import imagePath from "../constants/imagePath";
import {
  Automotive,
  EcommerceSlider,
  Education,
  Finance,
  Fintech,
  Government,
  HealthcareIcon,
  Logistics,
  MediaEntertainment2,
  OnDemand,
  RealEstate,
  Sports,
  TravelHospitality,
} from "../constants/svgPath";
import { ServicesDetailsMap } from "./interfaces";

export const servicesContent: ServicesDetailsMap = {
  "ios-app-development": {
    banner: {
      breadcrumb: "iOS App Development",
      title: "Crafting Premium",
      highlight: "iOS Mobile Experiences.",
      description:
        "We design and develop high-performance iOS applications that deliver seamless user experiences across iPhone, iPad, and Apple devices. Our solutions focus on intuitive design, secure architecture, and scalable performance to help businesses engage users and grow within the Apple ecosystem.",
      cta: "Build Your iOS App",

      backgroundImage: require("../assets/images/ios-app-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Successful iOS applications require more than clean interfaces. They demand strong architecture, smooth performance, and alignment with Apple’s design and security standards. We collaborate closely with founders, product teams, and stakeholders to transform ideas into polished iOS apps that are reliable, scalable, and optimized for long-term growth. Our development approach ensures efficient performance, secure data handling, and seamless compatibility across Apple devices and operating system updates.",
      milestones: [
        {
          counts: 5,
          description: "Years of iOS Development Expertise",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Long-Term",
          description: "Product Partnerships",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End iOS App Development",
      description:
        "Our iOS app development services cover the complete journey from product discovery and UI design to development, testing, App Store launch, and continuous improvement. We focus on building secure, scalable, and performance-driven applications that align with Apple’s ecosystem while delivering meaningful user experiences.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Product Discovery & Strategy",
          icon: "DiscoveryIcon",
          description:
            "We begin by understanding your business goals, target users, and feature priorities. This phase defines the product roadmap, technical approach, and scalability considerations to ensure your iOS app is built with clarity and direction.",
          bullets: [
            {
              title: "Requirement Analysis",
              text: "Defining features and user expectations.",
            },
            {
              title: "Roadmap Planning",
              text: "Aligning technical decisions with growth goals.",
            },
          ],
        },
        {
          title: "UI/UX Design for iOS",
          icon: "DesignIcon",
          description:
            "Our designers create intuitive, Apple-guideline-compliant interfaces that deliver smooth navigation and engaging interactions. Design decisions focus on clarity, consistency, and usability across different iOS devices.",
          bullets: [
            {
              title: "Human Interface Guidelines",
              text: "Following Apple’s design standards.",
            },
            {
              title: "User-Centered Layouts",
              text: "Clean, intuitive mobile experiences.",
            },
          ],
        },
        {
          title: "Native iOS Development",
          icon: "DevelopmentIcon",
          description:
            "We develop robust native iOS applications using modern technologies and clean coding practices. Development emphasizes performance optimization, data security, and maintainability for long-term reliability.",
          bullets: [
            {
              title: "Swift Development",
              text: "Modern and efficient native coding.",
            },
            {
              title: "Secure Architecture",
              text: "Protecting user data and transactions.",
            },
          ],
        },
        {
          title: "Integration & Performance Optimization",
          icon: "IntegrationIcon",
          description:
            "We integrate APIs, payment gateways, analytics tools, and backend systems while optimizing app speed, responsiveness, and stability across devices.",
          bullets: [
            {
              title: "API Integration",
              text: "Seamless backend connectivity.",
            },
            {
              title: "Performance Tuning",
              text: "Ensuring smooth and fast interactions.",
            },
          ],
        },
        {
          title: "Testing, App Store Launch & Support",
          icon: "LaunchIcon",
          description:
            "Before release, we conduct detailed functional, usability, and performance testing. We also manage App Store submission and provide ongoing updates to keep your app optimized and compliant.",
          bullets: [
            {
              title: "Quality Assurance",
              text: "Testing across devices and scenarios.",
            },
            {
              title: "Continuous Updates",
              text: "Improvements after launch.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Deliver Exceptional Experiences On Apple Devices",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your iOS Application",
      title: "Our iOS App Development Process",
      description:
        "A structured process designed to deliver secure, scalable, and high-performing iOS applications.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding business objectives and user expectations.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Defining architecture, features, and timelines.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description:
            "Creating intuitive interfaces aligned with Apple standards.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building secure and scalable native functionality.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Validating performance, usability, and stability.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Optimization",
          description: "Publishing on the App Store and refining continuously.",
        },
      ],
    },

    customIndustries: {
      title: "iOS Applications Across Industries",
      description:
        "We build iOS applications tailored to diverse industries and business models.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "iOS applications designed to enhance engagement, reliability, and scalable growth.",
      slides: [
        {
          title: "Enhanced User Engagement",
          subTitle: "Premium User Experience",
          description:
            "Well-crafted iOS interfaces encourage higher retention and user satisfaction.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Swift & Native Frameworks", image: "" }],
        },
        {
          title: "Scalable Performance",
          subTitle: "Optimized Architecture",
          description:
            "Efficient development ensures smooth performance as your user base grows.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Apple SDKs", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We build iOS applications that combine technical precision with long-term product thinking.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Apple Ecosystem Expertise",
          text: "Deep understanding of Apple’s frameworks, tools, and design standards to deliver reliable native experiences.",
        },
        {
          title: "Performance-Oriented Engineering",
          text: "Optimized architecture ensures smooth operation and responsiveness across devices.",
        },
        {
          title: "Security-First Approach",
          text: "Strong data protection and secure coding practices are embedded throughout development.",
        },
        {
          title: "Long-Term Support",
          text: "We provide continuous updates and enhancements to keep your app competitive.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Businesses trust us to deliver high-quality iOS applications built for reliability and growth.",
      clientTestimonails: [
        {
          description:
            "The iOS app exceeded our expectations in performance and user experience, helping us reach a broader audience within the Apple ecosystem.",
          name: "Daniel R.",
          position: "Product Director",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern tools and frameworks chosen for performance, security, and scalability within the Apple ecosystem.",
      techList: [
        {
          name: "Programming",
          icon: "",
          lenguages: [
            { name: "Swift", icon: "" },
            { name: "Objective-C", icon: "" },
          ],
        },
        {
          name: "Frameworks",
          icon: "",
          lenguages: [
            { name: "UIKit", icon: "" },
            { name: "SwiftUI", icon: "" },
          ],
        },
        {
          name: "Tools",
          icon: "",
          lenguages: [
            { name: "Xcode", icon: "" },
            { name: "TestFlight", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about our iOS app development services.",
      questions: [
        {
          title: "Do you build native iOS applications?",
          description:
            "Yes, we specialize in native iOS app development using Swift and Apple frameworks.",
        },
        {
          title: "Can you handle App Store submission?",
          description:
            "Yes, we manage the complete App Store review and publishing process.",
        },
        {
          title: "Will the app follow Apple’s design guidelines?",
          description:
            "Absolutely, we design and develop apps aligned with Apple’s Human Interface Guidelines.",
        },
        {
          title: "Do you provide post-launch support?",
          description:
            "Yes, we offer continuous updates, optimization, and feature enhancements.",
        },
        {
          title: "Can the app scale as users grow?",
          description:
            "Yes, scalability and performance are core considerations in our development process.",
        },
      ],
    },
  },
  "ecommerce-website-development": {
    banner: {
      breadcrumb: "eCommerce Website Development",
      title: "Building Scalable",
      highlight: "Online Commerce Experiences.",
      description:
        "We design and develop high-performing eCommerce websites that help businesses sell efficiently, manage operations smoothly, and deliver seamless shopping experiences. Our solutions focus on usability, performance, and scalability to support long-term growth in competitive digital markets.",
      cta: "Start Selling Online",
      backgroundImage: require("../assets/images/ecommerce-website-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Successful eCommerce platforms require more than attractive storefronts, they demand reliable architecture, smooth user journeys, and operational flexibility. We work closely with business owners, marketing teams, and technical stakeholders to build eCommerce solutions that are easy to manage, optimized for conversions, and capable of scaling as product catalogs, traffic, and customer expectations continue to grow.",
      milestones: [
        {
          counts: 5,
          description: "Years of eCommerce Expertise",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Long-Term",
          description: "eCommerce Partnerships",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End eCommerce Website Development",
      description:
        "Our eCommerce website development services cover the complete journey from strategy and design to development, launch, and continuous optimization. We focus on building secure, scalable, and conversion-focused platforms that simplify product management, enhance customer experience, and integrate smoothly with payments, logistics, and business systems.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "eCommerce Strategy & Discovery",
          icon: "DiscoveryIcon",
          description:
            "We analyze your business model, target audience, and competitive landscape to define a clear eCommerce strategy. This phase ensures platform decisions, feature priorities, and user journeys are aligned with revenue goals and long-term growth plans.",
          bullets: [
            {
              title: "Business Analysis",
              text: "Understanding products, customers, and sales goals.",
            },
            {
              title: "Platform Planning",
              text: "Selecting the right eCommerce approach.",
            },
          ],
        },
        {
          title: "UX/UI Design & Customer Journey",
          icon: "DesignIcon",
          description:
            "Our designers create intuitive, conversion-focused interfaces that guide users smoothly from browsing to checkout. Design decisions focus on clarity, trust, and usability while ensuring the storefront reflects your brand identity.",
          bullets: [
            {
              title: "User-Centered Design",
              text: "Clear navigation and intuitive layouts.",
            },
            {
              title: "Conversion Optimization",
              text: "Designs that encourage purchases.",
            },
          ],
        },
        {
          title: "Custom eCommerce Development",
          icon: "DevelopmentIcon",
          description:
            "We develop robust eCommerce websites using modern technologies and clean architecture. Development emphasizes performance, security, and maintainability to support growing product catalogs and increasing traffic volumes.",
          bullets: [
            {
              title: "Scalable Architecture",
              text: "Built to handle growth and demand.",
            },
            {
              title: "Secure Implementation",
              text: "Protecting transactions and user data.",
            },
          ],
        },
        {
          title: "Integrations & Automation",
          icon: "IntegrationIcon",
          description:
            "We integrate essential tools such as payment gateways, shipping providers, inventory systems, and analytics platforms. Automation reduces manual effort and improves operational efficiency across order management and fulfillment.",
          bullets: [
            {
              title: "Payment & Shipping",
              text: "Multiple secure checkout options.",
            },
            {
              title: "Business Systems",
              text: "CRM, inventory, and analytics integration.",
            },
          ],
        },
        {
          title: "Testing, Launch & Optimization",
          icon: "LaunchIcon",
          description:
            "Before launch, we thoroughly test functionality, performance, and security. After release, we support ongoing optimization to improve conversions, performance, and user experience based on real customer behavior.",
          bullets: [
            {
              title: "Quality Assurance",
              text: "Testing across devices and scenarios.",
            },
            {
              title: "Continuous Improvement",
              text: "Data-driven optimization post-launch.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Turn Your Online Store Into a Growth Engine",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your eCommerce Website",
      title: "Our eCommerce Development Process",
      description:
        "A structured process designed to deliver reliable, scalable, and conversion-focused eCommerce platforms.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding business goals, customers, and product offerings.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description:
            "Defining platform architecture, features, and timelines.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating user journeys and storefront designs.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building secure, scalable eCommerce functionality.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Validating performance, usability, and security.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Optimization",
          description: "Launching the store and improving it continuously.",
        },
      ],
    },

    customIndustries: {
      title: "eCommerce Across Industries",
      description:
        "We build eCommerce platforms tailored to a wide range of industries and business models.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "eCommerce solutions designed to improve conversions, efficiency, and scalability.",
      slides: [
        {
          title: "Improved Conversions",
          subTitle: "Optimized User Journeys",
          description:
            "Well-designed shopping experiences reduce friction and increase completed purchases.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [
            { title: "Conversion Optimization Tools", image: "" },
          ],
        },
        {
          title: "Operational Efficiency",
          subTitle: "Streamlined Management",
          description:
            "Automation and integrations simplify inventory, orders, and reporting.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "eCommerce Platforms", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We build eCommerce websites that focus on growth, reliability, and long-term success.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Business-Focused",
          text: "Our eCommerce solutions are designed around real business goals, customer behavior, and revenue growth rather than generic templates.",
        },
        {
          title: "Scalable Engineering",
          text: "We build platforms that handle increasing traffic, products, and transactions without sacrificing performance.",
        },
        {
          title: "User-Centered",
          text: "Customer experience is prioritized to ensure smooth browsing, checkout, and post-purchase interactions.",
        },
        {
          title: "Experienced",
          text: "Our team has delivered and supported successful eCommerce platforms across industries and markets.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Businesses trust us to build reliable and scalable eCommerce platforms.",
      clientTestimonails: [
        {
          description:
            "The new eCommerce website significantly improved our conversions and made daily operations much easier.",
          name: "Laura P.",
          position: "eCommerce Manager",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern tools and platforms chosen for performance, security, and scalability.",
      techList: [
        {
          name: "Frontend",
          icon: "",
          lenguages: [
            { name: "React", icon: "" },
            { name: "Next.js", icon: "" },
          ],
        },
        {
          name: "Backend",
          icon: "",
          lenguages: [
            { name: "Node.js", icon: "" },
            { name: "PHP", icon: "" },
          ],
        },
        {
          name: "eCommerce Platforms",
          icon: "",
          lenguages: [
            { name: "Shopify", icon: "" },
            { name: "WooCommerce", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description:
        "Common questions about our eCommerce website development services.",
      questions: [
        {
          title: "Do you build custom eCommerce websites?",
          description:
            "Yes, we build both custom eCommerce solutions and platform-based stores.",
        },
        {
          title: "Will my store be mobile-friendly?",
          description:
            "Yes, all eCommerce websites we build are fully responsive and mobile-optimized.",
        },
        {
          title: "Can you integrate payment gateways?",
          description:
            "Absolutely, we integrate secure payment and checkout solutions.",
        },
        {
          title: "Do you support post-launch optimization?",
          description:
            "Yes, we provide ongoing optimization and performance improvements.",
        },
        {
          title: "Can the platform scale as my business grows?",
          description:
            "Yes, scalability is a core consideration in all our eCommerce projects.",
        },
      ],
    },
  },
  "ecommerce-app-development": {
    banner: {
      breadcrumb: "eCommerce App Development",
      title: "Creating Seamless Shopping Through",
      highlight: "Mobile Commerce Apps.",
      description:
        "We design and develop high-performing eCommerce mobile applications that deliver smooth shopping experiences, fast navigation, and secure transactions. Our apps help businesses connect with customers on mobile devices while supporting growth, engagement, and long-term scalability.",
      cta: "Build Your eCommerce App",
      backgroundImage: require("../assets/images/ecommerce-app-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Building successful eCommerce apps requires more than transferring a website to mobile screens. We work closely with business owners, product teams, and stakeholders to understand customer behavior, mobile usage patterns, and operational needs. Our approach focuses on performance, usability, and scalable architecture, ensuring eCommerce apps remain reliable, easy to manage, and adaptable as customer expectations, features, and transaction volumes continue to evolve.",
      milestones: [
        {
          counts: 5,
          description: "Years of Mobile Commerce Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Long-Term",
          description: "Mobile Commerce Partnerships",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End eCommerce App Development",
      description:
        "Our eCommerce app development services cover the complete mobile commerce lifecycle, from strategy and design to development, testing, and ongoing optimization. We focus on building secure, scalable, and user-friendly apps that simplify product discovery, improve checkout experiences, and integrate seamlessly with payment systems, logistics providers, and backend business tools.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Mobile Commerce Strategy & Discovery",
          icon: "DiscoveryIcon",
          description:
            "We analyze your business goals, customer journeys, and competitive landscape to define a clear mobile commerce strategy. This phase ensures feature prioritization, platform selection, and user flows are aligned with conversion objectives and long-term growth plans.",
          bullets: [
            {
              title: "User Behavior Analysis",
              text: "Understanding how customers shop on mobile.",
            },
            {
              title: "Platform Planning",
              text: "Defining iOS, Android, or cross-platform needs.",
            },
          ],
        },
        {
          title: "UX/UI Design for Mobile Shopping",
          icon: "DesignIcon",
          description:
            "Our designers craft intuitive, mobile-first interfaces that make browsing, searching, and purchasing effortless. Design decisions focus on clarity, speed, and trust while ensuring brand consistency across the entire shopping experience.",
          bullets: [
            {
              title: "Mobile-First Design",
              text: "Optimized layouts for smaller screens.",
            },
            {
              title: "Conversion-Focused UX",
              text: "Reducing friction throughout checkout.",
            },
          ],
        },
        {
          title: "Custom eCommerce App Development",
          icon: "DevelopmentIcon",
          description:
            "We build robust eCommerce applications using modern mobile technologies and clean architecture principles. Development emphasizes performance, security, and maintainability to support high traffic, frequent updates, and growing product catalogs.",
          bullets: [
            {
              title: "Scalable Architecture",
              text: "Built to support growth and peak demand.",
            },
            {
              title: "Secure Transactions",
              text: "Protecting payments and customer data.",
            },
          ],
        },
        {
          title: "Integrations & Mobile Features",
          icon: "IntegrationIcon",
          description:
            "We integrate essential mobile commerce features such as secure payments, shipping, inventory management, and push notifications. These integrations streamline operations and keep customers engaged throughout their shopping journey.",
          bullets: [
            {
              title: "Payment & Logistics",
              text: "Multiple payment and delivery options.",
            },
            {
              title: "Customer Engagement",
              text: "Notifications and personalized updates.",
            },
          ],
        },
        {
          title: "Testing, Launch & Continuous Optimization",
          icon: "LaunchIcon",
          description:
            "Before release, we thoroughly test the app for performance, usability, and security across devices. After launch, we support continuous optimization to improve conversions, stability, and customer satisfaction based on real usage data.",
          bullets: [
            {
              title: "Quality Assurance",
              text: "Testing across devices and scenarios.",
            },
            {
              title: "Ongoing Improvement",
              text: "Data-driven performance enhancements.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Turn Mobile Users Into Loyal Customers",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your eCommerce App",
      title: "Our eCommerce App Development Process",
      description:
        "A structured process designed to deliver secure, scalable, and conversion-focused eCommerce mobile applications.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding business goals, products, and mobile users.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description:
            "Defining features, platforms, and technical architecture.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating mobile-first shopping experiences.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building secure and scalable mobile commerce features.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Validating performance, usability, and security.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Optimization",
          description: "Releasing the app and improving it continuously.",
        },
      ],
    },

    customIndustries: {
      title: "eCommerce Apps Across Industries",
      description:
        "We build eCommerce mobile apps tailored to diverse industries and business models.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "Mobile commerce solutions designed to increase engagement, conversions, and operational efficiency.",
      slides: [
        {
          title: "Higher Engagement",
          subTitle: "Mobile-First Experiences",
          description:
            "Optimized mobile journeys encourage repeat usage and customer loyalty.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Mobile UX Frameworks", image: "" }],
        },
        {
          title: "Improved Sales Performance",
          subTitle: "Faster Checkout",
          description:
            "Streamlined purchasing flows reduce abandonment and increase conversions.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Payment Integrations", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We build eCommerce apps that focus on performance, growth, and long-term reliability.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Mobile Commerce Focused",
          text: "Our solutions are designed specifically for mobile shopping behavior and on-the-go purchasing habits.",
        },
        {
          title: "Scalable Engineering",
          text: "We build apps that handle growing users, products, and transaction volumes reliably.",
        },
        {
          title: "User-Centered Design",
          text: "Customer experience is prioritized to ensure smooth browsing and checkout journeys.",
        },
        {
          title: "Experienced",
          text: "Our team has delivered successful eCommerce mobile apps across industries and markets.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Businesses trust us to deliver reliable and high-performing eCommerce mobile apps.",
      clientTestimonails: [
        {
          description:
            "The eCommerce app significantly increased our mobile sales and improved customer engagement.",
          name: "David R.",
          position: "Digital Commerce Head",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern tools and platforms chosen for mobile performance, security, and scalability.",
      techList: [
        {
          name: "Mobile Development",
          icon: "",
          lenguages: [
            { name: "React Native", icon: "" },
            { name: "Flutter", icon: "" },
          ],
        },
        {
          name: "Backend & APIs",
          icon: "",
          lenguages: [
            { name: "Node.js", icon: "" },
            { name: "Firebase", icon: "" },
          ],
        },
        {
          name: "eCommerce Integrations",
          icon: "",
          lenguages: [
            { name: "Stripe", icon: "" },
            { name: "PayPal", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description:
        "Common questions about our eCommerce app development services.",
      questions: [
        {
          title: "Do you build native or cross-platform eCommerce apps?",
          description:
            "We build both native and cross-platform apps based on business needs.",
        },
        {
          title: "Can the app integrate with existing eCommerce systems?",
          description:
            "Yes, we integrate apps with existing platforms and backend systems.",
        },
        {
          title: "Is mobile payment security handled?",
          description:
            "Yes, we implement secure payment and data protection practices.",
        },
        {
          title: "Do you support post-launch enhancements?",
          description:
            "Yes, we provide ongoing optimization and feature updates.",
        },
        {
          title: "Can the app scale with business growth?",
          description:
            "Absolutely, scalability is a core part of our development approach.",
        },
      ],
    },
  },
  "magento-ecommerce-development": {
    banner: {
      breadcrumb: "Magento eCommerce Development",
      title: "Building Flexible And Scalable",
      highlight: "Magento Stores.",
      description:
        "We design and develop robust Magento eCommerce solutions that support complex product catalogs, advanced customization, and seamless customer experiences, helping businesses scale operations and manage online stores with confidence.",
      cta: "Build Your Magento Store",
      backgroundImage: require("../assets/images/magento-ecommerce-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Magento development requires a deep understanding of eCommerce architecture, performance optimization, and long-term maintainability. We work closely with business owners, product teams, and technical stakeholders to design Magento solutions that align with operational workflows, customer expectations, and growth plans. Our approach focuses on clean architecture, scalable customization, and reliable integrations to ensure your store remains stable, adaptable, and easy to manage as your business evolves.",
      milestones: [
        {
          counts: 5,
          description: "Years of Magento Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Long-Term",
          description: "eCommerce Support Engagements",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Magento Development",
      description:
        "Our Magento eCommerce development services cover the complete store lifecycle, from discovery and architecture planning to custom development, integrations, and ongoing optimization. We focus on building secure, high-performing Magento stores that handle complex requirements while remaining flexible for future enhancements, feature additions, and evolving business needs.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Magento Strategy & Architecture",
          icon: "StrategyIcon",
          description:
            "We begin by understanding business goals, product complexity, and operational workflows to define a scalable Magento architecture. This phase ensures the store structure, extensions, and customizations are aligned with long-term growth and performance expectations.",
          bullets: [
            {
              title: "Store Architecture",
              text: "Designing a scalable and maintainable foundation.",
            },
            {
              title: "Requirement Alignment",
              text: "Mapping business needs to Magento capabilities.",
            },
          ],
        },
        {
          title: "Custom Magento Development",
          icon: "DevelopmentIcon",
          description:
            "Our developers build custom Magento features, modules, and themes tailored to your business processes. Development focuses on clean code, performance optimization, and flexibility to support future updates and enhancements.",
          bullets: [
            {
              title: "Custom Modules",
              text: "Extending functionality beyond core features.",
            },
            {
              title: "Theme Customization",
              text: "Creating brand-aligned storefront experiences.",
            },
          ],
        },
        {
          title: "Magento Theme & UX Design",
          icon: "DesignIcon",
          description:
            "We design Magento storefronts that balance visual appeal with usability and conversion best practices. UX design focuses on clear navigation, intuitive product discovery, and smooth checkout experiences across devices.",
          bullets: [
            {
              title: "User-Centered Design",
              text: "Improving browsing and purchasing journeys.",
            },
            {
              title: "Responsive Layouts",
              text: "Optimized experiences across screen sizes.",
            },
          ],
        },
        {
          title: "Integrations & Extensions",
          icon: "IntegrationIcon",
          description:
            "We integrate Magento with payment gateways, shipping providers, ERP systems, CRM tools, and third-party extensions. Seamless integrations ensure efficient operations and consistent data flow across systems.",
          bullets: [
            {
              title: "Payment & Shipping",
              text: "Secure and flexible checkout options.",
            },
            {
              title: "Business Systems",
              text: "Connecting inventory, CRM, and analytics tools.",
            },
          ],
        },
        {
          title: "Performance, Security & Optimization",
          icon: "OptimizationIcon",
          description:
            "We optimize Magento stores for speed, stability, and security. This includes performance tuning, security hardening, and ongoing optimization to ensure reliable operation during traffic spikes and peak sales periods.",
          bullets: [
            {
              title: "Performance Tuning",
              text: "Improving load times and responsiveness.",
            },
            {
              title: "Security Best Practices",
              text: "Protecting customer and transaction data.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Power Your Online Store With Magento Flexibility",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your Magento Store",
      title: "Our Magento Development Process",
      description:
        "A structured development process designed to deliver reliable Magento stores without unnecessary complexity.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding business goals, product structure, and technical needs.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description:
            "Defining architecture, customizations, and integrations.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating storefront UX and visual design.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building custom Magento features and themes.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Validating functionality, performance, and security.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Support",
          description:
            "Deploying the store and providing ongoing optimization.",
        },
      ],
    },

    customIndustries: {
      title: "Magento Solutions Across Industries",
      description:
        "We build Magento eCommerce solutions for businesses with diverse products and operational needs.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "Magento solutions designed to support growth, flexibility, and operational efficiency.",
      slides: [
        {
          title: "Scalable Store Management",
          subTitle: "Built for Growth",
          description:
            "Magento stores scale smoothly as product catalogs and traffic increase.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Magento Architecture", image: "" }],
        },
        {
          title: "Operational Efficiency",
          subTitle: "Streamlined Processes",
          description:
            "Integrated systems improve inventory, order, and customer management.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "System Integrations", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver Magento development with a focus on stability, flexibility, and long-term success.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Magento Expertise",
          text: "Our team has hands-on experience building and maintaining complex Magento eCommerce solutions across industries.",
        },
        {
          title: "Scalable Engineering",
          text: "We design Magento stores that support growth without frequent rework or performance issues.",
        },
        {
          title: "Business-Focused",
          text: "Development decisions are guided by operational efficiency and business outcomes.",
        },
        {
          title: "Reliable Support",
          text: "We provide ongoing maintenance, optimization, and technical support post-launch.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Businesses trust us to build and manage reliable Magento eCommerce platforms.",
      clientTestimonails: [
        {
          description:
            "The Magento store was highly customized and handled our complex catalog smoothly.",
          name: "Deepak S.",
          position: "Ecommerce Manager",
        },
      ],
    },

    techStacks: {
      title: "Magento Technologies We Use",
      description:
        "Tools and technologies used to build secure and scalable Magento stores.",
      techList: [
        {
          name: "Magento Development",
          icon: "",
          lenguages: [
            { name: "Magento Open Source", icon: "" },
            { name: "Adobe Commerce", icon: "" },
          ],
        },
        {
          name: "Backend Technologies",
          icon: "",
          lenguages: [
            { name: "PHP", icon: "" },
            { name: "MySQL", icon: "" },
          ],
        },
        {
          name: "Frontend & Optimization",
          icon: "",
          lenguages: [
            { name: "HTML/CSS", icon: "" },
            { name: "JavaScript", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description:
        "Common questions about Magento eCommerce development services.",
      questions: [
        {
          title: "Do you build custom Magento stores?",
          description:
            "Yes, we build fully customized Magento solutions based on business needs.",
        },
        {
          title: "Can you migrate existing stores to Magento?",
          description:
            "Yes, we handle Magento migrations from other platforms.",
        },
        {
          title: "Is Magento suitable for large catalogs?",
          description:
            "Yes, Magento is ideal for complex and large-scale catalogs.",
        },
        {
          title: "Do you provide Magento support after launch?",
          description:
            "Yes, we offer ongoing maintenance and optimization services.",
        },
        {
          title: "Can Magento integrate with ERP or CRM systems?",
          description:
            "Absolutely, Magento supports robust third-party integrations.",
        },
      ],
    },
  },
  "shopify-development-services": {
    banner: {
      breadcrumb: "Shopify Development Services",
      title: "Launching High-Converting Stores With",
      highlight: "Shopify Expertise.",
      description:
        "We design and develop scalable Shopify stores that combine clean design, fast performance, and seamless shopping experiences, enabling businesses to launch quickly, manage products easily, and grow sales with confidence.",
      cta: "Build Your Shopify Store",
      backgroundImage: require("../assets/images/shopify-development-services.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Shopify success depends on more than choosing a popular platform, it requires thoughtful store structure, conversion-focused design, and reliable customization. We work closely with business owners and marketing teams to understand products, audiences, and growth goals. Our approach focuses on creating Shopify stores that are easy to manage, optimized for conversions, and flexible enough to support evolving business strategies without unnecessary technical complexity.",
      milestones: [
        {
          counts: 5,
          description: "Years of Shopify Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Long-Term",
          description: "Store Support Partnerships",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Shopify Development",
      description:
        "Our Shopify development services cover the complete store lifecycle, from planning and theme customization to app integration and ongoing optimization. We focus on building fast, secure, and user-friendly Shopify stores that simplify operations, enhance customer experience, and support consistent growth across sales channels.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Shopify Store Strategy & Planning",
          icon: "StrategyIcon",
          description:
            "We begin by understanding your products, target audience, and business objectives to define a Shopify store strategy. This phase ensures the store structure, features, and integrations are aligned with conversion goals and long-term scalability.",
          bullets: [
            {
              title: "Business Alignment",
              text: "Mapping store features to growth objectives.",
            },
            {
              title: "Store Architecture",
              text: "Planning collections, navigation, and workflows.",
            },
          ],
        },
        {
          title: "Custom Theme Design & Development",
          icon: "DesignIcon",
          description:
            "Our designers and developers create custom Shopify themes or enhance existing ones to reflect your brand identity. Theme development focuses on usability, performance, and responsive design across devices.",
          bullets: [
            {
              title: "Brand-Focused Design",
              text: "Creating visually consistent storefronts.",
            },
            {
              title: "Responsive Experience",
              text: "Optimized layouts for mobile and desktop.",
            },
          ],
        },
        {
          title: "Shopify App Integration & Customization",
          icon: "IntegrationIcon",
          description:
            "We integrate and customize Shopify apps to extend store functionality without overloading the system. Integrations support payments, shipping, marketing, analytics, and inventory management.",
          bullets: [
            {
              title: "Third-Party Apps",
              text: "Selecting reliable and scalable solutions.",
            },
            {
              title: "Custom Enhancements",
              text: "Tailoring apps to specific workflows.",
            },
          ],
        },
        {
          title: "Performance & Conversion Optimization",
          icon: "OptimizationIcon",
          description:
            "We optimize store speed, navigation, and checkout flows to improve user experience and conversions. Performance tuning ensures reliable operation during high traffic and promotional campaigns.",
          bullets: [
            {
              title: "Speed Optimization",
              text: "Reducing load times and friction.",
            },
            {
              title: "Conversion Focus",
              text: "Improving product discovery and checkout.",
            },
          ],
        },
        {
          title: "Launch, Support & Growth Optimization",
          icon: "LaunchIcon",
          description:
            "We manage store launch, quality checks, and post-launch support. Ongoing optimization helps adapt the store to customer behavior, platform updates, and evolving business needs.",
          bullets: [
            {
              title: "Smooth Launch",
              text: "Ensuring stable go-live execution.",
            },
            {
              title: "Continuous Improvement",
              text: "Refining features based on performance data.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Turn Your Shopify Store Into a Sales Engine",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your Shopify Store",
      title: "Our Shopify Development Process",
      description:
        "A clear and efficient process designed to deliver reliable Shopify stores without unnecessary delays.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description: "Understanding products, audience, and business goals.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Defining store structure, features, and integrations.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating branded storefront layouts and experiences.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building themes, features, and customizations.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Validating performance, usability, and integrations.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Optimization",
          description: "Deploying the store and refining post-launch.",
        },
      ],
    },

    customIndustries: {
      title: "Shopify Solutions Across Industries",
      description:
        "We build Shopify stores for businesses across diverse product categories and markets.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "Shopify solutions designed to improve conversions, performance, and operational efficiency.",
      slides: [
        {
          title: "Faster Time to Market",
          subTitle: "Quick Launch",
          description:
            "Shopify enables rapid store deployment without sacrificing quality.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Shopify Platform", image: "" }],
        },
        {
          title: "Improved Conversions",
          subTitle: "Optimized Experience",
          description:
            "Clean design and optimized flows improve purchase completion rates.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [
            { title: "Conversion Optimization Tools", image: "" },
          ],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver Shopify development with clarity, speed, and business focus.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Shopify Specialists",
          text: "Our team has hands-on experience delivering Shopify stores across industries and complexity levels.",
        },
        {
          title: "Conversion-Focused",
          text: "Every design and development decision supports usability and sales performance.",
        },
        {
          title: "Scalable Solutions",
          text: "Stores are built to support future growth, integrations, and feature expansion.",
        },
        {
          title: "Reliable Support",
          text: "We provide ongoing maintenance, updates, and performance optimization.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Businesses trust us to build and grow reliable Shopify stores.",
      clientTestimonails: [
        {
          description:
            "Our Shopify store launched quickly and performed exceptionally well during campaigns.",
          name: "Sneha P.",
          position: "Ecommerce Lead",
        },
      ],
    },

    techStacks: {
      title: "Shopify Technologies We Use",
      description:
        "Tools and technologies used to build and optimize Shopify stores.",
      techList: [
        {
          name: "Shopify Platform",
          icon: "",
          lenguages: [
            { name: "Shopify", icon: "" },
            { name: "Liquid", icon: "" },
          ],
        },
        {
          name: "Frontend Technologies",
          icon: "",
          lenguages: [
            { name: "HTML/CSS", icon: "" },
            { name: "JavaScript", icon: "" },
          ],
        },
        {
          name: "Integrations & Analytics",
          icon: "",
          lenguages: [
            { name: "Shopify Apps", icon: "" },
            { name: "Google Analytics", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about Shopify development services.",
      questions: [
        {
          title: "Do you build custom Shopify stores?",
          description:
            "Yes, we build custom and theme-based Shopify stores based on business needs.",
        },
        {
          title: "Can you migrate stores to Shopify?",
          description:
            "Yes, we handle migrations from other eCommerce platforms to Shopify.",
        },
        {
          title: "Do you integrate third-party apps?",
          description:
            "Yes, we integrate and customize Shopify apps as required.",
        },
        {
          title: "Is Shopify suitable for large stores?",
          description:
            "Yes, Shopify supports scaling for high-traffic and large product catalogs.",
        },
        {
          title: "Do you provide post-launch support?",
          description:
            "Yes, we offer ongoing support and optimization services.",
        },
      ],
    },
  },

  "devops-consulting": {
    banner: {
      breadcrumb: "DevOps Consulting",
      title: "Accelerating Delivery With",
      highlight: "DevOps Excellence.",
      description:
        "We help organizations streamline development and operations through DevOps best practices, enabling faster releases, higher reliability, and continuous improvement.",
      cta: "Optimize Your Delivery Pipeline",
      backgroundImage: require("../assets/images/devops-consulting.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "We work closely with your teams to break silos between development and operations, introducing structured DevOps practices that improve collaboration, reliability, and speed. Our consulting approach balances people, processes, and technology to ensure sustainable improvements rather than short-term fixes.",
      milestones: [
        {
          counts: 5,
          description: "Years of DevOps Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Long-Term",
          description: "Support Partnerships",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End DevOps Consulting",
      description:
        "Our DevOps consulting services cover the complete transformation journey, starting from understanding your current workflows to implementing automation, improving deployment reliability, and enabling continuous delivery. We focus on creating repeatable, scalable processes that align with your business goals and team culture.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "DevOps Readiness Assessment",
          icon: "",
          description:
            "We analyze your existing development, testing, and deployment practices to identify inefficiencies, risks, and improvement opportunities. This assessment forms a clear baseline and helps prioritize DevOps initiatives that deliver immediate and long-term value.",
          bullets: [
            {
              title: "Workflow Analysis",
              text: "Reviewing release cycles, handoffs, and dependencies.",
            },
            {
              title: "Risk Identification",
              text: "Highlighting areas that affect stability and delivery speed.",
            },
          ],
        },
        {
          title: "DevOps Strategy & Roadmap",
          icon: "",
          description:
            "Based on assessment insights, we define a tailored DevOps roadmap that aligns tools, processes, and responsibilities. This roadmap provides a phased, realistic plan for adoption without overwhelming teams or disrupting ongoing delivery.",
          bullets: [
            {
              title: "Clear Priorities",
              text: "Focused initiatives aligned with business objectives.",
            },
            {
              title: "Adoption Planning",
              text: "Gradual rollout to ensure team alignment.",
            },
          ],
        },
        {
          title: "CI/CD Pipeline Design",
          icon: "",
          description:
            "We design and implement automated CI/CD pipelines that support frequent, reliable releases. These pipelines reduce manual effort, enforce consistency, and help teams ship features faster while maintaining quality standards.",
          bullets: [
            {
              title: "Automated Testing",
              text: "Integrated testing to catch issues early.",
            },
            {
              title: "Repeatable Deployments",
              text: "Consistent releases across environments.",
            },
          ],
        },
        {
          title: "Infrastructure Automation",
          icon: "",
          description:
            "Our team introduces infrastructure automation to eliminate configuration drift and manual errors. Using infrastructure as code, we ensure environments are reproducible, version-controlled, and easier to manage as systems grow.",
          bullets: [
            {
              title: "Infrastructure as Code",
              text: "Versioned and auditable infrastructure definitions.",
            },
            {
              title: "Environment Consistency",
              text: "Reduced issues caused by mismatched setups.",
            },
          ],
        },
        {
          title: "Monitoring & Continuous Improvement",
          icon: "",
          description:
            "We implement monitoring, logging, and feedback loops that provide visibility into system health and delivery performance. These insights help teams proactively address issues and continuously refine processes over time.",
          bullets: [
            {
              title: "Performance Visibility",
              text: "Clear insights into system behavior.",
            },
            {
              title: "Ongoing Optimization",
              text: "Data-driven improvements and refinements.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Transform Delivery Speed and Reliability",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Improve Your DevOps Workflow",
      title: "Our DevOps Consulting Process",
      description:
        "A structured process designed to improve delivery efficiency while maintaining stability and team alignment.",
      setps: [
        {
          stepNumberImage: "",
          title: "Initial Discovery",
          description:
            "We engage with stakeholders to understand goals, challenges, and current delivery practices.",
        },
        {
          stepNumberImage: "",
          title: "Process Evaluation",
          description:
            "Existing workflows and tools are reviewed to identify inefficiencies and bottlenecks.",
        },
        {
          stepNumberImage: "",
          title: "Toolchain Review",
          description:
            "We assess current tools and identify gaps or integration opportunities.",
        },
        {
          stepNumberImage: "",
          title: "Solution Design",
          description:
            "Designing DevOps architecture, pipelines, and automation strategies.",
        },
        {
          stepNumberImage: "",
          title: "Implementation",
          description:
            "Implementing pipelines, automation, and monitoring solutions.",
        },
        {
          stepNumberImage: "",
          title: "Optimization & Enablement",
          description:
            "Refining processes, training teams, and supporting continuous improvement.",
        },
      ],
    },

    customIndustries: {
      title: "DevOps Across Industries",
      description:
        "Our DevOps consulting adapts to the needs of different industries and team structures.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Operational Impact",
      description:
        "DevOps consulting that creates measurable improvements in delivery speed, quality, and system reliability.",
      slides: [
        {
          title: "Faster Releases",
          subTitle: "Reduced Time-to-Market",
          description:
            "Automated pipelines enable teams to release features more frequently and with greater confidence.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "CI/CD Tools", image: "" }],
        },
        {
          title: "Improved Stability",
          subTitle: "Reliable Systems",
          description:
            "Monitoring and automation reduce deployment risks and unexpected outages.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Monitoring Platforms", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver DevOps consulting that balances speed, quality, and long-term sustainability.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Practical",
          text: "Our recommendations are grounded in real-world experience and tailored to fit your existing teams, tools, and delivery constraints without unnecessary complexity.",
        },
        {
          title: "Collaborative",
          text: "We work closely with developers, operations, and leadership to ensure alignment, shared ownership, and smooth adoption of DevOps practices.",
        },
        {
          title: "Automation-Focused",
          text: "Automation is introduced thoughtfully to reduce repetitive tasks, minimize errors, and free teams to focus on higher-value engineering work.",
        },
        {
          title: "Experienced",
          text: "Our consultants bring hands-on experience across diverse environments, helping teams avoid common pitfalls and adopt proven DevOps patterns.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Teams rely on us to guide their DevOps transformation with clarity and confidence.",
      clientTestimonails: [
        {
          description:
            "Their DevOps consulting helped us stabilize releases and significantly improve collaboration between teams.",
          name: "Anita K.",
          position: "Engineering Manager",
        },
      ],
    },

    techStacks: {
      title: "DevOps Tools & Technologies",
      description:
        "Reliable, industry-standard tools that support automation, visibility, and scalability.",
      techList: [
        {
          name: "CI/CD",
          icon: "",
          lenguages: [
            { name: "Jenkins", icon: "" },
            { name: "GitHub Actions", icon: "" },
          ],
        },
        {
          name: "Containers & Orchestration",
          icon: "",
          lenguages: [
            { name: "Docker", icon: "" },
            { name: "Kubernetes", icon: "" },
          ],
        },
        {
          name: "Infrastructure & Monitoring",
          icon: "",
          lenguages: [
            { name: "Terraform", icon: "" },
            { name: "Prometheus", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about our DevOps consulting services.",
      questions: [
        {
          title: "What does DevOps consulting include?",
          description:
            "Our consulting covers assessment, strategy, automation, CI/CD implementation, and ongoing optimization.",
        },
        {
          title: "Can you work with existing development teams?",
          description:
            "Yes, we collaborate closely with in-house teams to improve workflows and skills.",
        },
        {
          title: "Do you replace our current tools?",
          description:
            "Not necessarily. We evaluate and enhance your existing toolchain where possible.",
        },
        {
          title: "How long does DevOps adoption take?",
          description:
            "Timelines vary, but we focus on incremental improvements that deliver value early.",
        },
        {
          title: "Do you provide ongoing DevOps support?",
          description:
            "Yes, we offer continuous support, monitoring, and optimization services.",
        },
      ],
    },
  },
  "ci-cd-pipeline-development": {
    banner: {
      breadcrumb: "CI/CD Pipeline Development",
      title: "Automating Delivery With",
      highlight: "CI/CD Pipelines.",
      description:
        "We design and implement robust CI/CD pipelines that automate build, test, and deployment workflows, helping teams release software faster, more reliably, and with greater confidence across environments.",
      cta: "Build Your CI/CD Pipeline",
      backgroundImage: require("../assets/images/ci-cd-pipeline-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "We partner closely with engineering teams to design CI/CD pipelines that align with real development workflows rather than forcing rigid processes. Our approach emphasizes reliability, visibility, and incremental improvement, ensuring pipelines remain easy to maintain while supporting faster releases and consistent delivery outcomes.",
      milestones: [
        {
          counts: 5,
          description: "Years of Automation Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Ongoing",
          description: "Pipeline Optimization Engagements",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End CI/CD Pipeline Development",
      description:
        "Our CI/CD pipeline development services cover everything from understanding your existing delivery workflow to designing, implementing, and refining automated pipelines. We focus on building resilient, scalable pipelines that reduce manual effort, improve quality control, and adapt as your applications and teams evolve.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Pipeline Readiness Assessment",
          icon: "",
          description:
            "We review your current build, testing, and deployment practices to identify gaps, inefficiencies, and risks. This assessment establishes a clear baseline and helps define automation priorities that will deliver meaningful improvements to delivery speed and reliability.",
          bullets: [
            {
              title: "Workflow Review",
              text: "Analysis of existing build and deployment steps.",
            },
            {
              title: "Risk Identification",
              text: "Detecting manual steps that introduce errors.",
            },
          ],
        },
        {
          title: "CI/CD Architecture Design",
          icon: "ArchitectureIcon",
          description:
            "We design a CI/CD architecture tailored to your applications, environments, and release requirements. This includes defining stages, approvals, testing strategies, and deployment patterns that support consistency without slowing teams down.",
          bullets: [
            {
              title: "Pipeline Structure",
              text: "Well-defined stages from commit to production.",
            },
            {
              title: "Environment Strategy",
              text: "Clear promotion paths across environments.",
            },
          ],
        },
        {
          title: "Automated Build & Test Setup",
          icon: "BuildIcon",
          description:
            "Our team implements automated build and testing processes to ensure every change is validated consistently. This reduces regression risks, improves code quality, and gives teams fast feedback during development cycles.",
          bullets: [
            {
              title: "Continuous Integration",
              text: "Automated builds triggered on every change.",
            },
            {
              title: "Test Automation",
              text: "Integrated testing for early issue detection.",
            },
          ],
        },
        {
          title: "Deployment Automation",
          icon: "DeploymentIcon",
          description:
            "We automate deployments across environments using proven strategies that minimize downtime and risk. This ensures releases are repeatable, predictable, and easier to roll back when needed.",
          bullets: [
            {
              title: "Safe Deployments",
              text: "Controlled releases with rollback support.",
            },
            {
              title: "Consistency",
              text: "Identical deployments across environments.",
            },
          ],
        },
        {
          title: "Monitoring & Pipeline Optimization",
          icon: "MonitoringIcon",
          description:
            "We add monitoring and metrics to pipelines, providing visibility into build times, failure rates, and deployment health. These insights help teams continuously refine pipelines and improve overall delivery performance.",
          bullets: [
            {
              title: "Pipeline Metrics",
              text: "Visibility into performance and bottlenecks.",
            },
            {
              title: "Continuous Improvement",
              text: "Data-driven pipeline enhancements.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Deliver Faster With Confidence",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your CI/CD Pipeline",
      title: "Our CI/CD Development Process",
      description:
        "A structured, transparent process that improves automation while maintaining stability and team alignment.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding application architecture, environments, and release expectations.",
        },
        {
          stepNumberImage: "",
          title: "Workflow Mapping",
          description:
            "Mapping current development and deployment workflows in detail.",
        },
        {
          stepNumberImage: "",
          title: "Tool Evaluation",
          description:
            "Reviewing existing tools and identifying integration needs.",
        },
        {
          stepNumberImage: "",
          title: "Pipeline Design",
          description: "Designing CI/CD stages, triggers, and quality gates.",
        },
        {
          stepNumberImage: "",
          title: "Implementation",
          description: "Building and configuring automated pipelines.",
        },
        {
          stepNumberImage: "",
          title: "Review & Optimization",
          description:
            "Refining pipelines based on performance and team feedback.",
        },
      ],
    },

    customIndustries: {
      title: "CI/CD Across Industries",
      description:
        "Our CI/CD pipeline solutions support diverse industries and delivery models.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Delivery Impact",
      description:
        "CI/CD pipelines that deliver measurable improvements in speed, quality, and reliability.",
      slides: [
        {
          title: "Faster Releases",
          subTitle: "Automated Delivery",
          description:
            "Streamlined pipelines significantly reduce the time required to release new features and fixes.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "CI/CD Platforms", image: "" }],
        },
        {
          title: "Higher Quality",
          subTitle: "Consistent Validation",
          description:
            "Automated testing and checks catch issues early and improve overall software quality.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Test Automation Tools", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We build CI/CD pipelines that balance speed, safety, and long-term maintainability.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Reliable",
          text: "Our pipelines are designed to be stable, predictable, and resilient, reducing deployment failures and improving confidence during every release.",
        },
        {
          title: "Tailored",
          text: "Each pipeline is customized to match your applications, teams, and release practices rather than forcing generic templates.",
        },
        {
          title: "Automation-Driven",
          text: "We focus on meaningful automation that removes repetitive tasks and minimizes human error without overcomplicating workflows.",
        },
        {
          title: "Experienced",
          text: "Our team brings hands-on experience building CI/CD pipelines across varied environments, tools, and organizational scales.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Teams trust us to modernize and stabilize their delivery pipelines.",
      clientTestimonails: [
        {
          description:
            "Their CI/CD pipeline transformed our release process and eliminated many manual deployment issues.",
          name: "Rahul S.",
          position: "DevOps Lead",
        },
      ],
    },

    techStacks: {
      title: "CI/CD Tools & Technologies",
      description:
        "Proven tools that support automated, reliable delivery pipelines.",
      techList: [
        {
          name: "CI/CD Platforms",
          icon: "",
          lenguages: [
            { name: "Jenkins", icon: "" },
            { name: "GitHub Actions", icon: "" },
          ],
        },
        {
          name: "Containers & Deployment",
          icon: "",
          lenguages: [
            { name: "Docker", icon: "" },
            { name: "Kubernetes", icon: "" },
          ],
        },
        {
          name: "Infrastructure & Monitoring",
          icon: "",
          lenguages: [
            { name: "Terraform", icon: "" },
            { name: "Prometheus", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description:
        "Common questions about CI/CD pipeline development services.",
      questions: [
        {
          title: "What is included in CI/CD pipeline development?",
          description:
            "We design, implement, and optimize automated pipelines for build, test, and deployment workflows.",
        },
        {
          title: "Can you work with our existing tools?",
          description:
            "Yes, we integrate and improve your current CI/CD tools whenever possible.",
        },
        {
          title: "Do you support multiple environments?",
          description:
            "Yes, our pipelines support development, staging, and production environments.",
        },
        {
          title: "How long does pipeline implementation take?",
          description:
            "Timelines vary based on complexity, but we focus on delivering value incrementally.",
        },
        {
          title: "Do you offer ongoing pipeline optimization?",
          description:
            "Yes, we provide continuous monitoring and improvements to keep pipelines efficient.",
        },
      ],
    },
  },
  "infrastructure-as-code-iac": {
    banner: {
      breadcrumb: "Infrastructure as Code (IaC)",
      title: "Managing Infrastructure Through",
      highlight: "Code & Automation.",
      description:
        "We help organizations define, provision, and manage infrastructure using code-driven practices that improve consistency, reduce risk, and enable faster, more reliable environment creation across cloud and on-premise systems.",
      cta: "Automate Your Infrastructure",
      backgroundImage: require("../assets/images/infrastructure-as-code-iac.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "We work alongside your engineering and operations teams to replace manual infrastructure management with reliable, code-based workflows. Our Infrastructure as Code approach improves visibility, reduces configuration drift, and ensures environments remain predictable, auditable, and easy to evolve as business and technical needs change over time.",
      milestones: [
        {
          counts: 5,
          description: "Years of Infrastructure Automation",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Ongoing",
          description: "Infrastructure Management Engagements",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Infrastructure as Code Services",
      description:
        "Our Infrastructure as Code services support the full lifecycle of infrastructure automation, from assessing existing environments to designing, implementing, and maintaining reusable infrastructure definitions. We focus on building scalable, secure, and maintainable configurations that support long-term operational stability.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Infrastructure Assessment",
          icon: "",
          description:
            "We review your current infrastructure setup to understand dependencies, risks, and operational challenges. This assessment helps identify opportunities where Infrastructure as Code can improve consistency, security, and deployment speed across environments.",
          bullets: [
            {
              title: "Environment Review",
              text: "Evaluating existing infrastructure and configurations.",
            },
            {
              title: "Risk Analysis",
              text: "Identifying areas prone to manual errors.",
            },
          ],
        },
        {
          title: "IaC Strategy & Standards",
          icon: "",
          description:
            "We define Infrastructure as Code standards and conventions tailored to your organization. This includes folder structures, naming practices, and versioning strategies that ensure clarity, collaboration, and long-term maintainability.",
          bullets: [
            {
              title: "Coding Standards",
              text: "Clear conventions for readable infrastructure code.",
            },
            {
              title: "Version Control",
              text: "Infrastructure changes tracked and auditable.",
            },
          ],
        },
        {
          title: "Infrastructure Code Development",
          icon: "CodeIcon",
          description:
            "Our team develops reusable infrastructure modules that define networks, compute, storage, and security components. These definitions ensure environments can be created consistently and updated safely as requirements evolve.",
          bullets: [
            {
              title: "Reusable Modules",
              text: "Modular infrastructure definitions for flexibility.",
            },
            {
              title: "Consistency",
              text: "Identical setups across all environments.",
            },
          ],
        },
        {
          title: "Environment Provisioning & Testing",
          icon: "ProvisionIcon",
          description:
            "We provision environments using infrastructure code and validate configurations through automated checks. This ensures infrastructure behaves as expected before being used by applications or teams.",
          bullets: [
            {
              title: "Automated Provisioning",
              text: "Fast, repeatable environment creation.",
            },
            {
              title: "Validation",
              text: "Testing configurations for accuracy and safety.",
            },
          ],
        },
        {
          title: "Governance & Continuous Improvement",
          icon: "GovernanceIcon",
          description:
            "We introduce governance, review processes, and continuous improvement practices to keep infrastructure code secure, compliant, and aligned with evolving organizational standards and growth needs.",
          bullets: [
            {
              title: "Change Reviews",
              text: "Controlled updates through code reviews.",
            },
            {
              title: "Ongoing Optimization",
              text: "Continuous refinement as systems scale.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Build Stable Infrastructure With Code",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Automate Your Infrastructure",
      title: "Our Infrastructure as Code Process",
      description:
        "A structured process that replaces manual infrastructure changes with controlled, repeatable automation.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding current infrastructure, tooling, and operational challenges.",
        },
        {
          stepNumberImage: "",
          title: "Requirements Definition",
          description:
            "Defining infrastructure needs, environments, and constraints.",
        },
        {
          stepNumberImage: "",
          title: "Design Planning",
          description:
            "Designing modular and scalable infrastructure code structures.",
        },
        {
          stepNumberImage: "",
          title: "Code Implementation",
          description:
            "Writing and organizing infrastructure definitions and modules.",
        },
        {
          stepNumberImage: "",
          title: "Provisioning & Validation",
          description:
            "Provisioning environments and validating configurations.",
        },
        {
          stepNumberImage: "",
          title: "Review & Optimization",
          description: "Refining code, processes, and governance over time.",
        },
      ],
    },

    customIndustries: {
      title: "Infrastructure as Code Across Industries",
      description:
        "Our IaC solutions support diverse industries with varying infrastructure complexity.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Operational Impact",
      description:
        "Infrastructure as Code delivers measurable improvements in stability, speed, and governance.",
      slides: [
        {
          title: "Consistent Environments",
          subTitle: "Reduced Drift",
          description:
            "Code-defined infrastructure ensures environments remain predictable and aligned.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "IaC Frameworks", image: "" }],
        },
        {
          title: "Faster Provisioning",
          subTitle: "Improved Agility",
          description:
            "Automated provisioning dramatically reduces setup time for new environments.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Automation Tools", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We implement Infrastructure as Code with a focus on reliability, clarity, and long-term sustainability.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Structured",
          text: "Our approach emphasizes clean, well-organized infrastructure code that is easy for teams to understand, review, and maintain over time.",
        },
        {
          title: "Secure",
          text: "Security and access controls are embedded into infrastructure definitions rather than added later as an afterthought.",
        },
        {
          title: "Scalable",
          text: "We design infrastructure code that scales gracefully as workloads, environments, and teams grow.",
        },
        {
          title: "Experienced",
          text: "Our team brings hands-on experience managing complex infrastructure using modern Infrastructure as Code practices.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Teams rely on us to bring structure and reliability to their infrastructure management.",
      clientTestimonails: [
        {
          description:
            "Moving to Infrastructure as Code helped us eliminate configuration issues and speed up environment setup.",
          name: "Michael T.",
          position: "Platform Engineer",
        },
      ],
    },

    techStacks: {
      title: "Infrastructure as Code Tools",
      description:
        "Industry-proven tools used to define, provision, and manage infrastructure through code.",
      techList: [
        {
          name: "IaC Frameworks",
          icon: "",
          lenguages: [
            { name: "Terraform", icon: "" },
            { name: "Pulumi", icon: "" },
          ],
        },
        {
          name: "Configuration Management",
          icon: "",
          lenguages: [
            { name: "Ansible", icon: "" },
            { name: "Chef", icon: "" },
          ],
        },
        {
          name: "Cloud Platforms",
          icon: "",
          lenguages: [
            { name: "AWS", icon: "" },
            { name: "Azure", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about Infrastructure as Code services.",
      questions: [
        {
          title: "What is Infrastructure as Code?",
          description:
            "Infrastructure as Code is the practice of managing infrastructure using version-controlled code instead of manual processes.",
        },
        {
          title: "Can IaC work with existing infrastructure?",
          description:
            "Yes, existing environments can be gradually brought under Infrastructure as Code management.",
        },
        {
          title: "Is Infrastructure as Code secure?",
          description:
            "When implemented correctly, IaC improves security through consistency and reviewable changes.",
        },
        {
          title: "Which tools do you use for IaC?",
          description:
            "We work with tools like Terraform, Pulumi, and configuration management platforms.",
        },
        {
          title: "Do you provide ongoing IaC support?",
          description:
            "Yes, we offer ongoing support, optimization, and governance for infrastructure code.",
        },
      ],
    },
  },
  "cloud-migration-management": {
    banner: {
      breadcrumb: "Cloud Migration & Management",
      title: "Moving Systems Securely To",
      highlight: "The Cloud.",
      description:
        "We help organizations migrate applications and infrastructure to the cloud with minimal disruption while establishing strong management practices that ensure performance, security, and long-term operational efficiency.",
      cta: "Plan Your Cloud Migration",
      backgroundImage: require("../assets/images/cloud-migration-management.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Cloud migration is more than a technical move, it is an operational transformation. We work closely with your teams to understand dependencies, risks, and business priorities before migration begins. Our approach ensures workloads are migrated safely, optimized for cloud environments, and continuously managed with visibility and control.",
      milestones: [
        {
          counts: 5,
          description: "Years of Cloud Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Long-Term",
          description: "Cloud Management Engagements",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Cloud Migration & Management",
      description:
        "Our cloud migration and management services support the entire journey, from assessing existing systems to executing migrations and providing ongoing optimization. We focus on reducing risk, avoiding downtime, and ensuring cloud environments remain cost-effective, secure, and aligned with business goals over time.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Cloud Readiness Assessment",
          icon: "",
          description:
            "We evaluate your applications, infrastructure, and dependencies to determine cloud readiness. This step identifies migration complexity, potential risks, and opportunities for modernization before any workloads are moved.",
          bullets: [
            {
              title: "Application Analysis",
              text: "Understanding dependencies and performance needs.",
            },
            {
              title: "Risk Identification",
              text: "Highlighting migration challenges early.",
            },
          ],
        },
        {
          title: "Migration Strategy & Planning",
          icon: "",
          description:
            "Based on assessment findings, we define a clear migration strategy that outlines timelines, priorities, and migration approaches. This plan ensures workloads are moved in a controlled and predictable manner.",
          bullets: [
            {
              title: "Phased Migration",
              text: "Reducing disruption through staged execution.",
            },
            {
              title: "Architecture Planning",
              text: "Designing cloud-native or hybrid models.",
            },
          ],
        },
        {
          title: "Application & Data Migration",
          icon: "MigrationIcon",
          description:
            "We migrate applications and data using proven techniques that preserve integrity and performance. Each migration is validated to ensure systems function correctly in their new cloud environment.",
          bullets: [
            {
              title: "Secure Transfers",
              text: "Protecting data throughout migration.",
            },
            {
              title: "Validation Testing",
              text: "Ensuring systems behave as expected.",
            },
          ],
        },
        {
          title: "Cloud Optimization",
          icon: "OptimizationIcon",
          description:
            "After migration, we optimize cloud resources to improve performance and control costs. This includes right-sizing resources and applying cloud best practices for efficiency.",
          bullets: [
            {
              title: "Cost Management",
              text: "Reducing unnecessary cloud spend.",
            },
            {
              title: "Performance Tuning",
              text: "Improving responsiveness and reliability.",
            },
          ],
        },
        {
          title: "Ongoing Cloud Management",
          icon: "ManagementIcon",
          description:
            "We provide continuous monitoring, maintenance, and governance to keep cloud environments stable and secure. This ensures your systems remain healthy as usage and business needs evolve.",
          bullets: [
            {
              title: "Monitoring & Alerts",
              text: "Proactive visibility into system health.",
            },
            {
              title: "Operational Support",
              text: "Ongoing management and improvements.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Operate With Confidence In The Cloud",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Start Your Cloud Journey",
      title: "Our Cloud Migration Process",
      description:
        "A structured process designed to move systems safely while maintaining stability and performance.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding existing systems, dependencies, and business objectives.",
        },
        {
          stepNumberImage: "",
          title: "Assessment",
          description: "Evaluating readiness, risks, and migration complexity.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description:
            "Defining migration phases, priorities, and architecture.",
        },
        {
          stepNumberImage: "",
          title: "Migration Execution",
          description: "Moving applications and data to the cloud environment.",
        },
        {
          stepNumberImage: "",
          title: "Validation",
          description:
            "Testing systems to ensure functionality and performance.",
        },
        {
          stepNumberImage: "",
          title: "Management & Optimization",
          description: "Ongoing monitoring, cost control, and improvements.",
        },
      ],
    },

    customIndustries: {
      title: "Cloud Migration Across Industries",
      description:
        "We support cloud migration and management for organizations across multiple sectors.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "Cloud migration and management that deliver stability, scalability, and cost control.",
      slides: [
        {
          title: "Improved Scalability",
          subTitle: "Elastic Infrastructure",
          description:
            "Cloud environments scale efficiently to match changing workloads.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Cloud Platforms", image: "" }],
        },
        {
          title: "Operational Efficiency",
          subTitle: "Optimized Operations",
          description:
            "Managed cloud systems reduce operational overhead and manual effort.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Cloud Management Tools", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver cloud migrations that prioritize reliability, clarity, and long-term success.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Careful Planning",
          text: "Every migration is planned in detail to reduce risk, avoid downtime, and protect critical business operations.",
        },
        {
          title: "Secure Execution",
          text: "Security best practices are applied throughout migration and ongoing cloud operations to protect data and systems.",
        },
        {
          title: "Cost-Aware",
          text: "We design and manage cloud environments with cost visibility and optimization in mind from day one.",
        },
        {
          title: "Experienced",
          text: "Our team brings hands-on experience managing complex cloud migrations across diverse environments and industries.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Organizations trust us to move and manage their systems in the cloud.",
      clientTestimonails: [
        {
          description:
            "The migration was smooth, and ongoing management helped us control costs while improving performance.",
          name: "Laura P.",
          position: "IT Director",
        },
      ],
    },

    techStacks: {
      title: "Cloud Platforms & Tools",
      description:
        "Reliable technologies used to migrate, manage, and optimize cloud environments.",
      techList: [
        {
          name: "Cloud Platforms",
          icon: "",
          lenguages: [
            { name: "AWS", icon: "" },
            { name: "Azure", icon: "" },
          ],
        },
        {
          name: "Migration Tools",
          icon: "",
          lenguages: [
            { name: "CloudEndure", icon: "" },
            { name: "Azure Migrate", icon: "" },
          ],
        },
        {
          name: "Monitoring & Management",
          icon: "",
          lenguages: [
            { name: "CloudWatch", icon: "" },
            { name: "Grafana", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description:
        "Common questions about cloud migration and management services.",
      questions: [
        {
          title: "Can you migrate legacy systems to the cloud?",
          description:
            "Yes, we migrate legacy systems using approaches that balance modernization and stability.",
        },
        {
          title: "Will migration cause downtime?",
          description:
            "We plan migrations carefully to minimize or avoid downtime wherever possible.",
        },
        {
          title: "Do you manage cloud environments after migration?",
          description:
            "Yes, we provide ongoing monitoring, optimization, and support services.",
        },
        {
          title: "Which cloud platforms do you support?",
          description:
            "We work with major platforms including AWS and Microsoft Azure.",
        },
        {
          title: "Can you optimize existing cloud environments?",
          description:
            "Yes, we assess and optimize existing cloud setups for performance and cost efficiency.",
        },
      ],
    },
  },
  "containerization-orchestration": {
    banner: {
      breadcrumb: "Containerization & Orchestration",
      title: "Scaling Applications With",
      highlight: "Containers & Control.",
      description:
        "We help organizations package, deploy, and manage applications using containerization and orchestration technologies that improve portability, scalability, and operational consistency across modern infrastructure environments.",
      cta: "Containerize Your Applications",
      backgroundImage: require("../assets/images/containerization-orchestration.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Containerization and orchestration require more than tooling knowledge, they demand a clear operational mindset. We work closely with your teams to design container strategies that fit real workloads, improve reliability, and simplify deployments. Our approach ensures applications remain portable, scalable, and manageable as systems and teams continue to grow.",
      milestones: [
        {
          counts: 5,
          description: "Years of Container Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Ongoing",
          description: "Platform Support Engagements",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Containerization & Orchestration",
      description:
        "Our containerization and orchestration services support the full lifecycle, from assessing application readiness to building container platforms and managing orchestration environments. We focus on creating stable, secure, and scalable systems that simplify deployments while supporting continuous delivery and operational visibility.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Application Container Readiness",
          icon: "",
          description:
            "We analyze your applications to determine container suitability, dependencies, and runtime requirements. This step helps identify refactoring needs and ensures applications are prepared for efficient container-based deployment.",
          bullets: [
            {
              title: "Dependency Review",
              text: "Identifying runtime and service dependencies.",
            },
            {
              title: "Compatibility Check",
              text: "Validating container execution feasibility.",
            },
          ],
        },
        {
          title: "Container Image Design",
          icon: "ContainerIcon",
          description:
            "Our team designs lightweight, secure container images using best practices. These images are optimized for performance, maintainability, and consistency across development, testing, and production environments.",
          bullets: [
            {
              title: "Optimized Images",
              text: "Reducing size and attack surface.",
            },
            {
              title: "Standardization",
              text: "Consistent images across environments.",
            },
          ],
        },
        {
          title: "Orchestration Platform Setup",
          icon: "OrchestrationIcon",
          description:
            "We design and configure orchestration platforms to manage containerized workloads at scale. This includes defining clusters, networking, and scheduling strategies that ensure reliability and efficient resource usage.",
          bullets: [
            {
              title: "Cluster Design",
              text: "Scalable and resilient cluster architecture.",
            },
            {
              title: "Networking Setup",
              text: "Secure and reliable service communication.",
            },
          ],
        },
        {
          title: "Deployment & Scaling Automation",
          icon: "AutomationIcon",
          description:
            "We automate container deployments and scaling policies to ensure applications respond smoothly to demand changes. This reduces manual intervention while maintaining consistent performance and availability.",
          bullets: [
            {
              title: "Automated Deployments",
              text: "Repeatable and predictable releases.",
            },
            {
              title: "Auto Scaling",
              text: "Dynamic resource adjustment based on load.",
            },
          ],
        },
        {
          title: "Monitoring & Platform Optimization",
          icon: "MonitoringIcon",
          description:
            "We implement monitoring, logging, and optimization practices that provide visibility into container health and platform performance. These insights support proactive issue resolution and continuous operational improvement.",
          bullets: [
            {
              title: "Operational Visibility",
              text: "Clear insight into workloads and resources.",
            },
            {
              title: "Continuous Refinement",
              text: "Ongoing tuning for stability and efficiency.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Run Applications Anywhere With Confidence",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your Container Platform",
      title: "Our Containerization Process",
      description:
        "A structured approach that introduces containers and orchestration without disrupting existing delivery workflows.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding application architecture, dependencies, and operational goals.",
        },
        {
          stepNumberImage: "",
          title: "Assessment",
          description:
            "Evaluating container readiness and platform requirements.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description:
            "Designing container images and orchestration architecture.",
        },
        {
          stepNumberImage: "",
          title: "Implementation",
          description:
            "Building container images and configuring orchestration platforms.",
        },
        {
          stepNumberImage: "",
          title: "Deployment",
          description:
            "Deploying applications into containerized environments.",
        },
        {
          stepNumberImage: "",
          title: "Optimization & Support",
          description:
            "Monitoring, tuning, and supporting container platforms over time.",
        },
      ],
    },

    customIndustries: {
      title: "Containerization Across Industries",
      description:
        "We support container-based platforms across a wide range of industries and workloads.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Operational Impact",
      description:
        "Containerization and orchestration improve scalability, portability, and operational efficiency.",
      slides: [
        {
          title: "Improved Scalability",
          subTitle: "Elastic Workloads",
          description:
            "Applications scale smoothly based on demand without manual intervention.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Orchestration Platforms", image: "" }],
        },
        {
          title: "Consistent Deployments",
          subTitle: "Portable Applications",
          description:
            "Containerized applications run consistently across environments.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Container Runtimes", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We implement container platforms that balance flexibility, reliability, and operational clarity.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Thoughtful Design",
          text: "Our container solutions are designed with careful consideration of application behavior, operational needs, and long-term platform sustainability.",
        },
        {
          title: "Security-Focused",
          text: "We embed security best practices into container images, networking, and access controls from the very beginning.",
        },
        {
          title: "Scalable",
          text: "Our orchestration setups are built to scale reliably as workloads, teams, and usage patterns evolve.",
        },
        {
          title: "Experienced",
          text: "Our team brings hands-on experience managing container platforms in complex, production-grade environments.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Teams trust us to modernize application delivery using containers and orchestration.",
      clientTestimonails: [
        {
          description:
            "Containerization simplified our deployments and gave us far better control over scaling and reliability.",
          name: "Daniel R.",
          position: "Platform Lead",
        },
      ],
    },

    techStacks: {
      title: "Container & Orchestration Tools",
      description:
        "Industry-standard technologies used to build and manage container platforms.",
      techList: [
        {
          name: "Containerization",
          icon: "",
          lenguages: [
            { name: "Docker", icon: "" },
            { name: "Containerd", icon: "" },
          ],
        },
        {
          name: "Orchestration",
          icon: "",
          lenguages: [
            { name: "Kubernetes", icon: "" },
            { name: "Helm", icon: "" },
          ],
        },
        {
          name: "Monitoring & Logging",
          icon: "",
          lenguages: [
            { name: "Prometheus", icon: "" },
            { name: "Grafana", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description:
        "Common questions about containerization and orchestration services.",
      questions: [
        {
          title: "What applications are suitable for containerization?",
          description:
            "Most modern and many legacy applications can be containerized with the right preparation and adjustments.",
        },
        {
          title: "Do you work with Kubernetes?",
          description:
            "Yes, we design and manage Kubernetes-based orchestration platforms.",
        },
        {
          title: "Can containers run on multiple cloud providers?",
          description:
            "Yes, containers enable portability across cloud and on-premise environments.",
        },
        {
          title: "How do you handle container security?",
          description:
            "We apply security best practices across images, networks, and access controls.",
        },
        {
          title: "Do you provide ongoing platform support?",
          description:
            "Yes, we offer continuous monitoring, optimization, and operational support.",
        },
      ],
    },
  },
  "microservices-architecture-setup": {
    banner: {
      breadcrumb: "Microservices Architecture Setup",
      title: "Designing Flexible Systems With",
      highlight: "Microservices Architecture.",
      description:
        "We help organizations design and implement microservices architectures that improve scalability, resilience, and development agility, enabling teams to build, deploy, and evolve applications independently with confidence.",
      cta: "Adopt Microservices Architecture",
      backgroundImage: require("../assets/images/microservices-architecture-setup.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Adopting microservices is a strategic shift that impacts architecture, workflows, and team collaboration. We work closely with your engineering teams to design service boundaries, communication patterns, and operational practices that reduce complexity while supporting long-term scalability, resilience, and independent service evolution.",
      milestones: [
        {
          counts: 5,
          description: "Years of Architecture Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Ongoing",
          description: "Architecture Advisory Engagements",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Microservices Architecture Setup",
      description:
        "Our microservices architecture services guide you through the complete transition, from assessing monolithic systems to designing service boundaries and implementing operational tooling. We focus on building architectures that are scalable, observable, and maintainable while minimizing operational overhead and future rework.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Architecture Assessment",
          icon: "",
          description:
            "We analyze your existing application architecture to understand coupling, dependencies, and performance constraints. This assessment helps determine whether microservices are suitable and identifies areas that benefit most from service decomposition.",
          bullets: [
            {
              title: "System Analysis",
              text: "Understanding dependencies and data flows.",
            },
            {
              title: "Complexity Review",
              text: "Identifying tightly coupled components.",
            },
          ],
        },
        {
          title: "Service Decomposition Strategy",
          icon: "",
          description:
            "Based on domain and business logic, we define clear service boundaries and responsibilities. This strategy reduces cross-service dependencies and enables teams to develop, deploy, and scale services independently.",
          bullets: [
            {
              title: "Domain Modeling",
              text: "Defining services around business capabilities.",
            },
            {
              title: "Boundary Clarity",
              text: "Reducing shared logic and tight coupling.",
            },
          ],
        },
        {
          title: "Communication & Integration Design",
          icon: "IntegrationIcon",
          description:
            "We design reliable communication patterns between services, including synchronous and asynchronous interactions. This ensures data consistency, fault tolerance, and predictable behavior across distributed systems.",
          bullets: [
            {
              title: "API Design",
              text: "Well-defined contracts between services.",
            },
            {
              title: "Event-Driven Patterns",
              text: "Loose coupling through asynchronous messaging.",
            },
          ],
        },
        {
          title: "Infrastructure & Deployment Setup",
          icon: "InfrastructureIcon",
          description:
            "Our team designs infrastructure and deployment models that support microservices at scale. This includes containerization, orchestration, and deployment strategies that ensure reliability and efficient resource usage.",
          bullets: [
            {
              title: "Container Deployment",
              text: "Independent deployment of services.",
            },
            {
              title: "Scalable Platforms",
              text: "Infrastructure built for growth.",
            },
          ],
        },
        {
          title: "Observability & Resilience Practices",
          icon: "MonitoringIcon",
          description:
            "We implement monitoring, logging, and resilience patterns that provide visibility into service behavior. These practices help teams quickly detect issues, understand system health, and improve reliability over time.",
          bullets: [
            {
              title: "Centralized Monitoring",
              text: "Clear visibility across all services.",
            },
            {
              title: "Fault Tolerance",
              text: "Designing systems that handle failures gracefully.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Build Systems That Evolve With Your Business",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Design Your Microservices",
      title: "Our Microservices Architecture Process",
      description:
        "A structured process that introduces microservices thoughtfully while maintaining system stability.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding business domains, system goals, and technical constraints.",
        },
        {
          stepNumberImage: "",
          title: "Assessment",
          description:
            "Evaluating existing architecture and readiness for microservices.",
        },
        {
          stepNumberImage: "",
          title: "Domain Modeling",
          description: "Identifying service boundaries and ownership models.",
        },
        {
          stepNumberImage: "",
          title: "Architecture Design",
          description:
            "Designing service interactions, data ownership, and deployment patterns.",
        },
        {
          stepNumberImage: "",
          title: "Implementation",
          description: "Building and deploying microservices incrementally.",
        },
        {
          stepNumberImage: "",
          title: "Optimization & Support",
          description:
            "Monitoring, refining, and supporting the architecture over time.",
        },
      ],
    },

    customIndustries: {
      title: "Microservices Across Industries",
      description:
        "We design microservices architectures for organizations across diverse industries.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Architectural Impact",
      description:
        "Microservices architectures enable scalability, resilience, and faster innovation.",
      slides: [
        {
          title: "Independent Scaling",
          subTitle: "Flexible Growth",
          description:
            "Services scale independently based on demand, improving efficiency and performance.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Service Platforms", image: "" }],
        },
        {
          title: "Improved Resilience",
          subTitle: "Fault Isolation",
          description:
            "Failures are isolated to individual services, reducing system-wide impact.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Resilience Patterns", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We design microservices architectures that balance flexibility with operational clarity.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Thoughtful Architecture",
          text: "We design service boundaries carefully to avoid unnecessary complexity while enabling independent development and deployment.",
        },
        {
          title: "Operational Focus",
          text: "Operational concerns such as monitoring, failure handling, and deployment are considered from the very beginning.",
        },
        {
          title: "Scalable Design",
          text: "Our architectures are built to scale smoothly as traffic, data, and teams grow over time.",
        },
        {
          title: "Experienced",
          text: "Our team brings hands-on experience designing and supporting production-grade microservices systems.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Teams trust us to guide them through successful microservices adoption.",
      clientTestimonails: [
        {
          description:
            "The microservices architecture improved our scalability and made our development teams far more independent.",
          name: "Sophia L.",
          position: "Engineering Director",
        },
      ],
    },

    techStacks: {
      title: "Microservices Technologies",
      description:
        "Modern tools and platforms used to build and operate microservices architectures.",
      techList: [
        {
          name: "Containers & Runtime",
          icon: "",
          lenguages: [
            { name: "Docker", icon: "" },
            { name: "Containerd", icon: "" },
          ],
        },
        {
          name: "Orchestration",
          icon: "",
          lenguages: [
            { name: "Kubernetes", icon: "" },
            { name: "Helm", icon: "" },
          ],
        },
        {
          name: "Communication & Observability",
          icon: "",
          lenguages: [
            { name: "Kafka", icon: "" },
            { name: "Prometheus", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about microservices architecture setup.",
      questions: [
        {
          title: "Is microservices architecture right for every project?",
          description:
            "Microservices are best suited for complex systems where scalability and independent deployments are important.",
        },
        {
          title: "Can you migrate monolithic systems to microservices?",
          description:
            "Yes, we help teams incrementally break down monoliths into manageable services.",
        },
        {
          title: "How do you manage communication between services?",
          description:
            "We design reliable APIs and event-driven patterns to handle service communication.",
        },
        {
          title: "Do microservices increase operational complexity?",
          description:
            "They can, which is why we focus on strong observability and automation practices.",
        },
        {
          title: "Do you provide ongoing architecture support?",
          description:
            "Yes, we offer continuous guidance, optimization, and support for microservices platforms.",
        },
      ],
    },
  },
  "site-reliability-engineering-sre": {
    banner: {
      breadcrumb: "Site Reliability Engineering (SRE)",
      title: "Ensuring Stability Through",
      highlight: "Reliability Engineering.",
      description:
        "We help organizations improve system reliability, performance, and availability by applying Site Reliability Engineering principles that balance operational excellence with rapid development and continuous innovation.",
      cta: "Improve System Reliability",
      backgroundImage: require("../assets/images/site-reliability-engineering-sre.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Site Reliability Engineering is about creating sustainable systems, not just reacting to incidents. We collaborate closely with development and operations teams to design reliability practices that reduce outages, improve visibility, and support long-term system health. Our approach blends engineering discipline with pragmatic processes that scale alongside growing products and user demands.",
      milestones: [
        {
          counts: 5,
          description: "Years of Reliability Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Continuous",
          description: "Reliability Improvement Programs",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Site Reliability Engineering",
      description:
        "Our SRE services support the complete reliability lifecycle, from assessing system risks to implementing automation, monitoring, and incident response practices. We focus on reducing operational toil, improving service availability, and ensuring reliability goals are clearly defined, measured, and continuously improved across teams.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Reliability Assessment",
          icon: "",
          description:
            "We evaluate system architecture, operational practices, and historical incidents to understand reliability risks. This assessment identifies recurring failure patterns and highlights areas where engineering improvements can significantly reduce outages and performance issues.",
          bullets: [
            {
              title: "Incident Review",
              text: "Analyzing past outages and root causes.",
            },
            {
              title: "Risk Identification",
              text: "Highlighting reliability gaps and weak points.",
            },
          ],
        },
        {
          title: "SLO & Error Budget Definition",
          icon: "",
          description:
            "We help define service level objectives and error budgets that align reliability targets with business priorities. These metrics provide clear guidance for balancing feature development and operational stability.",
          bullets: [
            {
              title: "Clear Objectives",
              text: "Measurable reliability goals for services.",
            },
            {
              title: "Balanced Delivery",
              text: "Data-driven trade-offs between speed and stability.",
            },
          ],
        },
        {
          title: "Monitoring & Observability",
          icon: "MonitoringIcon",
          description:
            "We implement comprehensive monitoring, logging, and alerting to provide real-time visibility into system health. Strong observability helps teams detect issues early and understand system behavior under load.",
          bullets: [
            {
              title: "Service Visibility",
              text: "Clear insights into performance and availability.",
            },
            {
              title: "Actionable Alerts",
              text: "Reducing noise while highlighting real issues.",
            },
          ],
        },
        {
          title: "Automation & Toil Reduction",
          icon: "AutomationIcon",
          description:
            "Our team introduces automation to eliminate repetitive operational tasks. Reducing toil allows engineers to focus on reliability improvements rather than manual maintenance and firefighting.",
          bullets: [
            {
              title: "Operational Automation",
              text: "Streamlining routine maintenance tasks.",
            },
            {
              title: "Efficiency Gains",
              text: "Freeing teams from manual interventions.",
            },
          ],
        },
        {
          title: "Incident Response & Improvement",
          icon: "IncidentIcon",
          description:
            "We design incident response processes that prioritize fast recovery and learning. Post-incident reviews focus on systemic improvements rather than blame, strengthening reliability over time.",
          bullets: [
            {
              title: "Clear Runbooks",
              text: "Guided responses during incidents.",
            },
            {
              title: "Postmortems",
              text: "Learning-driven improvement practices.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Build Trust Through Reliable Systems",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Improve Your Reliability",
      title: "Our SRE Engagement Process",
      description:
        "A structured process that introduces reliability practices while maintaining development velocity.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding system architecture, traffic patterns, and reliability goals.",
        },
        {
          stepNumberImage: "",
          title: "Assessment",
          description:
            "Evaluating operational risks, incidents, and existing monitoring.",
        },
        {
          stepNumberImage: "",
          title: "Goal Definition",
          description: "Defining service level objectives and error budgets.",
        },
        {
          stepNumberImage: "",
          title: "Implementation",
          description:
            "Introducing monitoring, automation, and reliability tooling.",
        },
        {
          stepNumberImage: "",
          title: "Incident Readiness",
          description: "Establishing response processes and on-call practices.",
        },
        {
          stepNumberImage: "",
          title: "Continuous Improvement",
          description:
            "Iterating on reliability practices based on data and feedback.",
        },
      ],
    },

    customIndustries: {
      title: "SRE Across Industries",
      description:
        "We apply Site Reliability Engineering practices across industries with demanding availability requirements.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Reliability Impact",
      description:
        "SRE practices deliver measurable improvements in uptime, performance, and operational efficiency.",
      slides: [
        {
          title: "Reduced Downtime",
          subTitle: "Higher Availability",
          description:
            "Proactive monitoring and automation significantly reduce service interruptions.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Observability Platforms", image: "" }],
        },
        {
          title: "Improved Performance",
          subTitle: "Stable Systems",
          description:
            "Performance bottlenecks are identified early and addressed systematically.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [
            { title: "Performance Monitoring Tools", image: "" },
          ],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We apply SRE principles with a balanced focus on engineering rigor and practical delivery.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Engineering-Driven",
          text: "Our reliability improvements are rooted in solid engineering practices rather than reactive operational fixes.",
        },
        {
          title: "Data-Informed",
          text: "Decisions are guided by metrics, service objectives, and real system behavior rather than assumptions.",
        },
        {
          title: "Automation-Focused",
          text: "We prioritize automation to reduce manual effort and minimize the risk of human error during operations.",
        },
        {
          title: "Experienced",
          text: "Our team brings hands-on experience running and stabilizing complex, high-traffic production systems.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Teams rely on us to improve reliability without slowing innovation.",
      clientTestimonails: [
        {
          description:
            "SRE practices introduced by the team significantly reduced outages and improved our response times.",
          name: "Kevin M.",
          position: "Head of Engineering",
        },
      ],
    },

    techStacks: {
      title: "SRE Tools & Technologies",
      description:
        "Proven tools used to monitor, automate, and improve system reliability.",
      techList: [
        {
          name: "Monitoring & Observability",
          icon: "",
          lenguages: [
            { name: "Prometheus", icon: "" },
            { name: "Grafana", icon: "" },
          ],
        },
        {
          name: "Incident Management",
          icon: "",
          lenguages: [
            { name: "PagerDuty", icon: "" },
            { name: "Opsgenie", icon: "" },
          ],
        },
        {
          name: "Automation & Platforms",
          icon: "",
          lenguages: [
            { name: "Terraform", icon: "" },
            { name: "Kubernetes", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description:
        "Common questions about Site Reliability Engineering services.",
      questions: [
        {
          title: "What is Site Reliability Engineering?",
          description:
            "SRE applies software engineering principles to improve system reliability and operations.",
        },
        {
          title: "How is SRE different from traditional operations?",
          description:
            "SRE focuses on automation, metrics, and engineering-driven reliability improvements.",
        },
        {
          title: "Do you define service level objectives?",
          description:
            "Yes, we help teams define and track meaningful SLOs and error budgets.",
        },
        {
          title: "Can SRE work with existing DevOps practices?",
          description:
            "Absolutely, SRE complements DevOps by adding reliability-focused structure.",
        },
        {
          title: "Do you provide ongoing SRE support?",
          description:
            "Yes, we offer continuous reliability improvement and advisory services.",
        },
      ],
    },
  },
  "mvp-development": {
    banner: {
      breadcrumb: "MVP Development",
      title: "Turning Ideas Into",
      highlight: "Market-Ready Products.",
      description:
        "We help startups and businesses build Minimum Viable Products that validate ideas quickly, reduce risk, and create a strong foundation for scalable product growth within modern product engineering practices.",
      cta: "Build Your MVP",
      backgroundImage: require("../assets/images/mvp-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "MVP development requires balancing speed with thoughtful engineering decisions. We collaborate closely with founders, product managers, and technical teams to shape ideas into focused products that solve real problems. Our approach emphasizes learning, rapid feedback, and smart prioritization so your MVP delivers value without unnecessary complexity or wasted effort.",
      milestones: [
        {
          counts: 5,
          description: "Years of Product Engineering Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Ongoing",
          description: "Product Growth Partnerships",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End MVP Development",
      description:
        "Our MVP development services cover the full product engineering lifecycle, from idea validation and feature definition to design, development, and launch. We focus on building lean, testable products that gather real user feedback early while remaining flexible enough to evolve as market needs become clearer.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Idea Validation & Discovery",
          icon: "DiscoveryIcon",
          description:
            "We work with stakeholders to validate the core problem, target users, and product assumptions. This phase helps confirm feasibility and ensures development effort is focused on features that deliver meaningful early value.",
          bullets: [
            {
              title: "Problem Definition",
              text: "Clarifying user pain points and goals.",
            },
            {
              title: "Market Insight",
              text: "Understanding audience needs and expectations.",
            },
          ],
        },
        {
          title: "MVP Scope & Feature Prioritization",
          icon: "",
          description:
            "We define a clear MVP scope by prioritizing essential features and removing unnecessary complexity. This ensures faster delivery while preserving the core experience required to test assumptions and attract early adopters.",
          bullets: [
            {
              title: "Lean Feature Set",
              text: "Focusing only on must-have functionality.",
            },
            {
              title: "Roadmap Clarity",
              text: "Separating MVP features from future enhancements.",
            },
          ],
        },
        {
          title: "UX/UI Design",
          icon: "DesignIcon",
          description:
            "Our designers create intuitive, user-centered interfaces that support usability and clarity. The goal is to deliver a polished experience without over-investing in design elements that are not critical at the MVP stage.",
          bullets: [
            {
              title: "User-Centered Design",
              text: "Interfaces built around real user flows.",
            },
            {
              title: "Rapid Iteration",
              text: "Designs that evolve with feedback.",
            },
          ],
        },
        {
          title: "MVP Development & Engineering",
          icon: "DevelopmentIcon",
          description:
            "We build the MVP using modern, scalable technologies while keeping the architecture lightweight. The implementation supports quick iterations, easy changes, and future expansion as the product gains traction.",
          bullets: [
            {
              title: "Clean Architecture",
              text: "Simple, maintainable engineering decisions.",
            },
            {
              title: "Agile Delivery",
              text: "Incremental releases with frequent reviews.",
            },
          ],
        },
        {
          title: "Testing, Launch & Feedback",
          icon: "LaunchIcon",
          description:
            "Before launch, we test the MVP for usability, stability, and core functionality. After release, we help gather and interpret user feedback to guide product improvements and next development phases.",
          bullets: [
            {
              title: "Validation Testing",
              text: "Ensuring reliability of key features.",
            },
            {
              title: "User Feedback",
              text: "Insights to inform future iterations.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Validate Ideas Faster With Confidence",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your MVP",
      title: "Our MVP Development Process",
      description:
        "A structured yet flexible process designed to deliver learning, speed, and clarity.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description: "Understanding the idea, users, and business goals.",
        },
        {
          stepNumberImage: "",
          title: "Validation",
          description: "Confirming assumptions and defining success criteria.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Finalizing MVP scope, features, and timelines.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating user flows and interface designs.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building the MVP using agile engineering practices.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Learn",
          description: "Releasing the product and collecting user insights.",
        },
      ],
    },

    customIndustries: {
      title: "MVP Development Across Industries",
      description:
        "We build MVPs for products across a wide range of industries and use cases.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Product Impact",
      description:
        "MVP development focused on learning, speed, and smart investment.",
      slides: [
        {
          title: "Faster Validation",
          subTitle: "Reduced Risk",
          description:
            "Early releases help validate ideas before large investments are made.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Rapid Prototyping Tools", image: "" }],
        },
        {
          title: "Clear Direction",
          subTitle: "Informed Decisions",
          description:
            "Real user feedback guides product direction and priorities.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [
            { title: "Analytics & Feedback Tools", image: "" },
          ],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We build MVPs that balance speed, usability, and future growth.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Product-Focused",
          text: "We think beyond features, focusing on solving the right problem and delivering meaningful value to early users.",
        },
        {
          title: "Lean Execution",
          text: "Our development approach avoids unnecessary complexity while maintaining quality and scalability.",
        },
        {
          title: "Collaborative",
          text: "We work closely with founders and teams to ensure alignment and transparency throughout the process.",
        },
        {
          title: "Experienced",
          text: "Our team has hands-on experience launching MVPs that successfully evolve into full-scale products.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description: "Founders trust us to turn ideas into validated products.",
      clientTestimonails: [
        {
          description:
            "The MVP helped us validate our idea quickly and secure early customer interest.",
          name: "Alex W.",
          position: "Startup Founder",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern, flexible tools that support rapid MVP development and iteration.",
      techList: [
        {
          name: "Frontend",
          icon: "",
          lenguages: [
            { name: "React", icon: "" },
            { name: "Next.js", icon: "" },
          ],
        },
        {
          name: "Backend",
          icon: "",
          lenguages: [
            { name: "Node.js", icon: "" },
            { name: "Python", icon: "" },
          ],
        },
        {
          name: "Cloud & DevOps",
          icon: "",
          lenguages: [
            { name: "AWS", icon: "" },
            { name: "Docker", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about MVP development services.",
      questions: [
        {
          title: "What is an MVP?",
          description:
            "An MVP is a minimal version of a product built to validate ideas and gather user feedback.",
        },
        {
          title: "How long does MVP development take?",
          description:
            "Timelines vary, but most MVPs are built within a few weeks to a few months.",
        },
        {
          title: "Can an MVP scale into a full product?",
          description: "Yes, we design MVPs with future scalability in mind.",
        },
        {
          title: "Do you help refine the product after launch?",
          description:
            "Yes, we support iteration and growth based on real user feedback.",
        },
        {
          title: "Do you work with non-technical founders?",
          description:
            "Absolutely, we guide non-technical founders through the entire product development journey.",
        },
      ],
    },
  },
  "product-design-prototyping": {
    banner: {
      breadcrumb: "Product Design & Prototyping",
      title: "Designing Experiences That",
      highlight: "Users Love.",
      description:
        "We help businesses transform ideas into intuitive, user-centered product designs through structured research, thoughtful UX/UI design, and rapid prototyping that reduces risk and accelerates confident product decisions.",
      cta: "Design Your Product",
      backgroundImage: require("../assets/images/product-design-prototyping.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Great product design is built on understanding users, not assumptions. We work closely with founders, product owners, and engineering teams to translate ideas into clear, usable designs. Our process combines research, creativity, and validation to ensure designs are practical, scalable, and aligned with real user needs rather than visual trends alone.",
      milestones: [
        {
          counts: 5,
          description: "Years of Design Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Ongoing",
          description: "Design-Led Product Partnerships",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Product Design & Prototyping",
      description:
        "Our product design and prototyping services support the full journey from early concepts to validated design solutions. We focus on clarity, usability, and fast learning by combining research, UX strategy, UI design, and interactive prototypes that help teams test ideas before committing to full development.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "User Research & Discovery",
          icon: "ResearchIcon",
          description:
            "We conduct research to understand users, business goals, and problem space. This phase uncovers user motivations, pain points, and behaviors, forming a strong foundation for design decisions and reducing guesswork throughout the process.",
          bullets: [
            {
              title: "User Interviews",
              text: "Gathering insights directly from real users.",
            },
            {
              title: "Problem Exploration",
              text: "Identifying unmet needs and opportunities.",
            },
          ],
        },
        {
          title: "UX Strategy & Information Architecture",
          icon: "",
          description:
            "Based on research findings, we define product structure, user flows, and interaction models. This step ensures the product is intuitive, logically organized, and aligned with both user expectations and business objectives.",
          bullets: [
            {
              title: "User Flows",
              text: "Clear paths that guide user actions.",
            },
            {
              title: "Content Structure",
              text: "Well-organized information hierarchy.",
            },
          ],
        },
        {
          title: "Wireframing",
          icon: "WireframeIcon",
          description:
            "We create low and mid-fidelity wireframes to visualize layout and functionality without distractions. Wireframes allow teams to focus on usability, structure, and flow before investing time in visual design.",
          bullets: [
            {
              title: "Layout Planning",
              text: "Structuring screens for clarity.",
            },
            {
              title: "Early Validation",
              text: "Quick feedback on usability concepts.",
            },
          ],
        },
        {
          title: "UI Design",
          icon: "DesignIcon",
          description:
            "Our designers craft visually engaging interfaces that reflect your brand while supporting usability and accessibility. Visual design enhances clarity, trust, and consistency across the product experience.",
          bullets: [
            {
              title: "Visual Consistency",
              text: "Unified design language across screens.",
            },
            {
              title: "Accessibility",
              text: "Designs that consider diverse users.",
            },
          ],
        },
        {
          title: "Interactive Prototyping & Testing",
          icon: "PrototypeIcon",
          description:
            "We build interactive prototypes that simulate real product behavior. These prototypes are tested with users and stakeholders to validate assumptions, gather feedback, and refine the experience before development begins.",
          bullets: [
            {
              title: "Clickable Prototypes",
              text: "Realistic simulations of user interactions.",
            },
            {
              title: "Usability Testing",
              text: "Early feedback to guide improvements.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Design With Confidence Before You Build",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Design Your Product",
      title: "Our Product Design Process",
      description:
        "A structured, collaborative process that turns ideas into validated design solutions.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding users, business goals, and product vision.",
        },
        {
          stepNumberImage: "",
          title: "Research",
          description: "Gathering insights through interviews and analysis.",
        },
        {
          stepNumberImage: "",
          title: "Strategy",
          description: "Defining UX direction and product structure.",
        },
        {
          stepNumberImage: "",
          title: "Wireframing",
          description: "Visualizing layouts and user flows.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating polished, user-friendly interfaces.",
        },
        {
          stepNumberImage: "",
          title: "Prototype & Test",
          description: "Validating designs through interactive testing.",
        },
      ],
    },

    customIndustries: {
      title: "Product Design Across Industries",
      description:
        "We design digital products for a wide range of industries and audiences.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Design Impact",
      description:
        "Product design and prototyping that drive clarity, usability, and informed decisions.",
      slides: [
        {
          title: "Improved Usability",
          subTitle: "User-Centered Design",
          description:
            "Thoughtful design reduces friction and improves user satisfaction.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Design Systems", image: "" }],
        },
        {
          title: "Faster Validation",
          subTitle: "Reduced Risk",
          description:
            "Prototypes help validate ideas early, saving time and cost.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Prototyping Tools", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We design products that balance creativity, usability, and business value.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "User-Focused",
          text: "Every design decision is guided by real user needs, behaviors, and expectations rather than assumptions.",
        },
        {
          title: "Collaborative",
          text: "We work closely with stakeholders and engineers to ensure alignment and smooth handoff to development.",
        },
        {
          title: "Iterative",
          text: "Our design process embraces feedback and iteration to continuously improve the product experience.",
        },
        {
          title: "Experienced",
          text: "Our team has hands-on experience designing successful products across industries and platforms.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Teams value our ability to translate ideas into clear, usable designs.",
      clientTestimonails: [
        {
          description:
            "The design and prototype gave us clarity and confidence before starting development.",
          name: "Emma R.",
          position: "Product Manager",
        },
      ],
    },

    techStacks: {
      title: "Design & Prototyping Tools",
      description:
        "Modern tools used to design, prototype, and validate product ideas.",
      techList: [
        {
          name: "Design",
          icon: "",
          lenguages: [
            { name: "Figma", icon: "" },
            { name: "Sketch", icon: "" },
          ],
        },
        {
          name: "Prototyping",
          icon: "",
          lenguages: [
            { name: "Figma Prototyping", icon: "" },
            { name: "InVision", icon: "" },
          ],
        },
        {
          name: "Collaboration",
          icon: "",
          lenguages: [
            { name: "Miro", icon: "" },
            { name: "Zeplin", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description:
        "Common questions about product design and prototyping services.",
      questions: [
        {
          title: "What is product design?",
          description:
            "Product design focuses on creating usable, intuitive, and valuable digital experiences for users.",
        },
        {
          title: "Why is prototyping important?",
          description:
            "Prototyping allows teams to test ideas early and reduce development risk.",
        },
        {
          title: "Do you conduct user research?",
          description:
            "Yes, user research is a core part of our design process.",
        },
        {
          title: "Can designs be handed off to development teams?",
          description:
            "Absolutely, we provide clear documentation and assets for development.",
        },
        {
          title: "Do you redesign existing products?",
          description:
            "Yes, we improve and modernize existing products based on user feedback and goals.",
        },
      ],
    },
  },
  "full-scale-product-development": {
    banner: {
      breadcrumb: "Full-Scale Product Development",
      title: "Building Products Ready For",
      highlight: "Scale & Growth.",
      description:
        "We help organizations design, build, and scale full-featured digital products through structured product engineering, ensuring reliability, performance, and adaptability as user needs, markets, and business goals evolve over time.",
      cta: "Build Your Product",
      backgroundImage: require("../assets/images/full-scale-product-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Full-scale product development demands long-term thinking, technical depth, and strong collaboration. We partner closely with founders, product leaders, and engineering teams to transform validated ideas into robust products. Our approach emphasizes maintainable architecture, iterative delivery, and continuous alignment with business strategy to support sustainable product growth.",
      milestones: [
        {
          counts: 5,
          description: "Years of Product Engineering Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Long-Term",
          description: "Product Engineering Partnerships",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Full-Scale Product Development",
      description:
        "Our full-scale product development services cover the entire product lifecycle, from discovery and design to engineering, launch, and ongoing evolution. We focus on building scalable architectures, reliable systems, and adaptable processes that support continuous improvement, user growth, and changing business requirements without frequent rework.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Product Discovery & Strategy",
          icon: "DiscoveryIcon",
          description:
            "We collaborate with stakeholders to clarify product vision, target users, and success metrics. This phase aligns business objectives with technical feasibility, ensuring the product roadmap is realistic, focused, and built for long-term execution.",
          bullets: [
            {
              title: "Vision Alignment",
              text: "Shared understanding of product goals and outcomes.",
            },
            {
              title: "Strategic Roadmapping",
              text: "Clear direction for phased product growth.",
            },
          ],
        },
        {
          title: "Architecture & Technical Planning",
          icon: "ArchitectureIcon",
          description:
            "Our engineers design scalable system architectures that support performance, security, and future expansion. Technical planning reduces risk by addressing dependencies, data flows, and integration needs early in the development process.",
          bullets: [
            {
              title: "Scalable Design",
              text: "Architectures built for growth and flexibility.",
            },
            {
              title: "Risk Mitigation",
              text: "Addressing technical challenges upfront.",
            },
          ],
        },
        {
          title: "UX/UI Design",
          icon: "DesignIcon",
          description:
            "Design teams create user-centered interfaces that balance usability, accessibility, and brand consistency. Design decisions are validated continuously to ensure the product remains intuitive as features and complexity increase.",
          bullets: [
            {
              title: "User Experience",
              text: "Designs focused on clarity and ease of use.",
            },
            {
              title: "Design Consistency",
              text: "Unified visual and interaction patterns.",
            },
          ],
        },
        {
          title: "Engineering & Implementation",
          icon: "DevelopmentIcon",
          description:
            "We develop the product using modern engineering practices, emphasizing clean code, modular components, and reliable integrations. Iterative delivery ensures steady progress while maintaining quality across growing codebases.",
          bullets: [
            {
              title: "Agile Development",
              text: "Incremental releases with regular reviews.",
            },
            {
              title: "Code Quality",
              text: "Maintainable and well-structured implementations.",
            },
          ],
        },
        {
          title: "Testing, Launch & Scaling",
          icon: "LaunchIcon",
          description:
            "Before launch, we rigorously test functionality, performance, and security. Post-launch, we support scaling efforts, performance tuning, and feature expansion as user adoption and system demands increase.",
          bullets: [
            {
              title: "Quality Assurance",
              text: "Thorough testing across environments.",
            },
            {
              title: "Scalable Growth",
              text: "Preparing systems for increased usage.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Scale Confidently With a Strong Product Foundation",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your Product",
      title: "Our Product Development Process",
      description:
        "A structured yet flexible process designed to support long-term product success.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding product vision, users, and business goals.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Defining roadmap, scope, and delivery milestones.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating user experiences and interface designs.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description:
            "Building features using scalable engineering practices.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Validating functionality, performance, and security.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Evolution",
          description:
            "Releasing the product and supporting continuous improvement.",
        },
      ],
    },

    customIndustries: {
      title: "Full-Scale Product Development Across Industries",
      description:
        "We build and scale products across diverse industries and business models.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Product Impact",
      description:
        "Full-scale development focused on stability, growth, and long-term value.",
      slides: [
        {
          title: "Scalable Systems",
          subTitle: "Built for Growth",
          description:
            "Architectures that support increasing users, data, and feature complexity.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Scalable Architectures", image: "" }],
        },
        {
          title: "Sustained Quality",
          subTitle: "Reliable Performance",
          description:
            "Engineering practices that maintain performance and reliability over time.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Quality Engineering Tools", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We build full-scale products with a focus on longevity and adaptability.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Product-Minded",
          text: "We approach development with a strong product mindset, balancing user needs, business goals, and technical decisions throughout the lifecycle.",
        },
        {
          title: "Scalable Engineering",
          text: "Our engineering choices are made to support growth, minimizing rework as complexity increases.",
        },
        {
          title: "Collaborative",
          text: "We work as an extension of your team, ensuring transparency, alignment, and shared ownership.",
        },
        {
          title: "Experienced",
          text: "Our team has deep experience delivering and scaling complex products across industries.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Organizations trust us to deliver and scale mission-critical products.",
      clientTestimonails: [
        {
          description:
            "Their structured approach helped us scale our product while maintaining quality and stability.",
          name: "Jonathan P.",
          position: "Product Director",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern, scalable technologies that support long-term product development.",
      techList: [
        {
          name: "Frontend",
          icon: "",
          lenguages: [
            { name: "React", icon: "" },
            { name: "Next.js", icon: "" },
          ],
        },
        {
          name: "Backend",
          icon: "",
          lenguages: [
            { name: "Node.js", icon: "" },
            { name: "Java", icon: "" },
          ],
        },
        {
          name: "Cloud & DevOps",
          icon: "",
          lenguages: [
            { name: "AWS", icon: "" },
            { name: "Docker", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description:
        "Common questions about full-scale product development services.",
      questions: [
        {
          title: "What is full-scale product development?",
          description:
            "It covers end-to-end design, engineering, launch, and ongoing evolution of a complete product.",
        },
        {
          title: "Can you scale products after launch?",
          description:
            "Yes, we support performance tuning, feature expansion, and infrastructure scaling.",
        },
        {
          title: "Do you work with existing products?",
          description:
            "Yes, we enhance and modernize existing products as well.",
        },
        {
          title: "How do you manage long-term development?",
          description:
            "We use structured roadmaps, agile delivery, and continuous feedback loops.",
        },
        {
          title: "Do you provide post-launch support?",
          description:
            "Yes, we offer long-term support and continuous improvement services.",
        },
      ],
    },
  },
  "product-modernization-optimization": {
    banner: {
      breadcrumb: "Product Modernization & Optimization",
      title: "Evolving Products For",
      highlight: "Performance & Longevity.",
      description:
        "We help organizations modernize and optimize existing digital products to improve performance, usability, scalability, and maintainability, ensuring systems remain competitive, efficient, and aligned with evolving business and user expectations.",
      cta: "Modernize Your Product",
      backgroundImage: require("../assets/images/product-modernization-optimization.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Product modernization requires deep understanding of existing systems, business constraints, and future goals. We work closely with product, engineering, and leadership teams to identify improvement opportunities without disrupting ongoing operations. Our approach balances technical upgrades, user experience improvements, and performance optimization to extend product lifespan and unlock new growth potential.",
      milestones: [
        {
          counts: 5,
          description: "Years of Product Engineering Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Long-Term",
          description: "Optimization Partnerships",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Product Modernization & Optimization",
      description:
        "Our modernization and optimization services support the full transformation journey, from assessing legacy systems to implementing targeted improvements and continuous enhancements. We focus on reducing technical debt, improving performance, and aligning products with modern technology standards while protecting business continuity and user trust.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Product & Technical Assessment",
          icon: "",
          description:
            "We analyze existing product architecture, code quality, performance metrics, and user feedback to identify bottlenecks and risks. This assessment establishes a clear modernization baseline and highlights areas where optimization will deliver the greatest impact.",
          bullets: [
            {
              title: "Code Review",
              text: "Identifying technical debt and maintainability issues.",
            },
            {
              title: "Performance Analysis",
              text: "Evaluating speed, stability, and scalability limits.",
            },
          ],
        },
        {
          title: "Modernization Strategy & Roadmap",
          icon: "",
          description:
            "Based on assessment findings, we define a phased modernization roadmap that prioritizes high-impact improvements. This strategy balances quick wins with long-term architectural upgrades to minimize risk and disruption.",
          bullets: [
            {
              title: "Phased Execution",
              text: "Incremental improvements without major downtime.",
            },
            {
              title: "Business Alignment",
              text: "Upgrades aligned with strategic objectives.",
            },
          ],
        },
        {
          title: "Architecture & Technology Upgrades",
          icon: "ArchitectureIcon",
          description:
            "We modernize underlying architectures by introducing scalable patterns, updated frameworks, and improved integrations. These upgrades prepare the product for growth, higher traffic, and evolving feature requirements.",
          bullets: [
            {
              title: "Scalable Design",
              text: "Architectures built for future expansion.",
            },
            {
              title: "Technology Refresh",
              text: "Adoption of modern, supported frameworks.",
            },
          ],
        },
        {
          title: "Performance & UX Optimization",
          icon: "OptimizationIcon",
          description:
            "Our team optimizes application performance and refines user experience to reduce friction and improve satisfaction. Enhancements focus on responsiveness, usability, and accessibility across devices.",
          bullets: [
            {
              title: "Speed Improvements",
              text: "Reducing load times and latency.",
            },
            {
              title: "UX Enhancements",
              text: "Improving clarity and user flows.",
            },
          ],
        },
        {
          title: "Stabilization & Continuous Improvement",
          icon: "MonitoringIcon",
          description:
            "After modernization, we implement monitoring and feedback loops to ensure stability and guide ongoing optimization. Continuous improvement practices help products remain efficient and relevant as requirements evolve.",
          bullets: [
            {
              title: "Operational Monitoring",
              text: "Visibility into system health and usage.",
            },
            {
              title: "Ongoing Refinement",
              text: "Iterative improvements based on data.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Extend Product Value Without Starting Over",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Modernize Your Product",
      title: "Our Product Modernization Process",
      description:
        "A structured process designed to upgrade products while maintaining reliability and continuity.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding product goals, constraints, and current challenges.",
        },
        {
          stepNumberImage: "",
          title: "Assessment",
          description:
            "Evaluating architecture, performance, and technical debt.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Defining modernization scope and phased roadmap.",
        },
        {
          stepNumberImage: "",
          title: "Implementation",
          description:
            "Executing upgrades, optimizations, and refactoring efforts.",
        },
        {
          stepNumberImage: "",
          title: "Validation",
          description:
            "Testing improvements for stability, performance, and usability.",
        },
        {
          stepNumberImage: "",
          title: "Optimization & Support",
          description: "Monitoring systems and refining continuously.",
        },
      ],
    },

    customIndustries: {
      title: "Product Modernization Across Industries",
      description:
        "We modernize and optimize products across industries with diverse technical landscapes.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Optimization Impact",
      description:
        "Modernization efforts focused on performance, maintainability, and user satisfaction.",
      slides: [
        {
          title: "Improved Performance",
          subTitle: "Faster Systems",
          description:
            "Optimized architectures and codebases deliver noticeable speed and stability improvements.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [
            { title: "Performance Optimization Tools", image: "" },
          ],
        },
        {
          title: "Extended Product Lifespan",
          subTitle: "Future-Ready",
          description:
            "Modernized products remain viable, secure, and adaptable for years to come.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Modern Frameworks", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We modernize products with care, precision, and long-term thinking.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Risk-Aware",
          text: "We modernize incrementally to reduce operational risk while preserving business continuity and user trust.",
        },
        {
          title: "Balanced Approach",
          text: "Our work balances technical improvements with user experience and business priorities.",
        },
        {
          title: "Performance-Driven",
          text: "Every optimization is guided by measurable performance and usability improvements.",
        },
        {
          title: "Experienced",
          text: "Our team has extensive experience modernizing complex, long-running products across industries.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Organizations rely on us to modernize products without disruption.",
      clientTestimonails: [
        {
          description:
            "Modernization improved performance significantly while keeping our users unaffected during the transition.",
          name: "Rachel D.",
          position: "Product Owner",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern tools and platforms used to upgrade and optimize existing products.",
      techList: [
        {
          name: "Frontend",
          icon: "",
          lenguages: [
            { name: "React", icon: "" },
            { name: "Next.js", icon: "" },
          ],
        },
        {
          name: "Backend",
          icon: "",
          lenguages: [
            { name: "Node.js", icon: "" },
            { name: "Java", icon: "" },
          ],
        },
        {
          name: "Cloud & Optimization",
          icon: "",
          lenguages: [
            { name: "AWS", icon: "" },
            { name: "Docker", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description:
        "Common questions about product modernization and optimization services.",
      questions: [
        {
          title: "What is product modernization?",
          description:
            "It involves upgrading existing products to improve performance, usability, and maintainability.",
        },
        {
          title: "Can modernization be done without downtime?",
          description:
            "Yes, we use phased and incremental approaches to minimize disruption.",
        },
        {
          title: "Do you work with legacy systems?",
          description:
            "Absolutely, legacy systems are a common focus of our modernization efforts.",
        },
        {
          title: "How do you prioritize optimization efforts?",
          description:
            "We prioritize based on impact, risk, and business goals.",
        },
        {
          title: "Do you provide ongoing optimization support?",
          description:
            "Yes, we offer continuous monitoring and improvement services.",
        },
      ],
    },
  },
  "product-testing-qa": {
    banner: {
      breadcrumb: "Product Testing & QA",
      title: "Delivering Confidence Through",
      highlight: "Quality Assurance.",
      description:
        "We help organizations ensure product reliability, performance, and usability through structured testing and quality assurance practices that identify issues early, reduce risk, and support consistent, high-quality product releases.",
      cta: "Strengthen Product Quality",
      backgroundImage: require("../assets/images/product-testing-qa.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Product quality is not achieved through testing alone, it requires a thoughtful approach that integrates quality across the development lifecycle. We collaborate closely with product, engineering, and business teams to design QA strategies that improve visibility, reduce defects, and build confidence in every release while keeping delivery timelines predictable.",
      milestones: [
        {
          counts: 5,
          description: "Years of QA Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Ongoing",
          description: "Quality Assurance Engagements",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Product Testing & QA",
      description:
        "Our product testing and QA services cover the complete quality lifecycle, from defining testing strategies to executing manual and automated tests and supporting continuous quality improvement. We focus on identifying risks early, improving coverage, and ensuring products perform reliably across real-world scenarios and environments.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "QA Strategy & Test Planning",
          icon: "",
          description:
            "We define a clear QA strategy aligned with product goals, timelines, and risk tolerance. Test planning identifies critical scenarios, environments, and test types required to ensure reliable releases while avoiding unnecessary testing overhead.",
          bullets: [
            {
              title: "Risk-Based Planning",
              text: "Focusing effort on high-impact areas.",
            },
            {
              title: "Test Coverage Definition",
              text: "Ensuring critical paths are validated.",
            },
          ],
        },
        {
          title: "Manual Functional Testing",
          icon: "ManualTestIcon",
          description:
            "Our QA engineers perform thorough manual testing to validate core functionality, edge cases, and user workflows. Manual testing ensures the product behaves as expected from a real user perspective across different scenarios.",
          bullets: [
            {
              title: "User Flow Validation",
              text: "Testing real-world usage scenarios.",
            },
            {
              title: "Exploratory Testing",
              text: "Uncovering hidden and unexpected issues.",
            },
          ],
        },
        {
          title: "Automation Testing",
          icon: "AutomationIcon",
          description:
            "We implement automated test suites to improve coverage, consistency, and speed. Automation supports regression testing and continuous integration, enabling teams to detect issues quickly as changes are introduced.",
          bullets: [
            {
              title: "Regression Coverage",
              text: "Ensuring existing features remain stable.",
            },
            {
              title: "CI Integration",
              text: "Automated tests within delivery pipelines.",
            },
          ],
        },
        {
          title: "Performance & Security Testing",
          icon: "PerformanceIcon",
          description:
            "We assess product performance and security under realistic conditions to identify bottlenecks and vulnerabilities. These tests help ensure the system remains stable, responsive, and secure as usage scales.",
          bullets: [
            {
              title: "Load Testing",
              text: "Validating behavior under expected traffic.",
            },
            {
              title: "Security Checks",
              text: "Identifying common vulnerabilities.",
            },
          ],
        },
        {
          title: "Quality Monitoring & Continuous Improvement",
          icon: "MonitoringIcon",
          description:
            "We establish quality metrics, reporting, and feedback loops that help teams continuously improve testing effectiveness. Ongoing monitoring ensures quality remains consistent as products evolve.",
          bullets: [
            {
              title: "Quality Metrics",
              text: "Clear visibility into defect trends.",
            },
            {
              title: "Process Refinement",
              text: "Improving QA practices over time.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Release With Confidence and Clarity",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Improve Your Product Quality",
      title: "Our Testing & QA Process",
      description:
        "A structured process designed to embed quality into every stage of product development.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding product scope, risks, and quality expectations.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Defining testing strategy, scope, and environments.",
        },
        {
          stepNumberImage: "",
          title: "Test Design",
          description: "Creating test cases, scenarios, and automation plans.",
        },
        {
          stepNumberImage: "",
          title: "Execution",
          description: "Running manual and automated tests across builds.",
        },
        {
          stepNumberImage: "",
          title: "Reporting",
          description: "Sharing clear defect reports and quality insights.",
        },
        {
          stepNumberImage: "",
          title: "Optimization",
          description: "Refining testing processes based on outcomes.",
        },
      ],
    },

    customIndustries: {
      title: "Product Testing Across Industries",
      description:
        "We deliver QA and testing services for products across diverse industries and platforms.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Quality Impact",
      description:
        "Testing and QA practices that improve stability, usability, and release confidence.",
      slides: [
        {
          title: "Reduced Defects",
          subTitle: "Higher Quality Releases",
          description:
            "Early detection of issues leads to fewer production problems.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Testing Frameworks", image: "" }],
        },
        {
          title: "Faster Feedback",
          subTitle: "Improved Velocity",
          description:
            "Clear QA insights help teams fix issues quickly and release faster.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Automation Tools", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver QA services that balance thorough testing with efficient delivery.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Detail-Oriented",
          text: "Our testers focus on uncovering subtle issues that impact usability, stability, and user trust.",
        },
        {
          title: "Process-Driven",
          text: "We apply structured QA processes that integrate smoothly with development workflows.",
        },
        {
          title: "Automation-Smart",
          text: "Automation is applied thoughtfully to improve coverage without unnecessary complexity.",
        },
        {
          title: "Experienced",
          text: "Our team brings extensive experience testing complex products across platforms and domains.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Teams rely on us to protect product quality and release confidence.",
      clientTestimonails: [
        {
          description:
            "Their QA process helped us catch critical issues early and release with far more confidence.",
          name: "Priya N.",
          position: "Product Lead",
        },
      ],
    },

    techStacks: {
      title: "Testing Tools & Technologies",
      description:
        "Proven tools used to support reliable and efficient testing processes.",
      techList: [
        {
          name: "Automation Testing",
          icon: "",
          lenguages: [
            { name: "Selenium", icon: "" },
            { name: "Cypress", icon: "" },
          ],
        },
        {
          name: "Performance Testing",
          icon: "",
          lenguages: [
            { name: "JMeter", icon: "" },
            { name: "k6", icon: "" },
          ],
        },
        {
          name: "Test Management",
          icon: "",
          lenguages: [
            { name: "TestRail", icon: "" },
            { name: "Zephyr", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about product testing and QA services.",
      questions: [
        {
          title: "What types of testing do you provide?",
          description:
            "We provide functional, automation, performance, security, and regression testing.",
        },
        {
          title: "Can QA work alongside our development team?",
          description:
            "Yes, we integrate seamlessly with in-house or external teams.",
        },
        {
          title: "Do you offer test automation services?",
          description: "Yes, we design and maintain automated test suites.",
        },
        {
          title: "When should testing start in a project?",
          description:
            "Testing should begin as early as possible to reduce risk.",
        },
        {
          title: "Do you provide ongoing QA support?",
          description:
            "Yes, we support continuous testing and quality improvement.",
        },
      ],
    },
  },
  "search-engine-optimization-seo": {
    banner: {
      breadcrumb: "Search Engine Optimization (SEO)",
      title: "Driving Sustainable Growth Through",
      highlight: "Search Visibility.",
      description:
        "We help businesses improve their online visibility and organic reach through strategic Search Engine Optimization practices that attract the right audience, increase rankings, and deliver long-term, measurable digital growth.",
      cta: "Improve Search Rankings",
      backgroundImage: require("../assets/images/ecommerce-seo-services.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Effective SEO goes beyond keywords and rankings, it requires a deep understanding of search behavior, content quality, and technical foundations. We work closely with marketing and business teams to build SEO strategies rooted in data, aligned with business goals, and designed to deliver consistent, long-term results rather than short-lived traffic spikes.",
      milestones: [
        {
          counts: 5,
          description: "Years of SEO Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Long-Term",
          description: "SEO Growth Partnerships",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End SEO Services",
      description:
        "Our SEO services cover the complete optimization lifecycle, from technical audits and keyword research to on-page optimization, content strategy, and ongoing performance tracking. We focus on building strong search foundations that improve discoverability, user experience, and authority across search engines.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "SEO Audit & Assessment",
          icon: "AuditIcon",
          description:
            "We conduct a comprehensive SEO audit to evaluate technical health, site structure, content quality, and backlink profile. This assessment uncovers ranking barriers and provides a clear baseline for optimization priorities.",
          bullets: [
            {
              title: "Technical Review",
              text: "Identifying crawl, index, and performance issues.",
            },
            {
              title: "Content Analysis",
              text: "Evaluating relevance and search alignment.",
            },
          ],
        },
        {
          title: "Keyword Research & Strategy",
          icon: "KeywordIcon",
          description:
            "We identify high-intent keywords that align with your audience and business objectives. Keyword strategy focuses on search demand, competition, and relevance to guide content creation and optimization efforts.",
          bullets: [
            {
              title: "Search Intent Mapping",
              text: "Aligning keywords with user needs.",
            },
            {
              title: "Opportunity Identification",
              text: "Targeting achievable ranking opportunities.",
            },
          ],
        },
        {
          title: "On-Page SEO Optimization",
          icon: "OnPageIcon",
          description:
            "Our team optimizes on-page elements including content structure, metadata, internal linking, and semantic relevance. These improvements help search engines understand pages while enhancing usability for visitors.",
          bullets: [
            {
              title: "Content Optimization",
              text: "Improving clarity, relevance, and structure.",
            },
            {
              title: "Internal Linking",
              text: "Strengthening site navigation and authority flow.",
            },
          ],
        },
        {
          title: "Technical SEO Improvements",
          icon: "TechnicalIcon",
          description:
            "We address technical factors such as site speed, mobile friendliness, indexing, and structured data. Technical SEO ensures your website is accessible, fast, and compliant with search engine best practices.",
          bullets: [
            {
              title: "Performance Optimization",
              text: "Improving load times and responsiveness.",
            },
            {
              title: "Indexing Control",
              text: "Ensuring correct crawl and index behavior.",
            },
          ],
        },
        {
          title: "Monitoring, Reporting & Optimization",
          icon: "MonitoringIcon",
          description:
            "We continuously track rankings, traffic, and conversions to measure impact and guide refinements. Ongoing optimization ensures SEO performance adapts to algorithm updates, competition, and changing user behavior.",
          bullets: [
            {
              title: "Performance Tracking",
              text: "Clear visibility into SEO progress.",
            },
            {
              title: "Continuous Refinement",
              text: "Data-driven optimization decisions.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Turn Search Traffic Into Business Growth",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Improve Your SEO",
      title: "Our SEO Process",
      description:
        "A structured, transparent process designed to build lasting search visibility.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding business goals, audience, and competitive landscape.",
        },
        {
          stepNumberImage: "",
          title: "Audit",
          description: "Evaluating technical, content, and authority factors.",
        },
        {
          stepNumberImage: "",
          title: "Strategy",
          description: "Defining keyword focus and optimization roadmap.",
        },
        {
          stepNumberImage: "",
          title: "Implementation",
          description: "Executing on-page and technical improvements.",
        },
        {
          stepNumberImage: "",
          title: "Measurement",
          description: "Tracking rankings, traffic, and conversions.",
        },
        {
          stepNumberImage: "",
          title: "Optimization",
          description: "Refining strategy based on performance data.",
        },
      ],
    },

    customIndustries: {
      title: "SEO Across Industries",
      description:
        "We deliver SEO strategies tailored to diverse industries and competitive markets.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "SEO Impact",
      description:
        "Search optimization focused on visibility, relevance, and long-term performance.",
      slides: [
        {
          title: "Increased Organic Traffic",
          subTitle: "Sustained Growth",
          description: "Improved rankings attract qualified users over time.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "SEO Analytics Tools", image: "" }],
        },
        {
          title: "Higher Search Visibility",
          subTitle: "Stronger Presence",
          description:
            "Consistent optimization improves brand discoverability.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Search Console Tools", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver SEO strategies grounded in data, transparency, and sustainable results.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Data-Driven",
          text: "Our SEO decisions are guided by research, analytics, and measurable outcomes rather than assumptions or guesswork.",
        },
        {
          title: "Ethical Practices",
          text: "We follow search engine guidelines and avoid shortcuts that risk long-term penalties.",
        },
        {
          title: "Business-Aligned",
          text: "SEO efforts are aligned with real business goals such as leads, conversions, and growth.",
        },
        {
          title: "Experienced",
          text: "Our team has extensive experience improving search visibility across competitive industries.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Businesses trust us to grow their organic search presence sustainably.",
      clientTestimonails: [
        {
          description:
            "Our organic traffic grew steadily, and rankings improved without sacrificing content quality.",
          name: "Amit K.",
          position: "Marketing Manager",
        },
      ],
    },

    techStacks: {
      title: "SEO Tools & Platforms",
      description:
        "Trusted tools used to research, optimize, and measure SEO performance.",
      techList: [
        {
          name: "SEO Research",
          icon: "",
          lenguages: [
            { name: "Ahrefs", icon: "" },
            { name: "SEMrush", icon: "" },
          ],
        },
        {
          name: "Analytics & Tracking",
          icon: "",
          lenguages: [
            { name: "Google Analytics", icon: "" },
            { name: "Search Console", icon: "" },
          ],
        },
        {
          name: "Technical SEO",
          icon: "",
          lenguages: [
            { name: "Screaming Frog", icon: "" },
            { name: "PageSpeed Insights", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description:
        "Common questions about Search Engine Optimization services.",
      questions: [
        {
          title: "How long does SEO take to show results?",
          description:
            "SEO is a long-term strategy, with noticeable improvements typically appearing over several months.",
        },
        {
          title: "Do you follow Google guidelines?",
          description:
            "Yes, all SEO practices follow search engine best practices and guidelines.",
        },
        {
          title: "Can you optimize existing websites?",
          description:
            "Absolutely, we work with both new and existing websites.",
        },
        {
          title: "Do you provide SEO reporting?",
          description: "Yes, we provide clear and regular performance reports.",
        },
        {
          title: "Is SEO better than paid advertising?",
          description:
            "SEO provides long-term value, while paid ads deliver short-term visibility; both can work together.",
        },
      ],
    },
  },
  "digital-marketing-ppc": {
    banner: {
      breadcrumb: "Pay Per Click (PPC)",
      title: "Driving Immediate Results With",
      highlight: "Targeted Advertising.",
      description:
        "We help businesses generate qualified leads and measurable growth through data-driven Pay Per Click advertising strategies that focus on intent, relevance, and return on investment across major ad platforms.",
      cta: "Launch PPC Campaigns",
      backgroundImage: require("../assets/images/digital-marketing-ppc.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Successful PPC management requires more than launching ads, it demands constant optimization, insight, and strategic decision-making. We work closely with marketing and business teams to design PPC campaigns grounded in audience intent, clear messaging, and performance data. Our approach prioritizes efficiency, transparency, and continuous refinement to ensure ad spend consistently drives meaningful business outcomes.",
      milestones: [
        {
          counts: 5,
          description: "Years of PPC Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Ongoing",
          description: "Performance Optimization Engagements",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End PPC Management Services",
      description:
        "Our PPC services cover the complete advertising lifecycle, from strategy and setup to optimization and reporting. We focus on building campaigns that attract high-intent users, control costs, and improve conversion performance while continuously adapting to market changes, competition, and evolving customer behavior.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "PPC Audit & Account Review",
          icon: "AuditIcon",
          description:
            "We analyze existing PPC accounts or evaluate readiness for new campaigns to identify gaps, inefficiencies, and missed opportunities. This assessment provides clarity on budget usage, targeting accuracy, and performance improvement areas.",
          bullets: [
            {
              title: "Account Structure Review",
              text: "Evaluating campaigns, ad groups, and settings.",
            },
            {
              title: "Spend Analysis",
              text: "Identifying wasted spend and inefficiencies.",
            },
          ],
        },
        {
          title: "Campaign Strategy & Planning",
          icon: "StrategyIcon",
          description:
            "Based on business goals and audience insights, we define a PPC strategy that outlines platforms, targeting, budgets, and messaging. Planning ensures campaigns are aligned with conversion objectives rather than just traffic volume.",
          bullets: [
            {
              title: "Audience Targeting",
              text: "Reaching users with strong purchase intent.",
            },
            {
              title: "Budget Allocation",
              text: "Distributing spend for maximum impact.",
            },
          ],
        },
        {
          title: "Keyword & Audience Research",
          icon: "KeywordIcon",
          description:
            "We conduct in-depth keyword and audience research to identify high-performing opportunities. Research focuses on intent, competition, and cost efficiency to ensure ads appear at the right moment in the buyer journey.",
          bullets: [
            {
              title: "Search Intent Analysis",
              text: "Aligning ads with user motivation.",
            },
            {
              title: "Audience Segmentation",
              text: "Refining targeting for relevance.",
            },
          ],
        },
        {
          title: "Ad Creation & Landing Optimization",
          icon: "CreativeIcon",
          description:
            "Our team creates compelling ad copy and aligns landing pages to maximize relevance and conversion rates. Messaging, visuals, and calls to action are tested and refined to improve engagement and performance.",
          bullets: [
            {
              title: "Ad Copy Testing",
              text: "Optimizing messaging for engagement.",
            },
            {
              title: "Landing Page Alignment",
              text: "Ensuring consistency between ads and pages.",
            },
          ],
        },
        {
          title: "Optimization, Reporting & Scaling",
          icon: "OptimizationIcon",
          description:
            "We continuously monitor campaign performance, refine targeting, adjust bids, and test variations. Clear reporting and insights guide scaling decisions and ensure PPC investment delivers measurable returns.",
          bullets: [
            {
              title: "Performance Monitoring",
              text: "Tracking conversions and cost efficiency.",
            },
            {
              title: "Ongoing Optimization",
              text: "Improving results through data-driven changes.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Turn Ad Spend Into Measurable Growth",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Launch Your PPC Campaigns",
      title: "Our PPC Management Process",
      description:
        "A structured process designed to deliver fast insights, controlled spend, and consistent performance.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding business goals, target audience, and conversion objectives.",
        },
        {
          stepNumberImage: "",
          title: "Audit & Research",
          description:
            "Analyzing accounts, keywords, competitors, and opportunities.",
        },
        {
          stepNumberImage: "",
          title: "Strategy Definition",
          description: "Defining targeting, budgets, and platform selection.",
        },
        {
          stepNumberImage: "",
          title: "Campaign Setup",
          description: "Building campaigns, ads, and tracking configurations.",
        },
        {
          stepNumberImage: "",
          title: "Optimization",
          description:
            "Refining bids, ads, and audiences based on performance.",
        },
        {
          stepNumberImage: "",
          title: "Reporting & Scaling",
          description:
            "Measuring results and expanding high-performing campaigns.",
        },
      ],
    },

    customIndustries: {
      title: "PPC Across Industries",
      description:
        "We manage PPC campaigns for businesses across competitive and diverse markets.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Advertising Impact",
      description:
        "PPC strategies focused on efficiency, relevance, and measurable outcomes.",
      slides: [
        {
          title: "Higher Conversion Rates",
          subTitle: "Qualified Traffic",
          description:
            "Targeted campaigns attract users more likely to convert.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Ad Optimization Tools", image: "" }],
        },
        {
          title: "Controlled Ad Spend",
          subTitle: "Better ROI",
          description:
            "Continuous optimization ensures budget is used efficiently.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Bid Management Tools", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We manage PPC campaigns with a focus on accountability, insight, and sustainable performance.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Performance-Focused",
          text: "Every campaign decision is guided by measurable outcomes such as conversions, cost efficiency, and revenue impact.",
        },
        {
          title: "Transparent",
          text: "We provide clear reporting and visibility into spend, performance, and optimization actions.",
        },
        {
          title: "Continuously Optimized",
          text: "Campaigns are refined regularly to adapt to data, competition, and market changes.",
        },
        {
          title: "Experienced",
          text: "Our team has managed PPC campaigns across platforms, industries, and budget levels.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Businesses trust us to turn paid advertising into consistent growth.",
      clientTestimonails: [
        {
          description:
            "Our PPC campaigns became far more efficient, and lead quality improved significantly.",
          name: "Suresh P.",
          position: "Marketing Director",
        },
      ],
    },

    techStacks: {
      title: "PPC Platforms & Tools",
      description:
        "Trusted platforms and tools used to manage and optimize paid campaigns.",
      techList: [
        {
          name: "Advertising Platforms",
          icon: "",
          lenguages: [
            { name: "Google Ads", icon: "" },
            { name: "Microsoft Ads", icon: "" },
          ],
        },
        {
          name: "Analytics & Tracking",
          icon: "",
          lenguages: [
            { name: "Google Analytics", icon: "" },
            { name: "Tag Manager", icon: "" },
          ],
        },
        {
          name: "Optimization & Insights",
          icon: "",
          lenguages: [
            { name: "SEMrush", icon: "" },
            { name: "Optmyzr", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about Pay Per Click advertising services.",
      questions: [
        {
          title: "What is PPC advertising?",
          description:
            "PPC is a paid advertising model where you pay only when users click on your ads.",
        },
        {
          title: "How quickly can PPC deliver results?",
          description:
            "PPC can generate traffic and leads almost immediately after launch.",
        },
        {
          title: "Do you manage ad budgets?",
          description:
            "Yes, we manage and optimize budgets to maximize return on investment.",
        },
        {
          title: "Can PPC work with SEO?",
          description:
            "Yes, PPC and SEO complement each other when aligned strategically.",
        },
        {
          title: "Do you provide regular PPC reports?",
          description:
            "Yes, we provide clear performance reports with actionable insights.",
        },
      ],
    },
  },
  "digital-marketing-orm": {
    banner: {
      breadcrumb: "Online Reputation Management (ORM)",
      title: "Protecting Trust And Building",
      highlight: "Digital Credibility.",
      description:
        "We help businesses monitor, protect, and strengthen their online reputation through strategic Online Reputation Management practices that build trust, influence perception, and support long-term brand credibility across digital platforms.",
      cta: "Manage Your Online Reputation",
      backgroundImage: require("../assets/images/digital-marketing-orm.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Online reputation directly impacts customer trust and business decisions. We work closely with brands to understand their public perception, industry challenges, and audience expectations. Our ORM approach combines monitoring, response strategy, content positioning, and continuous improvement to help businesses maintain credibility, address concerns responsibly, and build a strong, positive digital presence over time.",
      milestones: [
        {
          counts: 5,
          description: "Years of Reputation Management Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Ongoing",
          description: "Reputation Monitoring Engagements",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Online Reputation Management",
      description:
        "Our Online Reputation Management services cover the complete reputation lifecycle, from monitoring brand mentions and reviews to responding strategically and promoting positive brand narratives. We focus on transparency, consistency, and long-term trust building while helping organizations stay in control of how they are perceived online.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Reputation Audit & Assessment",
          icon: "AuditIcon",
          description:
            "We analyze your existing online presence, reviews, mentions, and search results to understand public perception. This assessment identifies risks, recurring concerns, and opportunities to strengthen credibility and visibility across platforms.",
          bullets: [
            {
              title: "Brand Sentiment Review",
              text: "Evaluating public opinions and feedback trends.",
            },
            {
              title: "Search Presence Analysis",
              text: "Understanding what users see first online.",
            },
          ],
        },
        {
          title: "Monitoring & Alert Setup",
          icon: "MonitoringIcon",
          description:
            "We implement continuous monitoring systems to track reviews, mentions, and discussions across platforms. Real-time alerts ensure issues are identified early and addressed before they escalate.",
          bullets: [
            {
              title: "Real-Time Monitoring",
              text: "Tracking brand mentions and reviews.",
            },
            {
              title: "Early Issue Detection",
              text: "Identifying potential reputation risks quickly.",
            },
          ],
        },
        {
          title: "Review & Feedback Management",
          icon: "FeedbackIcon",
          description:
            "Our team helps manage customer reviews and feedback professionally and consistently. Thoughtful responses demonstrate accountability, improve customer relationships, and influence public perception positively.",
          bullets: [
            {
              title: "Response Guidelines",
              text: "Professional handling of positive and negative feedback.",
            },
            {
              title: "Platform Management",
              text: "Managing reviews across multiple channels.",
            },
          ],
        },
        {
          title: "Content & Brand Positioning",
          icon: "ContentIcon",
          description:
            "We promote positive, accurate content that reflects your brand values and expertise. Strategic content placement helps strengthen credibility and balance negative or outdated information.",
          bullets: [
            {
              title: "Positive Content Promotion",
              text: "Highlighting strengths and success stories.",
            },
            {
              title: "Brand Narrative Control",
              text: "Shaping consistent and authentic messaging.",
            },
          ],
        },
        {
          title: "Ongoing Reputation Optimization",
          icon: "OptimizationIcon",
          description:
            "We continuously evaluate reputation performance, adjust strategies, and provide insights to improve trust and visibility. Ongoing optimization ensures your brand reputation remains resilient as markets and conversations evolve.",
          bullets: [
            {
              title: "Performance Tracking",
              text: "Measuring reputation trends and improvements.",
            },
            {
              title: "Continuous Refinement",
              text: "Adapting strategies based on feedback and data.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Build Trust That Drives Long-Term Growth",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Strengthen Your Reputation",
      title: "Our ORM Process",
      description:
        "A structured process designed to protect credibility and maintain consistent brand trust.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding brand perception, audience, and industry context.",
        },
        {
          stepNumberImage: "",
          title: "Audit",
          description:
            "Reviewing online mentions, reviews, and search results.",
        },
        {
          stepNumberImage: "",
          title: "Strategy",
          description: "Defining response guidelines and positioning approach.",
        },
        {
          stepNumberImage: "",
          title: "Implementation",
          description: "Managing reviews, responses, and content placement.",
        },
        {
          stepNumberImage: "",
          title: "Monitoring",
          description: "Tracking mentions and sentiment continuously.",
        },
        {
          stepNumberImage: "",
          title: "Optimization",
          description: "Refining strategy based on insights and trends.",
        },
      ],
    },

    customIndustries: {
      title: "ORM Across Industries",
      description:
        "We manage online reputation for brands across highly visible and competitive industries.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Reputation Impact",
      description:
        "ORM strategies focused on trust, transparency, and long-term credibility.",
      slides: [
        {
          title: "Improved Brand Trust",
          subTitle: "Positive Perception",
          description:
            "Consistent reputation management strengthens customer confidence.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [
            { title: "Reputation Monitoring Tools", image: "" },
          ],
        },
        {
          title: "Reduced Reputation Risk",
          subTitle: "Proactive Management",
          description: "Early detection and response help prevent escalation.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Sentiment Analysis Tools", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We manage online reputation with responsibility, consistency, and strategic insight.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Proactive",
          text: "We focus on early detection and prevention to address issues before they impact brand trust or customer decisions.",
        },
        {
          title: "Transparent",
          text: "Our ORM approach emphasizes honest communication and accountability in every interaction.",
        },
        {
          title: "Strategic",
          text: "Reputation management efforts are aligned with long-term brand and business objectives.",
        },
        {
          title: "Experienced",
          text: "Our team has managed reputation challenges across industries and high-visibility platforms.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Brands rely on us to protect and strengthen their digital reputation.",
      clientTestimonails: [
        {
          description:
            "Their ORM strategy helped us regain trust and maintain a positive brand image online.",
          name: "Neha S.",
          position: "Brand Manager",
        },
      ],
    },

    techStacks: {
      title: "ORM Tools & Platforms",
      description:
        "Trusted tools used to monitor, analyze, and manage online reputation.",
      techList: [
        {
          name: "Monitoring & Alerts",
          icon: "",
          lenguages: [
            { name: "Google Alerts", icon: "" },
            { name: "Brand24", icon: "" },
          ],
        },
        {
          name: "Review Management",
          icon: "",
          lenguages: [
            { name: "Trustpilot", icon: "" },
            { name: "G2", icon: "" },
          ],
        },
        {
          name: "Analytics & Sentiment",
          icon: "",
          lenguages: [
            { name: "Mention", icon: "" },
            { name: "Hootsuite", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description:
        "Common questions about Online Reputation Management services.",
      questions: [
        {
          title: "What is Online Reputation Management?",
          description:
            "ORM focuses on monitoring, influencing, and improving how a brand is perceived online.",
        },
        {
          title: "Can ORM remove negative reviews?",
          description:
            "We focus on addressing concerns professionally and promoting positive content rather than unethical removal.",
        },
        {
          title: "How quickly can ORM show results?",
          description:
            "Some improvements are visible quickly, while long-term trust building takes consistent effort.",
        },
        {
          title: "Do you monitor reviews continuously?",
          description:
            "Yes, we provide ongoing monitoring and alert-based tracking.",
        },
        {
          title: "Is ORM important for small businesses?",
          description:
            "Absolutely, online reputation strongly influences customer trust and purchasing decisions.",
        },
      ],
    },
  },
  "digital-marketing-smo": {
    banner: {
      breadcrumb: "Social Media Optimization (SMO)",
      title: "Building Meaningful Engagement Through",
      highlight: "Social Presence.",
      description:
        "We help brands strengthen their social media presence through strategic Social Media Optimization that improves visibility, engagement, and audience trust across platforms while supporting consistent, long-term digital growth.",
      cta: "Optimize Your Social Media",
      backgroundImage: require("../assets/images/digital-marketing-smo.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Effective social media optimization requires more than frequent posting or visual content. We work closely with marketing and brand teams to understand audience behavior, platform dynamics, and brand voice. Our approach focuses on consistency, relevance, and performance insights to build authentic engagement, improve reach, and ensure social channels support broader marketing and business objectives.",
      milestones: [
        {
          counts: 5,
          description: "Years of Social Media Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Ongoing",
          description: "Social Growth Partnerships",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Social Media Optimization",
      description:
        "Our SMO services cover the full optimization lifecycle, from profile setup and content strategy to engagement management and performance analysis. We focus on aligning content, timing, and interaction strategies with platform algorithms and audience preferences to improve reach, build community, and drive consistent engagement.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Social Media Audit & Assessment",
          icon: "AuditIcon",
          description:
            "We review existing social profiles, content performance, audience engagement, and platform alignment. This assessment identifies strengths, gaps, and opportunities to improve visibility, consistency, and interaction across social channels.",
          bullets: [
            {
              title: "Profile Review",
              text: "Evaluating bios, visuals, and brand consistency.",
            },
            {
              title: "Engagement Analysis",
              text: "Understanding audience interaction patterns.",
            },
          ],
        },
        {
          title: "Content Strategy & Planning",
          icon: "ContentIcon",
          description:
            "We define a structured content strategy that aligns brand messaging with audience interests and platform behavior. Planning ensures content remains consistent, relevant, and engaging without relying on repetitive or generic posts.",
          bullets: [
            {
              title: "Content Themes",
              text: "Defining topics that resonate with audiences.",
            },
            {
              title: "Posting Schedule",
              text: "Optimizing timing for visibility and reach.",
            },
          ],
        },
        {
          title: "Profile & Page Optimization",
          icon: "OptimizationIcon",
          description:
            "Our team optimizes profile elements including descriptions, visuals, highlights, and links to improve discoverability and brand clarity. Optimized profiles help convert profile visits into followers and engaged users.",
          bullets: [
            {
              title: "Keyword Alignment",
              text: "Improving discoverability within platforms.",
            },
            {
              title: "Visual Consistency",
              text: "Creating a cohesive brand appearance.",
            },
          ],
        },
        {
          title: "Community Engagement & Interaction",
          icon: "EngagementIcon",
          description:
            "We manage interactions by responding to comments, messages, and mentions in a timely and brand-aligned manner. Active engagement strengthens relationships, builds trust, and encourages ongoing audience participation.",
          bullets: [
            {
              title: "Audience Interaction",
              text: "Meaningful responses and conversations.",
            },
            {
              title: "Reputation Support",
              text: "Maintaining a positive social presence.",
            },
          ],
        },
        {
          title: "Monitoring, Reporting & Optimization",
          icon: "MonitoringIcon",
          description:
            "We track performance metrics such as reach, engagement, and follower growth to guide continuous optimization. Insights from reporting help refine content strategy and improve results over time.",
          bullets: [
            {
              title: "Performance Tracking",
              text: "Clear visibility into social growth.",
            },
            {
              title: "Ongoing Improvement",
              text: "Data-driven content and engagement refinements.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Turn Social Engagement Into Brand Loyalty",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Optimize Your Social Media",
      title: "Our SMO Process",
      description:
        "A structured process designed to improve visibility, engagement, and brand consistency across social platforms.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description: "Understanding brand voice, audience, and social goals.",
        },
        {
          stepNumberImage: "",
          title: "Audit",
          description:
            "Reviewing profiles, content, and engagement performance.",
        },
        {
          stepNumberImage: "",
          title: "Strategy",
          description: "Defining content direction and engagement approach.",
        },
        {
          stepNumberImage: "",
          title: "Optimization",
          description: "Improving profiles, visuals, and content structure.",
        },
        {
          stepNumberImage: "",
          title: "Engagement",
          description: "Actively interacting with audiences and communities.",
        },
        {
          stepNumberImage: "",
          title: "Measurement",
          description: "Tracking results and refining strategy continuously.",
        },
      ],
    },

    customIndustries: {
      title: "SMO Across Industries",
      description:
        "We optimize social media presence for brands across diverse industries and audience segments.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Social Impact",
      description:
        "Social media optimization focused on engagement, consistency, and brand growth.",
      slides: [
        {
          title: "Higher Engagement",
          subTitle: "Active Communities",
          description:
            "Optimized content and interactions encourage meaningful audience participation.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Social Analytics Tools", image: "" }],
        },
        {
          title: "Improved Visibility",
          subTitle: "Stronger Reach",
          description:
            "Consistent optimization improves discoverability across platforms.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Platform Insights", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We optimize social media with a focus on authenticity, consistency, and measurable engagement.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Audience-Centric",
          text: "Our SMO strategies are designed around real audience behavior and platform-specific expectations.",
        },
        {
          title: "Consistent",
          text: "We maintain brand voice and visual consistency across all social platforms.",
        },
        {
          title: "Insight-Led",
          text: "Decisions are guided by performance data rather than assumptions or trends alone.",
        },
        {
          title: "Experienced",
          text: "Our team has managed and optimized social presence across industries and competitive markets.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Brands trust us to build meaningful and consistent social engagement.",
      clientTestimonails: [
        {
          description:
            "Our social media engagement improved significantly, and our brand voice became much clearer.",
          name: "Rohit M.",
          position: "Marketing Lead",
        },
      ],
    },

    techStacks: {
      title: "SMO Tools & Platforms",
      description:
        "Tools used to manage, analyze, and optimize social media performance.",
      techList: [
        {
          name: "Social Platforms",
          icon: "",
          lenguages: [
            { name: "Facebook", icon: "" },
            { name: "Instagram", icon: "" },
          ],
        },
        {
          name: "Management & Scheduling",
          icon: "",
          lenguages: [
            { name: "Hootsuite", icon: "" },
            { name: "Buffer", icon: "" },
          ],
        },
        {
          name: "Analytics & Insights",
          icon: "",
          lenguages: [
            { name: "Meta Insights", icon: "" },
            { name: "LinkedIn Analytics", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about Social Media Optimization services.",
      questions: [
        {
          title: "What is Social Media Optimization?",
          description:
            "SMO focuses on improving social profiles, content, and engagement to increase visibility and interaction.",
        },
        {
          title: "Is SMO different from social media advertising?",
          description:
            "Yes, SMO focuses on organic growth, while ads provide paid reach.",
        },
        {
          title: "How often should content be posted?",
          description:
            "Posting frequency depends on platform, audience, and content strategy.",
        },
        {
          title: "Do you manage comments and messages?",
          description: "Yes, we support engagement and community interaction.",
        },
        {
          title: "Can SMO support brand awareness?",
          description:
            "Absolutely, consistent optimization helps build long-term brand recognition.",
        },
      ],
    },
  },
  "digital-marketing-smm": {
    banner: {
      breadcrumb: "Social Media Marketing (SMM)",
      title: "Driving Growth Through",
      highlight: "Social Campaigns.",
      description:
        "We help businesses grow brand awareness, engagement, and conversions through strategic Social Media Marketing campaigns that combine creative storytelling, precise targeting, and performance-driven optimization across leading social platforms.",
      cta: "Launch Social Campaigns",
      backgroundImage: require("../assets/images/digital-marketing-smm.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Successful social media marketing requires more than posting ads or boosting content. We work closely with marketing and leadership teams to understand brand goals, audience behavior, and competitive dynamics. Our approach blends creative strategy, audience targeting, and continuous performance analysis to deliver campaigns that feel authentic, drive measurable results, and adapt as platforms and user expectations evolve.",
      milestones: [
        {
          counts: 5,
          description: "Years of Social Marketing Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Ongoing",
          description: "Campaign Optimization Partnerships",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Social Media Marketing",
      description:
        "Our Social Media Marketing services cover the full campaign lifecycle, from strategy and creative development to execution, optimization, and reporting. We focus on building campaigns that resonate with audiences, align with platform algorithms, and deliver consistent returns through data-informed decisions and continuous refinement.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Campaign Strategy & Planning",
          icon: "StrategyIcon",
          description:
            "We define campaign objectives, target audiences, platforms, and success metrics based on business goals. Strategic planning ensures every campaign has clear intent, focused messaging, and measurable outcomes before launch.",
          bullets: [
            {
              title: "Objective Definition",
              text: "Aligning campaigns with business outcomes.",
            },
            {
              title: "Platform Selection",
              text: "Choosing channels that fit audience behavior.",
            },
          ],
        },
        {
          title: "Audience Research & Targeting",
          icon: "AudienceIcon",
          description:
            "Our team researches audience demographics, interests, and behaviors to build precise targeting strategies. This step ensures campaigns reach users most likely to engage, convert, and respond positively to brand messaging.",
          bullets: [
            {
              title: "Audience Segmentation",
              text: "Refining groups based on intent and interests.",
            },
            {
              title: "Lookalike Targeting",
              text: "Expanding reach to similar high-value users.",
            },
          ],
        },
        {
          title: "Creative Development",
          icon: "CreativeIcon",
          description:
            "We design engaging ad creatives, visuals, and messaging tailored to each platform. Creative development focuses on storytelling, clarity, and relevance to capture attention and encourage meaningful interaction.",
          bullets: [
            {
              title: "Ad Copy & Visuals",
              text: "Compelling messaging and design assets.",
            },
            {
              title: "Platform-Specific Formats",
              text: "Optimized creatives for each channel.",
            },
          ],
        },
        {
          title: "Campaign Execution & Management",
          icon: "ExecutionIcon",
          description:
            "We launch and manage campaigns across selected platforms, monitoring performance closely. Active management ensures budgets, bids, and placements are adjusted to maintain efficiency and reach campaign goals.",
          bullets: [
            {
              title: "Live Monitoring",
              text: "Tracking performance in real time.",
            },
            {
              title: "Budget Control",
              text: "Managing spend to maximize impact.",
            },
          ],
        },
        {
          title: "Optimization, Reporting & Scaling",
          icon: "OptimizationIcon",
          description:
            "Campaign performance is continuously analyzed to refine targeting, creatives, and bids. Detailed reporting provides transparency and insights that guide scaling decisions and future campaign improvements.",
          bullets: [
            {
              title: "Performance Analysis",
              text: "Understanding engagement and conversion trends.",
            },
            {
              title: "Scalable Growth",
              text: "Expanding high-performing campaigns strategically.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Turn Social Reach Into Real Results",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Launch Your Social Campaigns",
      title: "Our Social Media Marketing Process",
      description:
        "A structured process designed to deliver measurable results and continuous improvement.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding brand goals, audience, and campaign objectives.",
        },
        {
          stepNumberImage: "",
          title: "Research",
          description:
            "Analyzing audience behavior, competitors, and platforms.",
        },
        {
          stepNumberImage: "",
          title: "Strategy",
          description: "Defining messaging, targeting, and campaign structure.",
        },
        {
          stepNumberImage: "",
          title: "Execution",
          description: "Launching and managing campaigns across platforms.",
        },
        {
          stepNumberImage: "",
          title: "Optimization",
          description: "Refining creatives, targeting, and bids.",
        },
        {
          stepNumberImage: "",
          title: "Reporting & Scaling",
          description: "Measuring performance and expanding what works.",
        },
      ],
    },

    customIndustries: {
      title: "SMM Across Industries",
      description:
        "We manage social media marketing campaigns across diverse industries and audience segments.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Campaign Impact",
      description:
        "Social media marketing focused on awareness, engagement, and conversions.",
      slides: [
        {
          title: "Increased Engagement",
          subTitle: "Active Audiences",
          description:
            "Well-targeted campaigns encourage interaction and brand recall.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Social Ad Platforms", image: "" }],
        },
        {
          title: "Higher Conversions",
          subTitle: "Measurable ROI",
          description:
            "Optimized campaigns drive actions that support business growth.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Conversion Tracking Tools", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver social media marketing with clarity, creativity, and accountability.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Strategy-Led",
          text: "Every campaign is built on clear objectives and a structured strategy aligned with business goals.",
        },
        {
          title: "Creative & Data-Driven",
          text: "We combine creative storytelling with performance data to continuously improve results.",
        },
        {
          title: "Transparent",
          text: "Clear reporting ensures full visibility into performance, spend, and optimization actions.",
        },
        {
          title: "Experienced",
          text: "Our team has managed and scaled social campaigns across industries and platforms.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Brands trust us to deliver impactful social media marketing campaigns.",
      clientTestimonails: [
        {
          description:
            "Our social campaigns delivered strong engagement and measurable leads within weeks.",
          name: "Anjali R.",
          position: "Marketing Head",
        },
      ],
    },

    techStacks: {
      title: "SMM Platforms & Tools",
      description:
        "Trusted platforms and tools used to manage and optimize social campaigns.",
      techList: [
        {
          name: "Advertising Platforms",
          icon: "",
          lenguages: [
            { name: "Meta Ads", icon: "" },
            { name: "LinkedIn Ads", icon: "" },
          ],
        },
        {
          name: "Analytics & Tracking",
          icon: "",
          lenguages: [
            { name: "Google Analytics", icon: "" },
            { name: "Meta Insights", icon: "" },
          ],
        },
        {
          name: "Creative & Management",
          icon: "",
          lenguages: [
            { name: "Canva", icon: "" },
            { name: "Hootsuite", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about Social Media Marketing services.",
      questions: [
        {
          title: "What is Social Media Marketing?",
          description:
            "SMM uses paid and organic campaigns on social platforms to drive awareness, engagement, and conversions.",
        },
        {
          title: "Which platforms do you advertise on?",
          description:
            "We manage campaigns across platforms like Facebook, Instagram, LinkedIn, and others.",
        },
        {
          title: "How do you measure campaign success?",
          description:
            "Success is measured using metrics such as engagement, conversions, and return on ad spend.",
        },
        {
          title: "Can SMM work alongside SEO and PPC?",
          description:
            "Yes, SMM complements other digital marketing channels effectively.",
        },
        {
          title: "Do you provide regular performance reports?",
          description:
            "Yes, we provide detailed and transparent campaign performance reports.",
        },
      ],
    },
  },
  "on-demand-expertise": {
    banner: {
      breadcrumb: "On-Demand Expertise",
      title: "Access Specialized Skills",
      highlight: "Exactly When Needed.",
      description:
        "We help organizations quickly access specialized technology expertise through on-demand staffing models that provide flexibility, speed, and precision, enabling teams to overcome skill gaps, accelerate delivery, and respond effectively to changing project demands.",
      cta: "Access Expert Talent",
      backgroundImage: require("../assets/images/on-demand-expertise.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "On-demand expertise is about agility and accuracy, not just availability. We work closely with engineering leaders and project owners to understand immediate challenges, technical complexity, and delivery expectations. Our approach ensures experts are carefully matched to specific needs, integrate smoothly with existing teams, and deliver value from day one without long-term hiring commitments.",
      milestones: [
        {
          counts: 5,
          description: "Years of Talent Engagement Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Flexible",
          description: "Short & Long-Term Engagements",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End On-Demand Expertise Services",
      description:
        "Our on-demand expertise services cover the full engagement lifecycle, from rapid requirement definition to expert deployment and ongoing performance support. We focus on delivering highly skilled professionals who can step into complex environments quickly, contribute effectively, and help teams move forward without delays or overhead.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Rapid Requirement Definition",
          icon: "AssessmentIcon",
          description:
            "We work with stakeholders to quickly understand skill gaps, project context, and expected outcomes. Clear definition ensures the right expert is selected without delays or misalignment.",
          bullets: [
            {
              title: "Skill Gap Analysis",
              text: "Identifying precise technical or domain needs.",
            },
            {
              title: "Engagement Scope",
              text: "Clarifying duration and responsibilities.",
            },
          ],
        },
        {
          title: "Expert Identification & Matching",
          icon: "MatchingIcon",
          description:
            "Our team identifies and matches specialists from our vetted talent network based on expertise, availability, and project relevance. This ensures a strong fit for both technical and collaborative requirements.",
          bullets: [
            {
              title: "Vetted Specialists",
              text: "Experienced professionals across domains.",
            },
            {
              title: "Precise Matching",
              text: "Aligning skills with project challenges.",
            },
          ],
        },
        {
          title: "Fast Deployment",
          icon: "DeploymentIcon",
          description:
            "Selected experts are deployed quickly to minimize downtime and maintain project momentum. Our process reduces onboarding friction and enables immediate contribution.",
          bullets: [
            {
              title: "Quick Start",
              text: "Minimal ramp-up time.",
            },
            {
              title: "Seamless Integration",
              text: "Alignment with existing workflows.",
            },
          ],
        },
        {
          title: "Collaboration & Delivery Support",
          icon: "CollaborationIcon",
          description:
            "We ensure experts collaborate effectively with in-house teams, contributing knowledge and delivering results while respecting existing processes and team culture.",
          bullets: [
            {
              title: "Team Alignment",
              text: "Smooth collaboration with internal teams.",
            },
            {
              title: "Knowledge Sharing",
              text: "Transferring expertise and best practices.",
            },
          ],
        },
        {
          title: "Ongoing Oversight & Flexibility",
          icon: "SupportIcon",
          description:
            "Throughout the engagement, we provide oversight, performance check-ins, and flexibility to scale expertise up or down as project needs change.",
          bullets: [
            {
              title: "Performance Check-Ins",
              text: "Ensuring expectations are met consistently.",
            },
            {
              title: "Adaptive Scaling",
              text: "Adjusting expertise as priorities evolve.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Solve Complex Challenges Without Long-Term Hiring",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Deploy the Right Expert",
      title: "Our On-Demand Expertise Process",
      description:
        "A streamlined process designed to deliver specialized skills quickly and effectively.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding immediate challenges and expertise requirements.",
        },
        {
          stepNumberImage: "",
          title: "Requirement Definition",
          description: "Clarifying scope, skills, and engagement duration.",
        },
        {
          stepNumberImage: "",
          title: "Expert Matching",
          description: "Identifying the most suitable specialist.",
        },
        {
          stepNumberImage: "",
          title: "Deployment",
          description: "Introducing the expert into your team and workflow.",
        },
        {
          stepNumberImage: "",
          title: "Collaboration",
          description: "Ensuring effective contribution and team alignment.",
        },
        {
          stepNumberImage: "",
          title: "Review & Adjustment",
          description:
            "Evaluating performance and adapting engagement as needed.",
        },
      ],
    },

    customIndustries: {
      title: "On-Demand Expertise Across Industries",
      description:
        "We provide specialized expertise to organizations across diverse industries and technical environments.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Engagement Impact",
      description:
        "On-demand expertise that delivers speed, precision, and flexibility.",
      slides: [
        {
          title: "Immediate Skill Access",
          subTitle: "No Hiring Delays",
          description:
            "Specialized expertise becomes available exactly when needed.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Vetted Talent Networks", image: "" }],
        },
        {
          title: "Operational Flexibility",
          subTitle: "Adaptive Scaling",
          description:
            "Expert resources scale with evolving project requirements.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [
            { title: "Flexible Engagement Models", image: "" },
          ],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver on-demand expertise with speed, accuracy, and accountability.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Precision Matching",
          text: "Experts are selected based on precise technical and domain alignment rather than general availability.",
        },
        {
          title: "Rapid Access",
          text: "Our streamlined processes ensure minimal delay between request and deployment.",
        },
        {
          title: "Flexible Engagement",
          text: "Engagement models adapt easily to short-term or evolving needs without rigid commitments.",
        },
        {
          title: "Experienced Network",
          text: "Our talent pool includes seasoned professionals with real-world, production-level experience.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Teams trust us to deliver the right expertise exactly when it matters.",
      clientTestimonails: [
        {
          description:
            "The on-demand expert integrated quickly and solved complex issues without slowing our roadmap.",
          name: "Karan V.",
          position: "Engineering Manager",
        },
      ],
    },

    techStacks: {
      title: "Expertise Areas We Support",
      description: "Broad technical and domain expertise available on-demand.",
      techList: [
        {
          name: "Software Engineering",
          icon: "",
          lenguages: [
            { name: "Java", icon: "" },
            { name: "Node.js", icon: "" },
          ],
        },
        {
          name: "Cloud & DevOps",
          icon: "",
          lenguages: [
            { name: "AWS", icon: "" },
            { name: "Kubernetes", icon: "" },
          ],
        },
        {
          name: "Data & Quality",
          icon: "",
          lenguages: [
            { name: "Python", icon: "" },
            { name: "Automation Testing", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about on-demand expertise services.",
      questions: [
        {
          title: "What is on-demand expertise?",
          description:
            "It provides immediate access to specialized professionals without long-term hiring commitments.",
        },
        {
          title: "How quickly can experts be deployed?",
          description:
            "Experts can often be deployed within days, depending on requirements.",
        },
        {
          title: "Can engagement duration be adjusted?",
          description:
            "Yes, engagements are flexible and can scale up or down as needed.",
        },
        {
          title: "Do experts work with in-house teams?",
          description:
            "Absolutely, experts collaborate closely with existing teams.",
        },
        {
          title: "Is this suitable for short-term challenges?",
          description:
            "Yes, on-demand expertise is ideal for short-term or specialized needs.",
        },
      ],
    },
  },
  "it-staffing-solutions": {
    banner: {
      breadcrumb: "IT Staffing Solutions",
      title: "Strengthening Teams With",
      highlight: "Skilled IT Talent.",
      description:
        "We help organizations scale their technology teams quickly and efficiently through flexible IT staffing solutions that provide access to experienced professionals aligned with your technical needs, project timelines, and business goals.",
      cta: "Hire IT Talent",
      backgroundImage: require("../assets/images/it-staffing-solutions.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Effective IT staffing is about more than filling roles, it is about finding the right talent at the right time. We work closely with hiring managers, delivery teams, and leadership to understand technical requirements, team dynamics, and project objectives. Our approach ensures candidates are technically capable, culturally aligned, and ready to contribute immediately, helping organizations maintain momentum without long-term hiring risk.",
      milestones: [
        {
          counts: 5,
          description: "Years of Staffing Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Ongoing",
          description: "Talent Engagements",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End IT Staffing Services",
      description:
        "Our IT staffing services support the complete talent engagement lifecycle, from requirement analysis and candidate sourcing to onboarding and ongoing performance support. We focus on delivering skilled professionals who integrate seamlessly into your teams, helping you scale capacity, accelerate delivery, and respond quickly to changing business demands.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Requirement Analysis",
          icon: "AssessmentIcon",
          description:
            "We work with stakeholders to understand technical needs, project scope, and team expectations. Clear requirement analysis ensures we identify candidates with the right skills, experience level, and availability.",
          bullets: [
            {
              title: "Skill Mapping",
              text: "Defining required technical and domain expertise.",
            },
            {
              title: "Engagement Clarity",
              text: "Aligning timelines and working models.",
            },
          ],
        },
        {
          title: "Talent Sourcing & Screening",
          icon: "SourcingIcon",
          description:
            "Our recruitment team sources candidates from a wide talent pool and conducts thorough technical and behavioral screening. This process ensures only qualified professionals are presented for consideration.",
          bullets: [
            {
              title: "Technical Evaluation",
              text: "Assessing skills and real-world experience.",
            },
            {
              title: "Cultural Fit",
              text: "Ensuring alignment with team dynamics.",
            },
          ],
        },
        {
          title: "Candidate Shortlisting & Selection",
          icon: "SelectionIcon",
          description:
            "We present carefully shortlisted candidates and support the interview and selection process. Feedback loops help refine choices and ensure the best match for your project or team.",
          bullets: [
            {
              title: "Shortlist Curation",
              text: "Presenting high-quality candidate profiles.",
            },
            {
              title: "Interview Coordination",
              text: "Streamlining selection workflows.",
            },
          ],
        },
        {
          title: "Onboarding & Integration",
          icon: "OnboardingIcon",
          description:
            "We support smooth onboarding and integration of selected professionals into your teams. This ensures minimal ramp-up time and immediate contribution to ongoing work.",
          bullets: [
            {
              title: "Quick Onboarding",
              text: "Reducing time to productivity.",
            },
            {
              title: "Team Integration",
              text: "Aligning with tools and processes.",
            },
          ],
        },
        {
          title: "Ongoing Support & Engagement",
          icon: "SupportIcon",
          description:
            "Throughout the engagement, we provide performance check-ins, contract management, and replacement support if needed. Continuous engagement ensures long-term success and flexibility.",
          bullets: [
            {
              title: "Performance Monitoring",
              text: "Ensuring consistent delivery and alignment.",
            },
            {
              title: "Flexible Scaling",
              text: "Adjusting team size as needs evolve.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Scale Your Team Without Hiring Delays",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Strengthen Your Team",
      title: "Our IT Staffing Process",
      description:
        "A structured staffing process designed for speed, quality, and flexibility.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding technical needs, timelines, and engagement models.",
        },
        {
          stepNumberImage: "",
          title: "Requirement Definition",
          description: "Finalizing role expectations and skill requirements.",
        },
        {
          stepNumberImage: "",
          title: "Sourcing",
          description:
            "Identifying suitable candidates from our talent network.",
        },
        {
          stepNumberImage: "",
          title: "Screening",
          description: "Evaluating technical skills and experience.",
        },
        {
          stepNumberImage: "",
          title: "Selection",
          description: "Supporting interviews and final candidate selection.",
        },
        {
          stepNumberImage: "",
          title: "Onboarding & Support",
          description: "Ensuring smooth integration and ongoing engagement.",
        },
      ],
    },

    customIndustries: {
      title: "IT Staffing Across Industries",
      description:
        "We provide IT staffing solutions for organizations across diverse industries and domains.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Staffing Impact",
      description:
        "IT staffing solutions that improve delivery speed, flexibility, and team efficiency.",
      slides: [
        {
          title: "Faster Team Scaling",
          subTitle: "Reduced Hiring Time",
          description:
            "Quick access to skilled professionals accelerates project execution.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Talent Networks", image: "" }],
        },
        {
          title: "Cost Efficiency",
          subTitle: "Flexible Engagement",
          description:
            "Staff augmentation reduces long-term hiring costs and risk.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Flexible Staffing Models", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver IT staffing solutions with speed, reliability, and transparency.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Quality-Focused",
          text: "We prioritize candidate quality through rigorous screening and technical evaluation processes.",
        },
        {
          title: "Flexible Models",
          text: "Our engagement models adapt to short-term, long-term, and project-based needs.",
        },
        {
          title: "Fast Turnaround",
          text: "Efficient sourcing processes help fill roles quickly without compromising standards.",
        },
        {
          title: "Experienced",
          text: "Our team has extensive experience supporting staffing needs across technologies and industries.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Organizations trust us to deliver reliable and skilled IT professionals.",
      clientTestimonails: [
        {
          description:
            "The staffing support helped us scale our team quickly without compromising quality.",
          name: "Vikram T.",
          position: "Delivery Manager",
        },
      ],
    },

    techStacks: {
      title: "Skills & Technologies We Support",
      description:
        "Wide-ranging technical expertise available through our IT staffing services.",
      techList: [
        {
          name: "Software Development",
          icon: "",
          lenguages: [
            { name: "Java", icon: "" },
            { name: "Node.js", icon: "" },
          ],
        },
        {
          name: "Cloud & DevOps",
          icon: "",
          lenguages: [
            { name: "AWS", icon: "" },
            { name: "Docker", icon: "" },
          ],
        },
        {
          name: "Data & QA",
          icon: "",
          lenguages: [
            { name: "Python", icon: "" },
            { name: "Selenium", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description:
        "Common questions about IT staffing and staff augmentation services.",
      questions: [
        {
          title: "What is IT staff augmentation?",
          description:
            "It is a flexible model that allows businesses to extend their teams with skilled professionals.",
        },
        {
          title: "How quickly can you provide candidates?",
          description:
            "Depending on requirements, candidates can be available within days.",
        },
        {
          title: "Can we scale the team up or down?",
          description: "Yes, our staffing models are designed for flexibility.",
        },
        {
          title: "Do you offer short-term and long-term staffing?",
          description:
            "Yes, we support both project-based and long-term engagements.",
        },
        {
          title: "Do you handle onboarding and support?",
          description:
            "Yes, we assist with onboarding and provide ongoing engagement support.",
        },
      ],
    },
  },
  "skills-gap-analysis": {
    banner: {
      breadcrumb: "Skills Gap Analysis",
      title: "Identifying Talent Gaps To",
      highlight: "Strengthen Teams.",
      description:
        "We help organizations assess existing team capabilities and identify critical skill gaps through structured Skills Gap Analysis, enabling informed staffing decisions, targeted upskilling, and more effective use of staff augmentation strategies.",
      cta: "Analyze Team Skills",
      backgroundImage: require("../assets/images/skills-gap-analysis.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Understanding skill gaps requires more than reviewing resumes or role titles. We work closely with leadership, HR, and technical teams to evaluate real-world capabilities, workload demands, and future goals. Our approach combines qualitative insights with structured analysis to uncover hidden gaps, reduce delivery risk, and create clear action plans for hiring, augmentation, or training that support long-term organizational growth.",
      milestones: [
        {
          counts: 5,
          description: "Years of Workforce Analysis Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Actionable",
          description: "Skill Gap Reports Delivered",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Skills Gap Analysis",
      description:
        "Our skills gap analysis services cover the complete evaluation lifecycle, from understanding business objectives to assessing technical and functional capabilities and defining improvement strategies. We focus on delivering clear insights that help organizations decide whether to hire, upskill, or use staff augmentation to close gaps efficiently and sustainably.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Business & Delivery Alignment",
          icon: "AssessmentIcon",
          description:
            "We begin by understanding business goals, delivery timelines, and upcoming initiatives. This context ensures the skills assessment focuses on capabilities that directly impact execution, scalability, and future readiness rather than generic role requirements.",
          bullets: [
            {
              title: "Goal Mapping",
              text: "Aligning skill needs with business objectives.",
            },
            {
              title: "Delivery Priorities",
              text: "Identifying critical upcoming demands.",
            },
          ],
        },
        {
          title: "Current Skill Assessment",
          icon: "EvaluationIcon",
          description:
            "We assess existing team skills through interviews, role analysis, and performance review inputs. This step reveals actual competency levels, overlaps, and areas where reliance on a few individuals creates operational risk.",
          bullets: [
            {
              title: "Capability Review",
              text: "Evaluating real-world technical proficiency.",
            },
            {
              title: "Risk Identification",
              text: "Highlighting single points of failure.",
            },
          ],
        },
        {
          title: "Gap Identification & Prioritization",
          icon: "GapIcon",
          description:
            "Identified gaps are mapped against business impact and urgency. This prioritization helps teams focus on the most critical shortages that could affect timelines, quality, or system stability.",
          bullets: [
            {
              title: "Impact Analysis",
              text: "Understanding consequences of missing skills.",
            },
            {
              title: "Priority Ranking",
              text: "Focusing on high-risk gaps first.",
            },
          ],
        },
        {
          title: "Augmentation & Upskilling Strategy",
          icon: "StrategyIcon",
          description:
            "We recommend the most effective approach to address each gap, whether through staff augmentation, targeted hiring, or internal upskilling. Strategies are designed to balance speed, cost, and long-term capability building.",
          bullets: [
            {
              title: "Staff Augmentation",
              text: "Short-term expertise to fill immediate gaps.",
            },
            {
              title: "Upskilling Paths",
              text: "Developing internal capabilities over time.",
            },
          ],
        },
        {
          title: "Action Plan & Ongoing Review",
          icon: "PlanningIcon",
          description:
            "A clear action plan outlines next steps, timelines, and success metrics. We also support periodic reviews to ensure skill alignment remains relevant as projects, technologies, and priorities evolve.",
          bullets: [
            {
              title: "Clear Roadmap",
              text: "Structured plan for closing gaps.",
            },
            {
              title: "Continuous Alignment",
              text: "Reassessing skills as needs change.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Make Smarter Staffing Decisions With Clarity",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Analyze Your Team Skills",
      title: "Our Skills Gap Analysis Process",
      description:
        "A structured process designed to deliver clarity, prioritization, and actionable outcomes.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding business goals, teams, and delivery expectations.",
        },
        {
          stepNumberImage: "",
          title: "Assessment",
          description:
            "Evaluating current technical and functional capabilities.",
        },
        {
          stepNumberImage: "",
          title: "Gap Mapping",
          description: "Identifying missing or underdeveloped skills.",
        },
        {
          stepNumberImage: "",
          title: "Prioritization",
          description: "Ranking gaps based on risk and business impact.",
        },
        {
          stepNumberImage: "",
          title: "Strategy Definition",
          description: "Defining augmentation, hiring, or training approaches.",
        },
        {
          stepNumberImage: "",
          title: "Review & Adjustment",
          description: "Reassessing skills as projects and goals evolve.",
        },
      ],
    },

    customIndustries: {
      title: "Skills Gap Analysis Across Industries",
      description:
        "We conduct skills gap assessments for teams across a wide range of industries and delivery models.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Analysis Impact",
      description:
        "Skills gap analysis that drives informed decisions and stronger team performance.",
      slides: [
        {
          title: "Clear Skill Visibility",
          subTitle: "Informed Decisions",
          description:
            "Teams gain clarity into strengths, weaknesses, and risk areas.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Assessment Frameworks", image: "" }],
        },
        {
          title: "Improved Resource Planning",
          subTitle: "Reduced Risk",
          description:
            "Better planning reduces delays caused by missing expertise.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Workforce Planning Models", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver skills gap analysis with depth, objectivity, and practical outcomes.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Objective Assessment",
          text: "Our evaluations focus on actual capabilities and delivery needs rather than assumptions or job titles.",
        },
        {
          title: "Action-Oriented",
          text: "Every insight is paired with clear, practical recommendations for closing gaps.",
        },
        {
          title: "Business-Aligned",
          text: "Skill analysis is directly linked to business goals, timelines, and risk reduction.",
        },
        {
          title: "Experienced",
          text: "Our team has assessed diverse teams across technologies, industries, and delivery models.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Organizations trust us to bring clarity to complex staffing decisions.",
      clientTestimonails: [
        {
          description:
            "The skills gap analysis helped us clearly understand where to augment and where to upskill our team.",
          name: "Manish K.",
          position: "Operations Head",
        },
      ],
    },

    techStacks: {
      title: "Skill Areas We Assess",
      description:
        "Technical and functional domains commonly included in skills gap analysis.",
      techList: [
        {
          name: "Software Development",
          icon: "",
          lenguages: [
            { name: "Java", icon: "" },
            { name: "JavaScript", icon: "" },
          ],
        },
        {
          name: "Cloud & DevOps",
          icon: "",
          lenguages: [
            { name: "AWS", icon: "" },
            { name: "CI/CD", icon: "" },
          ],
        },
        {
          name: "Quality & Data",
          icon: "",
          lenguages: [
            { name: "Automation Testing", icon: "" },
            { name: "Data Analysis", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about skills gap analysis services.",
      questions: [
        {
          title: "What is skills gap analysis?",
          description:
            "It evaluates current team capabilities against business and delivery requirements.",
        },
        {
          title: "Who should use skills gap analysis?",
          description:
            "It is useful for growing teams, transformation initiatives, and delivery-critical projects.",
        },
        {
          title: "Can this support staff augmentation decisions?",
          description:
            "Yes, it helps identify where external expertise is needed most.",
        },
        {
          title: "Do you assess both technical and functional skills?",
          description:
            "Yes, assessments can include technical, domain, and process-related skills.",
        },
        {
          title: "Is skills gap analysis a one-time activity?",
          description:
            "It can be repeated periodically as teams and goals evolve.",
        },
      ],
    },
  },
  "project-based-augmentation": {
    banner: {
      breadcrumb: "Project-Based Augmentation",
      title: "Scaling Delivery Through",
      highlight: "Focused Project Teams.",
      description:
        "We help organizations deliver projects on time and with confidence through project-based staff augmentation that provides dedicated, outcome-focused talent aligned to specific goals, timelines, and technical requirements.",
      cta: "Augment Your Project Team",
      backgroundImage: require("../assets/images/project-based-augmentation.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Project-based augmentation demands clarity, accountability, and strong execution. We work closely with stakeholders to understand project scope, technical complexity, and delivery milestones. Our approach ensures the right mix of skills is assigned to each phase, resources integrate smoothly with internal teams, and delivery momentum is maintained without the overhead of permanent hiring or long-term commitments.",
      milestones: [
        {
          counts: 5,
          description: "Years of Project Delivery Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Outcome-Focused",
          description: "Project Engagement Models",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Project-Based Augmentation",
      description:
        "Our project-based augmentation services support the entire project lifecycle, from early planning and skill alignment to execution and completion. We focus on providing dedicated professionals who work exclusively on defined project goals, ensuring accountability, efficiency, and consistent progress from start to finish.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Project Scope & Requirement Alignment",
          icon: "AssessmentIcon",
          description:
            "We begin by understanding project objectives, timelines, and technical requirements in detail. This alignment ensures the right skills and roles are defined clearly before team augmentation begins.",
          bullets: [
            {
              title: "Scope Definition",
              text: "Clarifying deliverables and success criteria.",
            },
            {
              title: "Skill Mapping",
              text: "Identifying expertise needed for each phase.",
            },
          ],
        },
        {
          title: "Team Composition & Planning",
          icon: "PlanningIcon",
          description:
            "Based on project needs, we assemble a focused team with complementary skills. Planning ensures balanced workloads, clear responsibilities, and effective collaboration across all project stages.",
          bullets: [
            {
              title: "Role Assignment",
              text: "Defining responsibilities and ownership.",
            },
            {
              title: "Capacity Planning",
              text: "Aligning resources with timelines.",
            },
          ],
        },
        {
          title: "Talent Deployment",
          icon: "DeploymentIcon",
          description:
            "Selected professionals are deployed to work exclusively on the project. Fast onboarding and alignment with tools and processes help maintain delivery momentum.",
          bullets: [
            {
              title: "Quick Onboarding",
              text: "Minimizing ramp-up time.",
            },
            {
              title: "Tool Alignment",
              text: "Integrating with project workflows.",
            },
          ],
        },
        {
          title: "Execution & Collaboration",
          icon: "ExecutionIcon",
          description:
            "Augmented team members collaborate closely with internal stakeholders to execute tasks, resolve challenges, and meet milestones. Clear communication supports consistent progress and quality.",
          bullets: [
            {
              title: "Milestone Tracking",
              text: "Ensuring progress against plans.",
            },
            {
              title: "Cross-Team Coordination",
              text: "Maintaining alignment across teams.",
            },
          ],
        },
        {
          title: "Completion & Knowledge Transition",
          icon: "TransitionIcon",
          description:
            "At project completion, we support smooth handover and knowledge transfer. This ensures continuity and prepares internal teams for ongoing maintenance or future phases.",
          bullets: [
            {
              title: "Knowledge Transfer",
              text: "Sharing documentation and insights.",
            },
            {
              title: "Post-Project Support",
              text: "Ensuring stable transition.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Deliver Projects Without Staffing Bottlenecks",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Strengthen Your Project Team",
      title: "Our Project-Based Augmentation Process",
      description:
        "A structured process designed to support focused delivery and predictable outcomes.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description: "Understanding project goals, scope, and timelines.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Defining team structure and resource needs.",
        },
        {
          stepNumberImage: "",
          title: "Team Setup",
          description: "Assembling and aligning the project team.",
        },
        {
          stepNumberImage: "",
          title: "Execution",
          description: "Delivering tasks and milestones collaboratively.",
        },
        {
          stepNumberImage: "",
          title: "Monitoring",
          description: "Tracking progress and resolving issues.",
        },
        {
          stepNumberImage: "",
          title: "Completion",
          description: "Final delivery and knowledge transition.",
        },
      ],
    },

    customIndustries: {
      title: "Project-Based Augmentation Across Industries",
      description:
        "We support project delivery across industries with varying complexity and scale.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Delivery Impact",
      description:
        "Project-based augmentation that improves focus, accountability, and delivery speed.",
      slides: [
        {
          title: "Predictable Delivery",
          subTitle: "Clear Outcomes",
          description:
            "Dedicated project teams improve focus and milestone achievement.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [
            { title: "Project Management Frameworks", image: "" },
          ],
        },
        {
          title: "Reduced Resource Risk",
          subTitle: "Flexible Scaling",
          description:
            "Teams can scale based on project phase without long-term commitments.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Flexible Staffing Models", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver project-based augmentation with structure, accountability, and execution focus.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Outcome-Oriented",
          text: "Every engagement is structured around clear deliverables and success metrics.",
        },
        {
          title: "Seamless Integration",
          text: "Augmented teams work closely with internal stakeholders and existing processes.",
        },
        {
          title: "Flexible Engagement",
          text: "Team size and composition adapt to project phases and priorities.",
        },
        {
          title: "Experienced",
          text: "Our professionals bring hands-on project delivery experience across industries.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Teams rely on us to support complex projects without staffing delays.",
      clientTestimonails: [
        {
          description:
            "The augmented team helped us meet tight deadlines without compromising quality.",
          name: "Ravi P.",
          position: "Program Manager",
        },
      ],
    },

    techStacks: {
      title: "Project Skills We Support",
      description:
        "Technical and functional expertise available for project-based augmentation.",
      techList: [
        {
          name: "Software Development",
          icon: "",
          lenguages: [
            { name: "Java", icon: "" },
            { name: "JavaScript", icon: "" },
          ],
        },
        {
          name: "Cloud & DevOps",
          icon: "",
          lenguages: [
            { name: "AWS", icon: "" },
            { name: "CI/CD", icon: "" },
          ],
        },
        {
          name: "Quality & Testing",
          icon: "",
          lenguages: [
            { name: "Automation Testing", icon: "" },
            { name: "Manual QA", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description:
        "Common questions about project-based staff augmentation services.",
      questions: [
        {
          title: "What is project-based augmentation?",
          description:
            "It provides dedicated professionals focused on delivering a specific project or initiative.",
        },
        {
          title: "How is this different from regular staff augmentation?",
          description:
            "Project-based augmentation is structured around defined outcomes and timelines.",
        },
        {
          title: "Can team size change during the project?",
          description:
            "Yes, teams can scale based on project phase and requirements.",
        },
        {
          title: "Do augmented teams work with in-house staff?",
          description: "Yes, they collaborate closely with internal teams.",
        },
        {
          title: "Is knowledge transfer included?",
          description:
            "Yes, we support documentation and smooth handover at project completion.",
        },
      ],
    },
  },
  "team-expansion": {
    banner: {
      breadcrumb: "Team Expansion",
      title: "Scaling Your Workforce With",
      highlight: "Confidence And Speed.",
      description:
        "We help organizations expand their teams seamlessly through structured team expansion services that provide skilled professionals aligned with your culture, processes, and long-term objectives, enabling growth without disrupting delivery momentum.",
      cta: "Expand Your Team",
      backgroundImage: require("../assets/images/team-expansion.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Team expansion requires careful balance between speed and stability. We work closely with leadership and delivery teams to understand growth goals, existing workflows, and collaboration styles. Our approach ensures new team members integrate smoothly, contribute effectively, and strengthen overall team performance while maintaining consistency, accountability, and long-term operational continuity across expanding teams.",
      milestones: [
        {
          counts: 5,
          description: "Years of Team Scaling Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Sustained",
          description: "Long-Term Team Expansions",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Team Expansion Services",
      description:
        "Our team expansion services support organizations through every stage of growth, from understanding workforce needs to onboarding and continuous engagement. We focus on adding the right talent at the right pace, ensuring expanded teams remain productive, aligned, and capable of handling increased workloads without compromising quality or collaboration.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Growth Requirement Assessment",
          icon: "AssessmentIcon",
          description:
            "We analyze business growth plans, delivery forecasts, and team capacity to define expansion requirements clearly. This ensures hiring and augmentation efforts align with realistic timelines and workload expectations.",
          bullets: [
            {
              title: "Capacity Evaluation",
              text: "Understanding current workload and future demand.",
            },
            {
              title: "Role Definition",
              text: "Clarifying responsibilities and expectations.",
            },
          ],
        },
        {
          title: "Talent Planning & Role Mapping",
          icon: "PlanningIcon",
          description:
            "Based on assessment outcomes, we map required roles, skill levels, and team structure. Thoughtful planning ensures new members complement existing teams and support sustainable growth.",
          bullets: [
            {
              title: "Skill Alignment",
              text: "Matching expertise with team needs.",
            },
            {
              title: "Balanced Team Structure",
              text: "Maintaining effective collaboration dynamics.",
            },
          ],
        },
        {
          title: "Talent Sourcing & Selection",
          icon: "SourcingIcon",
          description:
            "We source, screen, and shortlist candidates who meet technical, cultural, and collaboration requirements. This process prioritizes long-term fit and consistent contribution over rapid placement alone.",
          bullets: [
            {
              title: "Technical Screening",
              text: "Evaluating practical skill proficiency.",
            },
            {
              title: "Cultural Fit",
              text: "Ensuring alignment with team values.",
            },
          ],
        },
        {
          title: "Onboarding & Integration",
          icon: "OnboardingIcon",
          description:
            "We support smooth onboarding and integration into existing workflows, tools, and communication practices. Proper onboarding reduces ramp-up time and builds confidence for new team members.",
          bullets: [
            {
              title: "Process Alignment",
              text: "Adapting to internal tools and workflows.",
            },
            {
              title: "Team Collaboration",
              text: "Encouraging early engagement and contribution.",
            },
          ],
        },
        {
          title: "Ongoing Support & Optimization",
          icon: "SupportIcon",
          description:
            "As teams expand, we provide ongoing engagement support, performance check-ins, and flexibility to adjust team composition. Continuous oversight ensures expansion remains effective as needs evolve.",
          bullets: [
            {
              title: "Performance Monitoring",
              text: "Ensuring consistent delivery standards.",
            },
            {
              title: "Scalable Adjustments",
              text: "Adapting team size and roles over time.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Grow Your Team Without Slowing Delivery",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Expand Your Team",
      title: "Our Team Expansion Process",
      description:
        "A structured process designed to support sustainable growth and seamless team integration.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding growth goals, timelines, and team structure.",
        },
        {
          stepNumberImage: "",
          title: "Assessment",
          description: "Evaluating current capacity and expansion needs.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Defining roles, skills, and onboarding approach.",
        },
        {
          stepNumberImage: "",
          title: "Sourcing",
          description: "Identifying and screening suitable professionals.",
        },
        {
          stepNumberImage: "",
          title: "Onboarding",
          description: "Integrating new members into teams and workflows.",
        },
        {
          stepNumberImage: "",
          title: "Support & Review",
          description:
            "Monitoring performance and adjusting expansion strategy.",
        },
      ],
    },

    customIndustries: {
      title: "Team Expansion Across Industries",
      description:
        "We support team growth for organizations across diverse industries and delivery models.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Expansion Impact",
      description:
        "Team expansion strategies that support growth, stability, and delivery confidence.",
      slides: [
        {
          title: "Sustained Productivity",
          subTitle: "Balanced Growth",
          description:
            "Well-planned expansion prevents productivity drops during scaling.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [
            { title: "Workforce Planning Frameworks", image: "" },
          ],
        },
        {
          title: "Reduced Hiring Risk",
          subTitle: "Flexible Growth",
          description:
            "Scalable engagement models reduce long-term hiring uncertainty.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Flexible Staffing Models", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We support team expansion with structure, care, and long-term perspective.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Growth-Aligned",
          text: "Expansion strategies are aligned with business growth plans and delivery realities.",
        },
        {
          title: "Seamless Integration",
          text: "New team members integrate smoothly into existing workflows and culture.",
        },
        {
          title: "Flexible Scaling",
          text: "Team size and composition can adapt as priorities and workloads change.",
        },
        {
          title: "Experienced",
          text: "Our team has supported expansion initiatives across industries and team sizes.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Organizations rely on us to scale teams without disruption.",
      clientTestimonails: [
        {
          description:
            "Team expansion was smooth, and new members contributed effectively from the start.",
          name: "Ankit R.",
          position: "Engineering Director",
        },
      ],
    },

    techStacks: {
      title: "Skills We Support For Team Expansion",
      description:
        "Technical and functional expertise commonly added during team expansion initiatives.",
      techList: [
        {
          name: "Software Development",
          icon: "",
          lenguages: [
            { name: "Java", icon: "" },
            { name: "JavaScript", icon: "" },
          ],
        },
        {
          name: "Cloud & DevOps",
          icon: "",
          lenguages: [
            { name: "AWS", icon: "" },
            { name: "CI/CD", icon: "" },
          ],
        },
        {
          name: "Quality & Support",
          icon: "",
          lenguages: [
            { name: "Automation Testing", icon: "" },
            { name: "Application Support", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about team expansion services.",
      questions: [
        {
          title: "What is team expansion?",
          description:
            "It involves adding skilled professionals to existing teams to support growth and increased workload.",
        },
        {
          title: "How is team expansion different from hiring?",
          description:
            "Team expansion offers flexible, scalable talent without long-term hiring commitments.",
        },
        {
          title: "Can expanded teams work with in-house staff?",
          description:
            "Yes, new members collaborate closely with existing teams.",
        },
        {
          title: "Can team size be adjusted later?",
          description:
            "Yes, team composition can scale up or down as needs change.",
        },
        {
          title: "Do you support long-term team growth?",
          description:
            "Yes, we support both short-term and long-term expansion initiatives.",
        },
      ],
    },
  },
  "android-app-development": {
    banner: {
      breadcrumb: "Android App Development",
      title: "Building Scalable And Engaging",
      highlight: "Android Applications.",
      description:
        "We design and develop high-performance Android applications tailored to your business goals, delivering seamless user experiences, strong security standards, and scalable architecture across smartphones, tablets, and Android-powered devices.",
      cta: "Build Your Android App",
      backgroundImage: require("../assets/images/android-app-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Successful Android app development requires a balance of user-centric design, reliable engineering, and platform expertise. We collaborate closely with founders, product teams, and stakeholders to understand business objectives, audience expectations, and technical constraints. Our approach focuses on building stable, responsive, and secure Android applications that perform consistently across devices, adapt to OS updates, and support long-term feature expansion without performance trade-offs.",
      milestones: [
        {
          counts: 5,
          description: "Years of Mobile Development Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Ongoing",
          description: "Product Support Engagements",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Android App Development",
      description:
        "Our Android development services cover the complete application lifecycle, from concept validation and UI design to coding, testing, deployment, and continuous improvement. We focus on creating secure, scalable, and user-friendly Android apps that meet business objectives while maintaining strong performance and usability across different devices and Android versions.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Product Discovery & Planning",
          icon: "DiscoveryIcon",
          description:
            "We begin by understanding your target users, app objectives, and technical requirements. Clear planning ensures the application architecture and feature set align with business strategy and long-term scalability goals.",
          bullets: [
            {
              title: "Requirement Analysis",
              text: "Defining features and technical needs.",
            },
            {
              title: "Architecture Planning",
              text: "Designing a scalable app foundation.",
            },
          ],
        },
        {
          title: "UI/UX Design",
          icon: "DesignIcon",
          description:
            "Our design team creates intuitive interfaces aligned with Android design guidelines. User experience is optimized for clarity, smooth navigation, and consistent interaction across various screen sizes.",
          bullets: [
            {
              title: "User-Centered Design",
              text: "Focusing on usability and accessibility.",
            },
            {
              title: "Responsive Layouts",
              text: "Optimized for diverse Android devices.",
            },
          ],
        },
        {
          title: "Native Android Development",
          icon: "DevelopmentIcon",
          description:
            "We develop Android apps using modern frameworks and best practices, ensuring clean code, efficient performance, and strong security. Development prioritizes stability and maintainability.",
          bullets: [
            {
              title: "Kotlin & Java",
              text: "Using proven Android technologies.",
            },
            {
              title: "Performance Optimization",
              text: "Ensuring smooth and responsive operation.",
            },
          ],
        },
        {
          title: "Integration & Testing",
          icon: "TestingIcon",
          description:
            "We integrate APIs, third-party services, and backend systems while conducting rigorous testing. Functional, usability, and device compatibility testing ensure reliable performance before launch.",
          bullets: [
            {
              title: "API Integration",
              text: "Connecting with backend and services.",
            },
            {
              title: "Quality Assurance",
              text: "Validating stability across devices.",
            },
          ],
        },
        {
          title: "Deployment & Ongoing Support",
          icon: "LaunchIcon",
          description:
            "We manage Play Store submission, release processes, and post-launch monitoring. Continuous updates and optimization ensure the app remains secure, relevant, and aligned with evolving user needs.",
          bullets: [
            {
              title: "Play Store Deployment",
              text: "Handling app publishing and compliance.",
            },
            {
              title: "Maintenance & Updates",
              text: "Supporting long-term performance.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Transform Ideas Into High-Impact Android Apps",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your Android App",
      title: "Our Android App Development Process",
      description:
        "A structured and transparent process designed to deliver reliable and scalable Android applications.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description: "Understanding business goals and user expectations.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Defining architecture and feature roadmap.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating intuitive UI and interaction flows.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building core features and integrations.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Ensuring performance, security, and compatibility.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Support",
          description: "Deploying and continuously improving the app.",
        },
      ],
    },

    customIndustries: {
      title: "Android Apps Across Industries",
      description:
        "We develop Android applications tailored to diverse industries and user bases.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "Android applications designed to enhance engagement, performance, and scalability.",
      slides: [
        {
          title: "Wider Market Reach",
          subTitle: "Global Android Audience",
          description:
            "Android apps enable access to a large and diverse user base worldwide.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Android SDK", image: "" }],
        },
        {
          title: "Reliable Performance",
          subTitle: "Optimized Experience",
          description:
            "Well-engineered apps deliver consistent speed and stability across devices.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Kotlin & Java", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver Android app development with clarity, technical depth, and long-term reliability.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Platform Expertise",
          text: "Our team understands Android ecosystem standards, updates, and device variations.",
        },
        {
          title: "User-Focused Design",
          text: "We prioritize intuitive interfaces and smooth navigation across devices.",
        },
        {
          title: "Scalable Architecture",
          text: "Apps are built to handle growth, new features, and user expansion.",
        },
        {
          title: "Ongoing Support",
          text: "We provide maintenance, updates, and performance monitoring post-launch.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Businesses trust us to build reliable and engaging Android applications.",
      clientTestimonails: [
        {
          description:
            "The Android app performs smoothly across devices and continues to scale with our user growth.",
          name: "Neeraj S.",
          position: "Product Manager",
        },
      ],
    },

    techStacks: {
      title: "Android Technologies We Use",
      description:
        "Tools and technologies used to build modern Android applications.",
      techList: [
        {
          name: "Programming Languages",
          icon: "",
          lenguages: [
            { name: "Kotlin", icon: "" },
            { name: "Java", icon: "" },
          ],
        },
        {
          name: "Frameworks & Tools",
          icon: "",
          lenguages: [
            { name: "Android SDK", icon: "" },
            { name: "Jetpack Components", icon: "" },
          ],
        },
        {
          name: "Testing & Deployment",
          icon: "",
          lenguages: [
            { name: "Firebase", icon: "" },
            { name: "Google Play Console", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about Android app development services.",
      questions: [
        {
          title: "Do you build native Android apps?",
          description:
            "Yes, we develop native Android applications using Kotlin and Java.",
        },
        {
          title: "Can you integrate third-party APIs?",
          description:
            "Yes, we integrate APIs and backend systems as required.",
        },
        {
          title: "Do you handle Play Store deployment?",
          description: "Yes, we manage submission and compliance processes.",
        },
        {
          title: "Will the app work across different devices?",
          description:
            "Yes, we test across multiple Android devices and versions.",
        },
        {
          title: "Do you provide post-launch support?",
          description:
            "Yes, we offer ongoing maintenance and feature enhancements.",
        },
      ],
    },
  },
  "cross-platform-app-development": {
    banner: {
      breadcrumb: "Cross-Platform App Development",
      title: "Build Once. Launch Everywhere.",
      highlight: "Unified Mobile Solutions.",
      description:
        "We develop high-performance cross-platform mobile applications that run smoothly on both iOS and Android, helping businesses reduce development costs, accelerate time to market, and maintain consistent user experiences across devices.",
      cta: "Start Your App Project",
      backgroundImage: require("../assets/images/cross-platform-app-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Cross-platform app development demands more than shared code. It requires strategic planning, performance-focused engineering, and careful user experience design tailored to each platform’s expectations. We collaborate closely with product owners and business stakeholders to define clear goals, scalable architecture, and long-term feature roadmaps. Our approach ensures applications remain stable, responsive, and adaptable while maintaining a unified codebase that simplifies maintenance and future enhancements.",
      milestones: [
        {
          counts: 5,
          description: "Years of Cross-Platform Experience",
        },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Continuous",
          description: "App Support & Enhancements",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End Cross-Platform App Development",
      description:
        "Our cross-platform development services cover the entire app lifecycle, from discovery and UX design to coding, integration, testing, and deployment. We focus on building scalable and secure applications that provide near-native performance while maintaining a single codebase, ensuring easier updates, faster feature rollouts, and consistent user experiences.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Product Discovery & Strategy",
          icon: "DiscoveryIcon",
          description:
            "We analyze your business goals, target audience, and technical requirements to define a clear roadmap. This step ensures the chosen framework, architecture, and features align with both current objectives and future scalability.",
          bullets: [
            {
              title: "Requirement Definition",
              text: "Clarifying features, integrations, and priorities.",
            },
            {
              title: "Technical Planning",
              text: "Selecting the right framework and structure.",
            },
          ],
        },
        {
          title: "UI/UX Design",
          icon: "DesignIcon",
          description:
            "Our design team creates intuitive, responsive interfaces that maintain consistency across platforms while respecting iOS and Android usability guidelines. The focus remains on smooth navigation and user engagement.",
          bullets: [
            {
              title: "Consistent Branding",
              text: "Unified design language across devices.",
            },
            {
              title: "Platform Adaptation",
              text: "Adhering to OS-specific interaction standards.",
            },
          ],
        },
        {
          title: "Cross-Platform Development",
          icon: "DevelopmentIcon",
          description:
            "We build applications using modern cross-platform frameworks to ensure code reusability without compromising performance. Development emphasizes clean architecture, maintainability, and efficient feature implementation.",
          bullets: [
            {
              title: "Shared Codebase",
              text: "Reducing duplication and speeding updates.",
            },
            {
              title: "Performance Optimization",
              text: "Ensuring smooth and responsive interactions.",
            },
          ],
        },
        {
          title: "Integration & Testing",
          icon: "TestingIcon",
          description:
            "We integrate backend services, APIs, and third-party tools while conducting comprehensive functional and device compatibility testing to ensure reliability across operating systems.",
          bullets: [
            {
              title: "API Integration",
              text: "Connecting securely with backend systems.",
            },
            {
              title: "Quality Assurance",
              text: "Testing across devices and OS versions.",
            },
          ],
        },
        {
          title: "Deployment & Ongoing Support",
          icon: "LaunchIcon",
          description:
            "We handle app store submissions, version releases, and post-launch monitoring. Continuous improvements ensure compatibility with updates and evolving user expectations.",
          bullets: [
            {
              title: "Store Submission",
              text: "Managing publishing and compliance.",
            },
            {
              title: "Maintenance & Updates",
              text: "Supporting long-term performance.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Reach More Users With One Powerful Application",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your Cross-Platform App",
      title: "Our Development Process",
      description:
        "A transparent and structured process designed to deliver efficient, scalable mobile applications.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding business objectives and user expectations.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Defining architecture and feature roadmap.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating intuitive cross-platform experiences.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building features using a unified codebase.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Ensuring performance, stability, and security.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Optimization",
          description: "Deploying and refining the application.",
        },
      ],
    },

    customIndustries: {
      title: "Cross-Platform Solutions Across Industries",
      description:
        "We deliver cross-platform mobile applications for businesses across various industries and operational models.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "Cross-platform applications designed to improve efficiency, reach, and long-term scalability.",
      slides: [
        {
          title: "Cost Efficiency",
          subTitle: "Single Development Cycle",
          description:
            "A shared codebase reduces development effort and simplifies maintenance.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Cross-Platform Frameworks", image: "" }],
        },
        {
          title: "Faster Market Entry",
          subTitle: "Simultaneous Launch",
          description:
            "Launching on iOS and Android together accelerates growth opportunities.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Unified Deployment Tools", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver cross-platform app development with a balance of efficiency, performance, and product strategy.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Framework Expertise",
          text: "Our developers are experienced in modern cross-platform technologies and best practices.",
        },
        {
          title: "Performance-Oriented",
          text: "Applications are engineered to deliver near-native speed and responsiveness.",
        },
        {
          title: "Scalable Architecture",
          text: "Apps are designed to handle future growth and feature expansion.",
        },
        {
          title: "Reliable Support",
          text: "We provide ongoing maintenance, updates, and technical guidance post-launch.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Organizations trust us to deliver efficient and scalable cross-platform applications.",
      clientTestimonails: [
        {
          description:
            "Launching on both platforms at once helped us reach customers faster and reduce development overhead.",
          name: "Amit K.",
          position: "Product Lead",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern tools and frameworks used to build efficient cross-platform mobile applications.",
      techList: [
        {
          name: "Frameworks",
          icon: "",
          lenguages: [
            { name: "Flutter", icon: "" },
            { name: "React Native", icon: "" },
          ],
        },
        {
          name: "Backend & APIs",
          icon: "",
          lenguages: [
            { name: "Node.js", icon: "" },
            { name: "Firebase", icon: "" },
          ],
        },
        {
          name: "Deployment Tools",
          icon: "",
          lenguages: [
            { name: "App Store Connect", icon: "" },
            { name: "Google Play Console", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about cross-platform app development.",
      questions: [
        {
          title: "What is cross-platform app development?",
          description:
            "It involves building one application that works across multiple operating systems using a shared codebase.",
        },
        {
          title: "Will performance match native apps?",
          description:
            "Modern frameworks provide near-native performance for most business use cases.",
        },
        {
          title: "Can existing apps be migrated?",
          description:
            "Yes, we can assess and migrate native applications when technically feasible.",
        },
        {
          title: "Do you handle store deployment?",
          description:
            "Yes, we manage submissions for both Apple App Store and Google Play.",
        },
        {
          title: "Is cross-platform suitable for startups?",
          description:
            "Yes, it enables faster launch and cost efficiency for early-stage products.",
        },
      ],
    },
  },
  "flutter-app-development": {
    banner: {
      breadcrumb: "Flutter App Development",
      title: "Create Beautiful Apps With",
      highlight: "Flutter Technology.",
      description:
        "We build visually rich and high-performance mobile applications using Flutter, enabling businesses to launch on iOS and Android from a single codebase while maintaining smooth animations, fast rendering, and scalable architecture.",
      cta: "Start Your Flutter App",
      backgroundImage: require("../assets/images/ser_bnner.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Flutter development combines expressive UI capabilities with efficient cross-platform performance. We work closely with product teams to design structured architectures, reusable widgets, and optimized rendering strategies. Our approach ensures applications remain responsive, maintainable, and adaptable to evolving feature requirements. By focusing on clean code practices and thoughtful integration planning, we help businesses build reliable mobile products that scale confidently as user engagement and functionality grow.",
      milestones: [
        { counts: 5, description: "Years of Flutter Experience" },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        { counts: "Ongoing", description: "App Maintenance Engagements" },
      ],
    },

    endToEndServices: {
      title: "End-to-End Flutter App Development",
      description:
        "Our Flutter development services span the entire mobile application lifecycle, from initial discovery and interface design to development, backend integration, testing, deployment, and optimization. We focus on building flexible widget structures, efficient state management systems, and scalable architectures that deliver consistent performance across platforms while supporting long-term product evolution.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Product Discovery & Architecture Design",
          icon: "DiscoveryIcon",
          description:
            "We define business goals, user journeys, and technical scope to create a structured Flutter architecture. Proper planning ensures modular code organization and efficient long-term scalability.",
          bullets: [
            {
              title: "Requirement Mapping",
              text: "Identifying core features and integrations.",
            },
            {
              title: "Architecture Planning",
              text: "Designing scalable widget structures.",
            },
          ],
        },
        {
          title: "UI/UX Development",
          icon: "DesignIcon",
          description:
            "We build custom Flutter interfaces using expressive widgets and smooth animations, ensuring consistent branding, intuitive navigation, and optimized performance across devices.",
          bullets: [
            {
              title: "Custom Widgets",
              text: "Reusable and visually consistent components.",
            },
            {
              title: "Responsive Design",
              text: "Optimized layouts for multiple screen sizes.",
            },
          ],
        },
        {
          title: "Core Application Development",
          icon: "DevelopmentIcon",
          description:
            "Our developers implement scalable features using modern Flutter practices, focusing on performance optimization, structured state management, and reliable data handling.",
          bullets: [
            {
              title: "State Management",
              text: "Predictable and efficient application behavior.",
            },
            {
              title: "Performance Tuning",
              text: "Ensuring smooth animations and fast rendering.",
            },
          ],
        },
        {
          title: "API Integration & Testing",
          icon: "TestingIcon",
          description:
            "We integrate backend systems, cloud services, and third-party tools while conducting comprehensive testing to validate stability, compatibility, and security.",
          bullets: [
            {
              title: "Secure Integrations",
              text: "Connecting apps with backend services.",
            },
            {
              title: "Quality Assurance",
              text: "Testing across platforms and devices.",
            },
          ],
        },
        {
          title: "Deployment & Continuous Optimization",
          icon: "LaunchIcon",
          description:
            "We manage app store submissions and provide post-launch updates to ensure compatibility with OS changes, improved performance, and evolving user expectations.",
          bullets: [
            {
              title: "Store Deployment",
              text: "Handling publishing requirements.",
            },
            {
              title: "Ongoing Maintenance",
              text: "Ensuring scalability and reliability.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Deliver Consistent Experiences Across Platforms",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build With Flutter",
      title: "Our Flutter Development Process",
      description:
        "A structured workflow designed to deliver efficient, scalable, and visually engaging mobile applications.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description: "Understanding product goals and user needs.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Designing architecture and feature roadmap.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating responsive and intuitive interfaces.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building modular and scalable features.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Ensuring reliability and performance.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Support",
          description: "Deploying and maintaining the application.",
        },
      ],
    },

    customIndustries: {
      title: "Flutter Solutions Across Industries",
      description:
        "We develop Flutter applications tailored to diverse industries and operational requirements.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "Flutter applications designed to accelerate development, enhance visual consistency, and expand market reach.",
      slides: [
        {
          title: "Faster Development Cycles",
          subTitle: "Single Codebase Efficiency",
          description:
            "Reusable widgets reduce duplication and speed up feature releases.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Flutter SDK", image: "" }],
        },
        {
          title: "Rich User Interfaces",
          subTitle: "Expressive Design",
          description:
            "Customizable widgets create visually engaging mobile experiences.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Dart Programming Language", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver Flutter development with technical precision, scalable architecture, and long-term product thinking.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Widget Expertise",
          text: "Experienced in building reusable and scalable Flutter components.",
        },
        {
          title: "Performance Focused",
          text: "Optimized rendering and smooth animation handling.",
        },
        {
          title: "Scalable Architecture",
          text: "Structured applications ready for growth and feature expansion.",
        },
        {
          title: "Reliable Support",
          text: "Continuous monitoring and post-launch improvements.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Organizations rely on us for efficient and visually compelling Flutter applications.",
      clientTestimonails: [
        {
          description:
            "The Flutter app delivered consistent performance and design across platforms with impressive speed.",
          name: "Neha R.",
          position: "Product Manager",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern tools and frameworks used to build high-performing Flutter applications.",
      techList: [
        {
          name: "Framework & Language",
          icon: "",
          lenguages: [
            { name: "Flutter", icon: "" },
            { name: "Dart", icon: "" },
          ],
        },
        {
          name: "Backend & Cloud",
          icon: "",
          lenguages: [
            { name: "Firebase", icon: "" },
            { name: "Node.js", icon: "" },
          ],
        },
        {
          name: "Deployment Tools",
          icon: "",
          lenguages: [
            { name: "App Store Connect", icon: "" },
            { name: "Google Play Console", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about Flutter app development.",
      questions: [
        {
          title: "What is Flutter?",
          description:
            "Flutter is a UI toolkit for building cross-platform mobile applications using a single Dart codebase.",
        },
        {
          title: "Is Flutter suitable for complex apps?",
          description:
            "Yes, with proper architecture it supports scalable and feature-rich applications.",
        },
        {
          title: "Do you manage deployment?",
          description:
            "Yes, we handle publishing to both iOS and Android stores.",
        },
        {
          title: "Can third-party APIs be integrated?",
          description:
            "Yes, we integrate payment systems, analytics, and backend services.",
        },
        {
          title: "Do you provide post-launch support?",
          description:
            "Yes, we offer ongoing maintenance and performance optimization.",
        },
      ],
    },
  },
  "react-native-app-development": {
    banner: {
      breadcrumb: "React Native App Development",
      title: "Build Scalable Mobile Apps With",
      highlight: "React Native.",
      description:
        "We develop high-performance mobile applications using React Native, enabling businesses to launch on both iOS and Android with a shared codebase while maintaining smooth user experiences, strong architecture, and long-term scalability.",
      cta: "Start Your React Native App",
      backgroundImage: require("../assets/images/react-native-app-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "React Native development requires more than cross-platform capability. It demands structured component architecture, optimized rendering performance, and clean state management. We collaborate with product owners and technical stakeholders to design scalable foundations that support feature growth and long-term maintainability. Our engineering approach focuses on reusable components, stable integrations, and consistent performance to ensure applications remain reliable as user expectations and business needs evolve.",
      milestones: [
        { counts: 5, description: "Years of React Native Expertise" },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Ongoing",
          description: "Continuous Improvement Engagements",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End React Native Development",
      description:
        "Our React Native development services cover the complete mobile application lifecycle, from discovery and UI implementation to backend integration, testing, deployment, and optimization. We focus on building modular and maintainable applications that balance performance, scalability, and user experience while ensuring seamless functionality across both iOS and Android platforms.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Product Discovery & Technical Planning",
          icon: "DiscoveryIcon",
          description:
            "We analyze business objectives, user journeys, and technical requirements to define a scalable React Native architecture. This step ensures the app structure supports efficient feature expansion and stable long-term maintenance.",
          bullets: [
            {
              title: "Requirement Analysis",
              text: "Defining features and integration needs.",
            },
            {
              title: "Architecture Blueprint",
              text: "Designing modular and reusable components.",
            },
          ],
        },
        {
          title: "UI/UX Implementation",
          icon: "DesignIcon",
          description:
            "We convert visual concepts into responsive and reusable React Native components, ensuring consistent branding, intuitive navigation, and smooth interaction patterns across devices.",
          bullets: [
            {
              title: "Reusable UI Components",
              text: "Maintaining design consistency.",
            },
            {
              title: "Platform Alignment",
              text: "Adhering to platform behavior standards.",
            },
          ],
        },
        {
          title: "Core App Development",
          icon: "DevelopmentIcon",
          description:
            "Our team builds application features using modern React Native practices, emphasizing clean code structure, efficient rendering, and predictable data management strategies.",
          bullets: [
            {
              title: "State Management",
              text: "Ensuring reliable and controlled data flow.",
            },
            {
              title: "Performance Optimization",
              text: "Delivering smooth transitions and responsiveness.",
            },
          ],
        },
        {
          title: "API Integration & Testing",
          icon: "TestingIcon",
          description:
            "We integrate backend APIs, authentication systems, and third-party services while conducting functional and compatibility testing to ensure secure and reliable performance.",
          bullets: [
            {
              title: "Secure Integrations",
              text: "Connecting seamlessly with backend systems.",
            },
            {
              title: "Quality Assurance",
              text: "Testing across devices and OS versions.",
            },
          ],
        },
        {
          title: "Deployment & Ongoing Support",
          icon: "LaunchIcon",
          description:
            "We manage application submission to app stores and provide continuous monitoring and updates, ensuring compatibility with platform changes and evolving user expectations.",
          bullets: [
            {
              title: "Store Deployment",
              text: "Handling publishing and compliance.",
            },
            {
              title: "Continuous Maintenance",
              text: "Supporting long-term scalability.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Accelerate Cross-Platform Growth With React Native",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build With React Native",
      title: "Our Development Workflow",
      description:
        "A structured and transparent workflow designed to deliver scalable, efficient, and reliable mobile applications.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description: "Understanding business objectives and technical scope.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Designing scalable architecture and roadmap.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Implementing responsive and intuitive interfaces.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building modular and reusable components.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Validating stability, performance, and security.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Support",
          description: "Deploying and maintaining the application.",
        },
      ],
    },

    customIndustries: {
      title: "React Native Solutions Across Industries",
      description:
        "We deliver React Native applications tailored to diverse industries and operational models.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "React Native applications designed to improve efficiency, reduce development time, and expand market reach.",
      slides: [
        {
          title: "Faster Release Cycles",
          subTitle: "Shared Codebase Efficiency",
          description:
            "Reusable components accelerate feature updates and improvements.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "React Native Framework", image: "" }],
        },
        {
          title: "Consistent User Experience",
          subTitle: "Unified Mobile Interface",
          description:
            "Maintaining design and functionality consistency across platforms strengthens usability.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [
            { title: "Component-Based Architecture", image: "" },
          ],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We combine technical expertise with structured development practices to deliver reliable React Native applications.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Technical Depth",
          text: "Experienced in scalable React Native architectures and integrations.",
        },
        {
          title: "Performance Focus",
          text: "Optimized rendering and efficient component management.",
        },
        {
          title: "Future-Ready Structure",
          text: "Applications designed for easy expansion and updates.",
        },
        {
          title: "Reliable Support",
          text: "Continuous monitoring and post-launch enhancements.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Businesses rely on us for efficient and scalable React Native development.",
      clientTestimonails: [
        {
          description:
            "The unified development approach allowed us to launch quickly across platforms without sacrificing performance.",
          name: "Arjun K.",
          position: "Product Director",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern frameworks and tools used to build reliable React Native applications.",
      techList: [
        {
          name: "Framework & Libraries",
          icon: "",
          lenguages: [
            { name: "React Native", icon: "" },
            { name: "Redux", icon: "" },
          ],
        },
        {
          name: "Backend & Integrations",
          icon: "",
          lenguages: [
            { name: "Node.js", icon: "" },
            { name: "Firebase", icon: "" },
          ],
        },
        {
          name: "Deployment Tools",
          icon: "",
          lenguages: [
            { name: "App Store Connect", icon: "" },
            { name: "Google Play Console", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about React Native app development.",
      questions: [
        {
          title: "What is React Native?",
          description:
            "A framework for building iOS and Android apps using a shared JavaScript codebase.",
        },
        {
          title: "Is it suitable for complex applications?",
          description:
            "Yes, with proper architecture it supports scalable and feature-rich applications.",
        },
        {
          title: "Do you manage app store submissions?",
          description:
            "Yes, we handle publishing for both iOS and Android platforms.",
        },
        {
          title: "Can third-party services be integrated?",
          description:
            "Yes, we integrate APIs, payment gateways, and analytics tools.",
        },
        {
          title: "Do you provide post-launch support?",
          description:
            "Yes, we offer ongoing maintenance and performance optimization services.",
        },
      ],
    },
  },
  "progressive-web-app-development": {
    banner: {
      breadcrumb: "Progressive Web App (PWA) Development",
      title: "Deliver App-Like Experiences With",
      highlight: "Progressive Web Apps.",
      description:
        "We design and develop high-performance Progressive Web Applications that combine the reach of the web with the functionality of mobile apps, enabling fast loading, offline access, and seamless user engagement across devices.",
      cta: "Build Your PWA",
      backgroundImage: require("../assets/images/progressive-web-app-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Progressive Web App development requires careful planning around performance, caching strategies, and responsive design principles. We collaborate with product owners and technical teams to define scalable architectures that deliver fast loading times and reliable offline functionality. Our approach focuses on clean code structure, optimized assets, and secure service worker implementation to ensure consistent experiences across browsers and devices while supporting long-term product growth.",
      milestones: [
        { counts: 5, description: "Years of PWA Experience" },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        {
          counts: "Ongoing",
          description: "Performance Optimization Engagements",
        },
      ],
    },

    endToEndServices: {
      title: "End-to-End PWA Development",
      description:
        "Our PWA development services cover the entire lifecycle from discovery and interface design to development, integration, testing, deployment, and optimization. We focus on building secure, responsive, and installable web applications that offer native-like performance while maintaining the flexibility and accessibility of modern web technologies.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Strategy & Technical Planning",
          icon: "StrategyIcon",
          description:
            "We evaluate business goals and user expectations to design a scalable PWA architecture. This stage defines caching strategies, performance benchmarks, and responsive design requirements.",
          bullets: [
            {
              title: "Requirement Analysis",
              text: "Defining functional and technical needs.",
            },
            {
              title: "Architecture Planning",
              text: "Structuring scalable web foundations.",
            },
          ],
        },
        {
          title: "Responsive UI Development",
          icon: "DesignIcon",
          description:
            "We create adaptive interfaces optimized for mobile, tablet, and desktop devices, ensuring consistent branding and smooth navigation across screen sizes.",
          bullets: [
            {
              title: "Mobile-First Design",
              text: "Optimizing layout for smaller screens.",
            },
            {
              title: "Cross-Browser Compatibility",
              text: "Ensuring consistent performance.",
            },
          ],
        },
        {
          title: "Service Worker Implementation",
          icon: "DevelopmentIcon",
          description:
            "Our team configures service workers to enable offline functionality, push notifications, and background synchronization for improved user engagement.",
          bullets: [
            {
              title: "Offline Support",
              text: "Enabling access without internet connectivity.",
            },
            { title: "Push Notifications", text: "Enhancing user engagement." },
          ],
        },
        {
          title: "Integration & Performance Optimization",
          icon: "IntegrationIcon",
          description:
            "We integrate APIs and backend services while optimizing asset delivery, caching, and loading performance to ensure fast and reliable operation.",
          bullets: [
            {
              title: "API Connectivity",
              text: "Secure backend communication.",
            },
            {
              title: "Speed Optimization",
              text: "Reducing load time and improving responsiveness.",
            },
          ],
        },
        {
          title: "Deployment & Continuous Improvement",
          icon: "LaunchIcon",
          description:
            "We deploy the PWA with proper hosting configuration and provide ongoing monitoring and updates to maintain compatibility and performance.",
          bullets: [
            {
              title: "Secure Hosting Setup",
              text: "Configuring HTTPS and environment.",
            },
            {
              title: "Ongoing Maintenance",
              text: "Continuous monitoring and improvements.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Expand Reach With Fast And Reliable Web Applications",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your Progressive Web App",
      title: "Our PWA Development Process",
      description:
        "A structured workflow designed to deliver scalable and high-performing web applications.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description: "Understanding business objectives and user needs.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Designing technical architecture and roadmap.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating responsive and user-friendly layouts.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Implementing core features and service workers.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Validating performance, compatibility, and security.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Support",
          description: "Deploying and maintaining the application.",
        },
      ],
    },

    customIndustries: {
      title: "PWA Solutions Across Industries",
      description:
        "We develop Progressive Web Applications tailored to diverse industries and digital strategies.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "PWAs designed to improve engagement, accessibility, and operational efficiency.",
      slides: [
        {
          title: "Improved User Engagement",
          subTitle: "App-Like Experience",
          description:
            "Push notifications and offline access increase interaction and retention.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Service Workers", image: "" }],
        },
        {
          title: "Faster Performance",
          subTitle: "Optimized Delivery",
          description:
            "Caching strategies and lightweight assets reduce load times significantly.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Modern Web Frameworks", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver Progressive Web Apps with strong technical foundations and performance-focused strategies.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Performance Expertise",
          text: "Focused on speed optimization and caching strategies.",
        },
        {
          title: "Responsive Design",
          text: "Ensuring seamless experiences across devices.",
        },
        {
          title: "Secure Implementation",
          text: "Deploying with HTTPS and modern security practices.",
        },
        {
          title: "Long-Term Support",
          text: "Providing continuous monitoring and updates.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Organizations trust us to deliver reliable and engaging Progressive Web Applications.",
      clientTestimonails: [
        {
          description:
            "Our PWA improved loading speed and significantly enhanced user engagement across devices.",
          name: "Karan S.",
          position: "Digital Product Manager",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern tools and frameworks used to build scalable Progressive Web Applications.",
      techList: [
        {
          name: "Frontend Frameworks",
          icon: "",
          lenguages: [
            { name: "React", icon: "" },
            { name: "Next.js", icon: "" },
          ],
        },
        {
          name: "Core Technologies",
          icon: "",
          lenguages: [
            { name: "Service Workers", icon: "" },
            { name: "Web App Manifest", icon: "" },
          ],
        },
        {
          name: "Backend & Hosting",
          icon: "",
          lenguages: [
            { name: "Node.js", icon: "" },
            { name: "Cloud Hosting", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about Progressive Web App development.",
      questions: [
        {
          title: "What is a Progressive Web App?",
          description:
            "A web application that delivers app-like functionality using modern browser capabilities.",
        },
        {
          title: "Do PWAs work offline?",
          description:
            "Yes, service workers enable offline functionality and caching.",
        },
        {
          title: "Can PWAs be installed on devices?",
          description: "Yes, users can install them directly from the browser.",
        },
        {
          title: "Are PWAs secure?",
          description:
            "Yes, they require HTTPS and follow modern security standards.",
        },
        {
          title: "Do you provide ongoing support?",
          description:
            "Yes, we offer performance monitoring and continuous improvements.",
        },
      ],
    },
  },
  "ionic-app-development": {
    banner: {
      breadcrumb: "Ionic App Development",
      title: "Hybrid Mobile Apps Powered By",
      highlight: "Ionic Framework.",
      description:
        "We develop scalable and feature-rich hybrid mobile applications using Ionic, enabling businesses to launch across iOS, Android, and web platforms with a unified codebase while maintaining performance, usability, and cost efficiency.",
      cta: "Build With Ionic",
      backgroundImage: require("../assets/images/ionic-app-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Ionic app development requires strong expertise in web technologies combined with mobile optimization strategies. We work closely with product teams to design structured architectures that ensure maintainable code, responsive layouts, and efficient API integrations. Our approach focuses on performance tuning, reusable UI components, and scalable backend connectivity, ensuring applications remain adaptable as features expand and user demand increases across platforms.",
      milestones: [
        { counts: 5, description: "Years of Ionic Experience" },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        { counts: "Ongoing", description: "Support & Enhancement Projects" },
      ],
    },

    endToEndServices: {
      title: "End-to-End Ionic App Development",
      description:
        "Our Ionic development services cover the complete mobile app lifecycle, from planning and UI design to development, integration, testing, deployment, and ongoing optimization. We focus on building maintainable hybrid applications that balance web flexibility with mobile performance, ensuring consistent experiences across platforms while reducing overall development time.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Requirement Analysis & Architecture Planning",
          icon: "DiscoveryIcon",
          description:
            "We evaluate business goals and technical requirements to design a scalable Ionic architecture. Proper planning ensures reusable components and smooth integration with backend systems.",
          bullets: [
            {
              title: "Feature Definition",
              text: "Clarifying app scope and functionality.",
            },
            {
              title: "Technical Blueprint",
              text: "Designing scalable hybrid architecture.",
            },
          ],
        },
        {
          title: "UI/UX Implementation",
          icon: "DesignIcon",
          description:
            "We build responsive and visually consistent interfaces using Ionic components, ensuring seamless navigation and cross-device compatibility.",
          bullets: [
            {
              title: "Reusable Components",
              text: "Creating consistent UI elements.",
            },
            {
              title: "Responsive Layouts",
              text: "Optimized for multiple screen sizes.",
            },
          ],
        },
        {
          title: "Core Development",
          icon: "DevelopmentIcon",
          description:
            "Our developers implement core application features using Ionic and modern web technologies, focusing on structured code and optimized performance.",
          bullets: [
            {
              title: "Modular Coding",
              text: "Ensuring maintainable application structure.",
            },
            {
              title: "Performance Optimization",
              text: "Enhancing responsiveness and speed.",
            },
          ],
        },
        {
          title: "Integration & Testing",
          icon: "TestingIcon",
          description:
            "We integrate APIs, authentication systems, and third-party services while performing comprehensive testing across devices and operating systems.",
          bullets: [
            {
              title: "API Connectivity",
              text: "Secure backend communication.",
            },
            {
              title: "Cross-Platform Testing",
              text: "Ensuring compatibility and stability.",
            },
          ],
        },
        {
          title: "Deployment & Continuous Support",
          icon: "LaunchIcon",
          description:
            "We manage application deployment to app stores and provide post-launch updates to maintain compatibility, security, and performance improvements.",
          bullets: [
            {
              title: "Store Submission",
              text: "Handling publishing and compliance.",
            },
            {
              title: "Ongoing Maintenance",
              text: "Supporting long-term scalability.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Expand Reach With Hybrid Mobile Solutions",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your Ionic App",
      title: "Our Ionic Development Process",
      description:
        "A structured workflow designed to deliver scalable, secure, and efficient hybrid mobile applications.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding product goals and technical requirements.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Designing architecture and development roadmap.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating responsive and intuitive interfaces.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building modular and reusable features.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Validating performance and cross-device compatibility.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Support",
          description: "Deploying and maintaining the application.",
        },
      ],
    },

    customIndustries: {
      title: "Ionic Solutions Across Industries",
      description:
        "We develop Ionic-based hybrid applications tailored to diverse industries and digital strategies.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "Ionic applications designed to accelerate development, reduce costs, and expand platform reach.",
      slides: [
        {
          title: "Cost Efficiency",
          subTitle: "Shared Web Technologies",
          description:
            "Single codebase reduces duplication and development effort.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Ionic Framework", image: "" }],
        },
        {
          title: "Cross-Platform Reach",
          subTitle: "Unified Deployment",
          description:
            "Launch across iOS, Android, and web platforms simultaneously.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [
            { title: "Angular / React Integration", image: "" },
          ],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver Ionic app development with structured engineering practices and long-term product thinking.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Hybrid Expertise",
          text: "Strong experience in building scalable Ionic-based applications.",
        },
        {
          title: "Performance Focused",
          text: "Optimized rendering and responsive user interfaces.",
        },
        {
          title: "Scalable Architecture",
          text: "Applications structured for future expansion.",
        },
        {
          title: "Reliable Support",
          text: "Continuous maintenance and optimization post-launch.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Organizations rely on us for efficient and scalable Ionic mobile solutions.",
      clientTestimonails: [
        {
          description:
            "The Ionic app allowed us to launch on multiple platforms quickly while maintaining consistent performance.",
          name: "Vikram S.",
          position: "Product Lead",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern tools and frameworks used to build reliable Ionic applications.",
      techList: [
        {
          name: "Framework & Libraries",
          icon: "",
          lenguages: [
            { name: "Ionic Framework", icon: "" },
            { name: "Angular", icon: "" },
          ],
        },
        {
          name: "Backend & APIs",
          icon: "",
          lenguages: [
            { name: "Node.js", icon: "" },
            { name: "Firebase", icon: "" },
          ],
        },
        {
          name: "Deployment Tools",
          icon: "",
          lenguages: [
            { name: "App Store Connect", icon: "" },
            { name: "Google Play Console", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about Ionic app development.",
      questions: [
        {
          title: "What is Ionic?",
          description:
            "Ionic is a framework for building hybrid mobile apps using web technologies.",
        },
        {
          title: "Is Ionic suitable for enterprise apps?",
          description:
            "Yes, with proper architecture it supports scalable and secure applications.",
        },
        {
          title: "Do you handle app store deployment?",
          description:
            "Yes, we manage publishing for iOS and Android platforms.",
        },
        {
          title: "Can Ionic apps access native device features?",
          description: "Yes, through plugins and native integrations.",
        },
        {
          title: "Do you provide post-launch support?",
          description:
            "Yes, we offer maintenance and performance optimization services.",
        },
      ],
    },
  },
  "wearable-app-development": {
    banner: {
      breadcrumb: "Wearable App Development",
      title: "Innovative Experiences For",
      highlight: "Wearable Devices.",
      description:
        "We design and develop intelligent wearable applications for smartwatches and connected devices, enabling businesses to deliver real-time data, seamless interactions, and lightweight user experiences optimized for compact screens and on-the-go usage.",
      cta: "Build Your Wearable App",
      backgroundImage: require("../assets/images/wearable-app-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Wearable app development requires a focused approach to minimal interfaces, performance efficiency, and seamless device synchronization. We collaborate with product teams to design compact yet intuitive user flows tailored for small screens and quick interactions. Our engineering practices emphasize optimized battery usage, stable Bluetooth or cloud connectivity, and secure data transmission, ensuring wearable applications remain responsive, reliable, and scalable as device ecosystems evolve.",
      milestones: [
        { counts: 5, description: "Years of Wearable Development Experience" },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        { counts: "Ongoing", description: "Device Integration Projects" },
      ],
    },

    endToEndServices: {
      title: "End-to-End Wearable App Development",
      description:
        "Our wearable app development services cover the entire lifecycle, from discovery and UX planning to development, integration, testing, and deployment. We focus on building lightweight and responsive applications that seamlessly integrate with mobile devices, cloud platforms, and IoT systems while maintaining optimal performance and security.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Strategy & Device Compatibility Planning",
          icon: "StrategyIcon",
          description:
            "We evaluate business objectives and device ecosystems to define compatibility requirements and technical architecture tailored for wearable platforms.",
          bullets: [
            {
              title: "Device Research",
              text: "Identifying supported wearables and OS versions.",
            },
            {
              title: "Architecture Design",
              text: "Planning scalable integration frameworks.",
            },
          ],
        },
        {
          title: "Compact UI/UX Design",
          icon: "DesignIcon",
          description:
            "We design minimal and intuitive interfaces optimized for small screens, ensuring quick access to essential features and effortless navigation.",
          bullets: [
            {
              title: "Minimal Layouts",
              text: "Reducing complexity for faster interactions.",
            },
            {
              title: "Gesture Optimization",
              text: "Enhancing usability through smart controls.",
            },
          ],
        },
        {
          title: "Core Wearable Development",
          icon: "DevelopmentIcon",
          description:
            "Our developers build efficient wearable applications using native SDKs and modern frameworks while ensuring smooth device synchronization.",
          bullets: [
            {
              title: "Efficient Coding",
              text: "Optimizing for speed and battery usage.",
            },
            {
              title: "Real-Time Sync",
              text: "Maintaining stable connectivity.",
            },
          ],
        },
        {
          title: "Integration & Testing",
          icon: "TestingIcon",
          description:
            "We integrate mobile apps, cloud platforms, and IoT devices while performing compatibility and performance testing across supported hardware.",
          bullets: [
            {
              title: "Secure Connectivity",
              text: "Protecting transmitted data.",
            },
            {
              title: "Cross-Device Testing",
              text: "Validating reliability across wearables.",
            },
          ],
        },
        {
          title: "Deployment & Continuous Support",
          icon: "LaunchIcon",
          description:
            "We manage deployment to wearable app stores and provide post-launch updates to maintain compatibility with new hardware and OS versions.",
          bullets: [
            {
              title: "Store Publishing",
              text: "Handling submission processes.",
            },
            {
              title: "Ongoing Optimization",
              text: "Improving performance and stability.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Enhance User Engagement Through Smart Devices",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your Wearable App",
      title: "Our Wearable Development Process",
      description:
        "A streamlined workflow designed to deliver efficient, secure, and responsive wearable applications.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description: "Understanding business goals and device requirements.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Designing architecture and integration strategy.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating compact and intuitive interfaces.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building optimized wearable features.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Validating performance and compatibility.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Support",
          description: "Deploying and maintaining the application.",
        },
      ],
    },

    customIndustries: {
      title: "Wearable Solutions Across Industries",
      description:
        "We develop wearable applications tailored to diverse industry needs and connected ecosystems.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "Wearable applications designed to enhance engagement, improve data accessibility, and expand connected ecosystems.",
      slides: [
        {
          title: "Real-Time Data Access",
          subTitle: "Instant Insights",
          description:
            "Providing users with immediate notifications and updates.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Wearable SDKs", image: "" }],
        },
        {
          title: "Improved User Engagement",
          subTitle: "On-The-Go Interaction",
          description:
            "Quick and convenient interactions increase user retention.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Bluetooth & Cloud Sync", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver wearable app development with strong device integration and performance-focused engineering.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Device Expertise",
          text: "Experienced in building apps for multiple wearable platforms.",
        },
        {
          title: "Performance Optimized",
          text: "Efficient coding practices for battery and speed.",
        },
        {
          title: "Secure Connectivity",
          text: "Strong data protection and encryption practices.",
        },
        {
          title: "Reliable Support",
          text: "Continuous monitoring and updates post-launch.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Businesses trust us to deliver reliable and innovative wearable solutions.",
      clientTestimonails: [
        {
          description:
            "The wearable application integrated seamlessly with our mobile app and delivered real-time insights effectively.",
          name: "Sonal T.",
          position: "Digital Product Manager",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern tools and frameworks used to build scalable wearable applications.",
      techList: [
        {
          name: "Wearable Platforms",
          icon: "",
          lenguages: [
            { name: "Wear OS", icon: "" },
            { name: "watchOS", icon: "" },
          ],
        },
        {
          name: "Connectivity",
          icon: "",
          lenguages: [
            { name: "Bluetooth Low Energy", icon: "" },
            { name: "Cloud APIs", icon: "" },
          ],
        },
        {
          name: "Mobile Integration",
          icon: "",
          lenguages: [
            { name: "Android", icon: "" },
            { name: "iOS", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about wearable app development.",
      questions: [
        {
          title: "Which wearable platforms do you support?",
          description:
            "We develop applications for Wear OS, watchOS, and other major wearable ecosystems.",
        },
        {
          title: "Can wearable apps sync with mobile applications?",
          description:
            "Yes, we enable secure synchronization between wearable and mobile devices.",
        },
        {
          title: "Do you ensure battery optimization?",
          description:
            "Yes, our development focuses on efficient performance and low energy consumption.",
        },
        {
          title: "Are wearable apps secure?",
          description:
            "Yes, we implement encryption and secure data transmission practices.",
        },
        {
          title: "Do you provide post-launch updates?",
          description:
            "Yes, we offer ongoing maintenance and compatibility updates.",
        },
      ],
    },
  },

  "appointment-app-development": {
    banner: {
      breadcrumb: "Appointment App Development",
      title: "Streamline Scheduling With",
      highlight: "Smart Appointment Apps.",
      description:
        "We design and develop intelligent appointment booking applications that simplify scheduling, automate reminders, manage availability in real time, and enhance customer engagement across mobile and web platforms.",
      cta: "Build Your Appointment App",
      backgroundImage: require("../assets/images/appointment-app-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Appointment app development requires structured scheduling logic, secure user management, and seamless calendar synchronization. We collaborate with businesses to understand service workflows, booking patterns, and operational challenges before defining scalable architecture. Our approach focuses on real-time availability updates, automated notifications, payment integration, and performance optimization to ensure smooth booking experiences for both administrators and end users while supporting long-term business growth.",
      milestones: [
        { counts: 5, description: "Years of App Development Experience" },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        { counts: "Ongoing", description: "Support & Enhancement Projects" },
      ],
    },

    endToEndServices: {
      title: "End-to-End Appointment App Development",
      description:
        "Our appointment app development services cover the complete product lifecycle, from strategy and interface design to backend development, calendar integration, testing, deployment, and optimization. We focus on building secure, scalable, and user-friendly scheduling platforms that automate bookings, reduce manual coordination, and improve customer satisfaction.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Business Analysis & Workflow Planning",
          icon: "StrategyIcon",
          description:
            "We analyze your service model, booking process, and operational requirements to design a scalable scheduling system tailored to your business needs.",
          bullets: [
            {
              title: "Requirement Mapping",
              text: "Defining booking rules and logic.",
            },
            {
              title: "Technical Planning",
              text: "Designing scalable backend architecture.",
            },
          ],
        },
        {
          title: "User-Centric UI/UX Design",
          icon: "DesignIcon",
          description:
            "We create intuitive booking interfaces that simplify time selection, service browsing, and confirmation processes across devices.",
          bullets: [
            {
              title: "Responsive Layouts",
              text: "Optimized for mobile and web.",
            },
            {
              title: "User-Friendly Flows",
              text: "Minimizing steps in booking journeys.",
            },
          ],
        },
        {
          title: "Core Application Development",
          icon: "DevelopmentIcon",
          description:
            "Our developers implement secure authentication, calendar management, and automated notification systems to ensure smooth scheduling operations.",
          bullets: [
            {
              title: "Real-Time Availability",
              text: "Dynamic slot management.",
            },
            {
              title: "Automated Reminders",
              text: "Push and email notifications.",
            },
          ],
        },
        {
          title: "Integration & Testing",
          icon: "TestingIcon",
          description:
            "We integrate payment gateways, CRM systems, and third-party calendars while conducting performance and usability testing to ensure reliability.",
          bullets: [
            {
              title: "Calendar Sync",
              text: "Integration with Google and Outlook.",
            },
            { title: "Comprehensive QA", text: "Ensuring system stability." },
          ],
        },
        {
          title: "Deployment & Continuous Improvement",
          icon: "LaunchIcon",
          description:
            "We manage app store deployment and provide ongoing updates, analytics integration, and feature enhancements to support growth.",
          bullets: [
            {
              title: "Secure Deployment",
              text: "Publishing across platforms.",
            },
            {
              title: "Ongoing Optimization",
              text: "Improving efficiency and scalability.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Simplify Scheduling And Improve Customer Experience",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your Scheduling App",
      title: "Our Appointment App Development Process",
      description:
        "A structured workflow designed to deliver reliable, secure, and scalable appointment booking applications.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description: "Understanding service models and booking requirements.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Designing architecture and scheduling logic.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating intuitive booking interfaces.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building core scheduling and notification systems.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Ensuring performance, security, and usability.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Support",
          description: "Deploying and optimizing the application.",
        },
      ],
    },

    customIndustries: {
      title: "Appointment Solutions Across Industries",
      description:
        "We develop scheduling applications tailored to diverse industries and operational needs.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "Appointment applications designed to increase efficiency, reduce no-shows, and enhance customer satisfaction.",
      slides: [
        {
          title: "Improved Operational Efficiency",
          subTitle: "Automated Scheduling",
          description:
            "Reducing manual coordination and administrative workload.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Calendar APIs", image: "" }],
        },
        {
          title: "Higher Customer Retention",
          subTitle: "Smart Notifications",
          description: "Automated reminders reduce missed appointments.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [
            { title: "Push Notification Services", image: "" },
          ],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver appointment app development with structured engineering, security-first practices, and long-term scalability in mind.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Workflow Expertise",
          text: "Designing structured and reliable scheduling systems.",
        },
        {
          title: "Security Focused",
          text: "Protecting user data and transactions.",
        },
        {
          title: "Performance Optimized",
          text: "Ensuring smooth booking experiences.",
        },
        {
          title: "Reliable Support",
          text: "Providing continuous updates and improvements.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Businesses rely on us to streamline scheduling and enhance customer engagement.",
      clientTestimonails: [
        {
          description:
            "The appointment app reduced our administrative workload and improved customer satisfaction significantly.",
          name: "Priya M.",
          position: "Operations Manager",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern frameworks and tools used to build secure and scalable scheduling applications.",
      techList: [
        {
          name: "Mobile Frameworks",
          icon: "",
          lenguages: [
            { name: "React Native", icon: "" },
            { name: "Flutter", icon: "" },
          ],
        },
        {
          name: "Backend",
          icon: "",
          lenguages: [
            { name: "Node.js", icon: "" },
            { name: "Firebase", icon: "" },
          ],
        },
        {
          name: "Integrations",
          icon: "",
          lenguages: [
            { name: "Google Calendar API", icon: "" },
            { name: "Stripe", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about appointment app development.",
      questions: [
        {
          title: "Can the app support real-time availability updates?",
          description: "Yes, we implement dynamic slot management systems.",
        },
        {
          title: "Do you integrate payment gateways?",
          description: "Yes, we support secure payment integrations.",
        },
        {
          title: "Can reminders be automated?",
          description: "Yes, we enable push and email notification systems.",
        },
        {
          title: "Is calendar synchronization available?",
          description: "Yes, we integrate with popular calendar platforms.",
        },
        {
          title: "Do you provide post-launch support?",
          description:
            "Yes, we offer ongoing updates and optimization services.",
        },
      ],
    },
  },
  "booking-system-development": {
    banner: {
      breadcrumb: "Booking System Development",
      title: "Efficient Scheduling With",
      highlight: "Custom Booking Systems.",
      description:
        "We design and develop scalable booking systems that automate reservations, manage availability in real time, streamline payments, and deliver seamless scheduling experiences across web and mobile platforms.",
      cta: "Build Your Booking System",
      backgroundImage: require("../assets/images/booking-system-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Booking system development requires structured availability logic, secure transaction handling, and seamless integration with operational workflows. We collaborate with business stakeholders to understand reservation patterns, peak demand cycles, and customer behavior before designing scalable architecture. Our approach focuses on automated confirmations, calendar synchronization, role-based management, and performance optimization to ensure reliable scheduling operations while supporting long-term scalability and operational efficiency.",
      milestones: [
        { counts: 5, description: "Years of System Development Experience" },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        { counts: "Ongoing", description: "Optimization & Support Projects" },
      ],
    },

    endToEndServices: {
      title: "End-to-End Booking System Development",
      description:
        "Our booking system development services cover the complete lifecycle, from strategy and UX planning to backend engineering, payment integration, testing, deployment, and continuous improvement. We focus on building secure, user-friendly, and scalable reservation platforms that reduce manual coordination, increase operational visibility, and enhance customer satisfaction.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Business Analysis & Requirement Planning",
          icon: "StrategyIcon",
          description:
            "We analyze your booking workflow, resource management needs, and customer journey to define a scalable system architecture aligned with business objectives.",
          bullets: [
            {
              title: "Workflow Mapping",
              text: "Understanding reservation processes.",
            },
            {
              title: "Technical Planning",
              text: "Designing structured backend systems.",
            },
          ],
        },
        {
          title: "User Interface & Experience Design",
          icon: "DesignIcon",
          description:
            "We design intuitive booking interfaces that simplify slot selection, pricing display, and confirmation processes across devices.",
          bullets: [
            {
              title: "Responsive Design",
              text: "Optimized for mobile and desktop.",
            },
            {
              title: "User-Friendly Navigation",
              text: "Streamlining booking flows.",
            },
          ],
        },
        {
          title: "Core System Development",
          icon: "DevelopmentIcon",
          description:
            "Our developers implement secure user management, dynamic availability tracking, and automated confirmation systems to ensure smooth operations.",
          bullets: [
            {
              title: "Real-Time Slot Management",
              text: "Dynamic availability updates.",
            },
            {
              title: "Secure Authentication",
              text: "Role-based access control.",
            },
          ],
        },
        {
          title: "Payment & Integration Setup",
          icon: "IntegrationIcon",
          description:
            "We integrate secure payment gateways, CRM tools, and calendar systems while ensuring reliable data synchronization.",
          bullets: [
            {
              title: "Payment Gateway Integration",
              text: "Secure transaction handling.",
            },
            {
              title: "Calendar Synchronization",
              text: "Integration with external calendars.",
            },
          ],
        },
        {
          title: "Testing, Deployment & Optimization",
          icon: "LaunchIcon",
          description:
            "We conduct performance and security testing before deployment and provide ongoing enhancements to support scalability and reliability.",
          bullets: [
            {
              title: "Quality Assurance",
              text: "Ensuring stability and performance.",
            },
            {
              title: "Continuous Improvement",
              text: "Ongoing feature enhancements.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Automate Reservations And Improve Operational Efficiency",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your Booking Platform",
      title: "Our Booking System Development Process",
      description:
        "A structured workflow designed to deliver secure, scalable, and reliable reservation management systems.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description:
            "Understanding operational requirements and user expectations.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Designing system architecture and booking logic.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating intuitive reservation interfaces.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building scheduling and payment functionalities.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Validating security, performance, and usability.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Support",
          description: "Deploying and optimizing the system.",
        },
      ],
    },

    customIndustries: {
      title: "Booking Solutions Across Industries",
      description:
        "We develop booking systems tailored to diverse industries and service-based operations.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "Booking systems designed to enhance efficiency, reduce manual errors, and improve customer satisfaction.",
      slides: [
        {
          title: "Operational Efficiency",
          subTitle: "Automated Scheduling",
          description:
            "Reducing administrative workload through system automation.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Calendar APIs", image: "" }],
        },
        {
          title: "Increased Revenue",
          subTitle: "Optimized Reservation Flow",
          description:
            "Simplified booking experiences increase conversion rates.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Secure Payment Gateways", image: "" }],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We deliver booking system development with strong technical expertise and scalable design practices.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Workflow Expertise",
          text: "Designing structured and efficient reservation systems.",
        },
        {
          title: "Security First",
          text: "Ensuring safe data handling and transactions.",
        },
        {
          title: "Performance Optimized",
          text: "Maintaining fast and reliable scheduling operations.",
        },
        {
          title: "Long-Term Support",
          text: "Providing continuous updates and improvements.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Businesses rely on us to automate reservations and improve service efficiency.",
      clientTestimonails: [
        {
          description:
            "The booking system streamlined our operations and significantly reduced scheduling errors.",
          name: "Amit R.",
          position: "Operations Director",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern frameworks and tools used to build secure and scalable booking platforms.",
      techList: [
        {
          name: "Frontend",
          icon: "",
          lenguages: [
            { name: "React", icon: "" },
            { name: "Next.js", icon: "" },
          ],
        },
        {
          name: "Backend",
          icon: "",
          lenguages: [
            { name: "Node.js", icon: "" },
            { name: "PHP", icon: "" },
          ],
        },
        {
          name: "Integrations",
          icon: "",
          lenguages: [
            { name: "Stripe", icon: "" },
            { name: "Google Calendar API", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about booking system development.",
      questions: [
        {
          title: "Can the system manage real-time availability?",
          description: "Yes, we implement dynamic slot management.",
        },
        {
          title: "Do you integrate secure payment gateways?",
          description: "Yes, we support trusted payment providers.",
        },
        {
          title: "Is calendar synchronization supported?",
          description: "Yes, we integrate with external calendar systems.",
        },
        {
          title: "Can the platform scale with growing demand?",
          description: "Yes, we design scalable architectures for expansion.",
        },
        {
          title: "Do you provide ongoing support?",
          description:
            "Yes, we offer continuous maintenance and optimization services.",
        },
      ],
    },
  },
  "on-demand-delivery-app-development": {
    banner: {
      breadcrumb: "On-Demand Delivery App Development",
      title: "Real-Time Logistics Powered By",
      highlight: "On-Demand Technology.",
      description:
        "We design and develop scalable on-demand delivery applications that enable real-time order tracking, seamless vendor coordination, secure payments, and efficient logistics management across mobile and web platforms.",
      cta: "Build Your Delivery App",
      backgroundImage: require("../assets/images/on-demand-delivery-app-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "On-demand delivery platforms require precise coordination between customers, vendors, and delivery partners. We collaborate closely with business stakeholders to understand operational workflows, dispatch logic, and real-time tracking requirements before designing scalable system architecture. Our approach focuses on GPS integration, automated order management, secure transactions, and performance optimization to ensure reliable delivery operations while supporting business growth and user satisfaction.",
      milestones: [
        { counts: 5, description: "Years of App Development Expertise" },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        { counts: "Ongoing", description: "Platform Optimization Projects" },
      ],
    },

    endToEndServices: {
      title: "End-to-End On-Demand Delivery App Development",
      description:
        "Our on-demand delivery app development services cover the entire product lifecycle, from business strategy and UX design to backend engineering, payment integration, GPS tracking, testing, deployment, and continuous enhancement. We focus on building secure, scalable, and high-performing delivery platforms that streamline operations and provide real-time visibility across the entire order journey.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Business Analysis & Dispatch Planning",
          icon: "StrategyIcon",
          description:
            "We analyze delivery workflows, vendor operations, and dispatch requirements to design a scalable system architecture aligned with your business objectives.",
          bullets: [
            {
              title: "Workflow Mapping",
              text: "Defining order and delivery processes.",
            },
            {
              title: "Technical Blueprint",
              text: "Designing scalable backend systems.",
            },
          ],
        },
        {
          title: "User & Driver Interface Design",
          icon: "DesignIcon",
          description:
            "We create intuitive interfaces for customers, vendors, and delivery partners to ensure smooth order placement, tracking, and fulfillment.",
          bullets: [
            {
              title: "Customer Experience",
              text: "Simplified ordering and checkout.",
            },
            {
              title: "Driver Dashboard",
              text: "Real-time route and order updates.",
            },
          ],
        },
        {
          title: "Core App Development",
          icon: "DevelopmentIcon",
          description:
            "Our developers build secure and scalable delivery applications with structured code, efficient order management, and GPS-based tracking.",
          bullets: [
            { title: "Real-Time Tracking", text: "Live location monitoring." },
            { title: "Secure Payments", text: "Integrated payment gateways." },
          ],
        },
        {
          title: "Integration & Quality Assurance",
          icon: "TestingIcon",
          description:
            "We integrate payment systems, analytics tools, and notification services while conducting performance and security testing.",
          bullets: [
            { title: "Push Notifications", text: "Automated order updates." },
            {
              title: "Comprehensive Testing",
              text: "Ensuring platform stability.",
            },
          ],
        },
        {
          title: "Deployment & Ongoing Optimization",
          icon: "LaunchIcon",
          description:
            "We manage deployment across app stores and provide continuous monitoring, analytics integration, and feature enhancements.",
          bullets: [
            {
              title: "App Store Publishing",
              text: "Handling compliance and submissions.",
            },
            {
              title: "Continuous Improvements",
              text: "Optimizing speed and scalability.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Deliver Faster And Improve Customer Satisfaction",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your Delivery Platform",
      title: "Our On-Demand App Development Process",
      description:
        "A structured workflow designed to deliver scalable, secure, and high-performing on-demand delivery solutions.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description: "Understanding delivery workflows and business goals.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Designing dispatch logic and architecture.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating intuitive user and driver interfaces.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building tracking, payment, and order features.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Ensuring reliability, security, and performance.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Support",
          description: "Deploying and optimizing the platform.",
        },
      ],
    },

    customIndustries: {
      title: "On-Demand Solutions Across Industries",
      description:
        "We develop delivery platforms tailored to various industries and logistics models.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "On-demand delivery applications designed to improve operational efficiency and enhance customer experience.",
      slides: [
        {
          title: "Improved Operational Efficiency",
          subTitle: "Automated Dispatch",
          description:
            "Optimized delivery assignments reduce delays and errors.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "GPS & Mapping APIs", image: "" }],
        },
        {
          title: "Enhanced Customer Experience",
          subTitle: "Real-Time Tracking",
          description: "Live updates increase transparency and user trust.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [
            { title: "Push Notification Services", image: "" },
          ],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We combine logistics understanding with scalable engineering practices to deliver reliable on-demand delivery platforms.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Logistics Expertise",
          text: "Designing efficient dispatch and tracking systems.",
        },
        {
          title: "Security Focused",
          text: "Ensuring safe transactions and data handling.",
        },
        {
          title: "Performance Optimized",
          text: "Maintaining fast and reliable operations.",
        },
        {
          title: "Long-Term Support",
          text: "Providing continuous updates and enhancements.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Businesses trust us to build scalable and reliable on-demand delivery platforms.",
      clientTestimonails: [
        {
          description:
            "The delivery app improved our operational efficiency and significantly enhanced customer satisfaction.",
          name: "Kunal S.",
          position: "Operations Head",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern frameworks and tools used to build scalable on-demand delivery applications.",
      techList: [
        {
          name: "Mobile Frameworks",
          icon: "",
          lenguages: [
            { name: "React Native", icon: "" },
            { name: "Flutter", icon: "" },
          ],
        },
        {
          name: "Backend",
          icon: "",
          lenguages: [
            { name: "Node.js", icon: "" },
            { name: "Firebase", icon: "" },
          ],
        },
        {
          name: "Integrations",
          icon: "",
          lenguages: [
            { name: "Google Maps API", icon: "" },
            { name: "Stripe", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about on-demand delivery app development.",
      questions: [
        {
          title: "Can the app support real-time tracking?",
          description: "Yes, we integrate GPS tracking for live updates.",
        },
        {
          title: "Do you provide driver and admin panels?",
          description:
            "Yes, we develop multi-role dashboards for complete management.",
        },
        {
          title: "Are secure payment options available?",
          description: "Yes, we integrate trusted and secure payment gateways.",
        },
        {
          title: "Can the platform scale with growing demand?",
          description: "Yes, we design scalable cloud-based architectures.",
        },
        {
          title: "Do you offer post-launch support?",
          description: "Yes, we provide ongoing maintenance and optimization.",
        },
      ],
    },
  },
  "home-service-app-development": {
    banner: {
      breadcrumb: "Home Service App Development",
      title: "Connect Customers With",
      highlight: "Reliable Home Services.",
      description:
        "We design and develop scalable home service applications that connect customers with trusted professionals, enable real-time booking, manage service requests efficiently, and streamline payments across mobile and web platforms.",
      cta: "Build Your Home Service App",
      backgroundImage: require("../assets/images/home-service-app-development.webp"),
    },

    whyPartenrChoose: {
      title: "A Partner You Can Rely On",
      description:
        "Home service platforms require seamless coordination between customers, service providers, and administrators. We work closely with stakeholders to understand service categories, booking workflows, pricing structures, and operational challenges before designing a scalable system architecture. Our development approach focuses on real-time scheduling, secure payments, provider management dashboards, and performance optimization to ensure smooth operations while supporting long-term business growth and customer satisfaction.",
      milestones: [
        { counts: 5, description: "Years of On-Demand Expertise" },
        {
          counts: 100,
          description: "On Time Delivery",
        },
        { counts: "Ongoing", description: "Enhancement & Support Engagements" },
      ],
    },

    endToEndServices: {
      title: "End-to-End Home Service App Development",
      description:
        "Our home service app development services cover the complete product lifecycle, from strategy and interface design to backend development, provider onboarding, payment integration, testing, deployment, and continuous optimization. We build secure and scalable solutions that simplify service booking, improve provider coordination, and enhance customer experience.",
      image: require("../assets/images/end1.webp"),
      setps: [
        {
          title: "Business Analysis & Workflow Planning",
          icon: "StrategyIcon",
          description:
            "We analyze your service model, pricing structure, and operational flow to design a scalable and efficient home service platform aligned with business goals.",
          bullets: [
            {
              title: "Requirement Mapping",
              text: "Defining service categories and features.",
            },
            {
              title: "Technical Architecture",
              text: "Designing scalable backend systems.",
            },
          ],
        },
        {
          title: "Customer & Provider UI/UX Design",
          icon: "DesignIcon",
          description:
            "We create intuitive interfaces for customers and service professionals, ensuring smooth booking, request management, and communication.",
          bullets: [
            {
              title: "User-Friendly Booking",
              text: "Simplified scheduling process.",
            },
            {
              title: "Provider Dashboard",
              text: "Efficient job management tools.",
            },
          ],
        },
        {
          title: "Core App Development",
          icon: "DevelopmentIcon",
          description:
            "Our developers build secure and scalable applications with structured code, role-based access, and real-time updates for service tracking.",
          bullets: [
            {
              title: "Real-Time Notifications",
              text: "Instant updates for bookings and status.",
            },
            {
              title: "Secure Payments",
              text: "Integrated and trusted gateways.",
            },
          ],
        },
        {
          title: "Integration & Quality Assurance",
          icon: "TestingIcon",
          description:
            "We integrate payment systems, analytics tools, and communication APIs while performing thorough testing to ensure stability and security.",
          bullets: [
            {
              title: "API Integration",
              text: "Seamless backend connectivity.",
            },
            {
              title: "Comprehensive QA",
              text: "Validating performance and usability.",
            },
          ],
        },
        {
          title: "Deployment & Ongoing Optimization",
          icon: "LaunchIcon",
          description:
            "We manage deployment across platforms and provide continuous monitoring, feature updates, and performance enhancements.",
          bullets: [
            {
              title: "Store Deployment",
              text: "Handling publishing and compliance.",
            },
            {
              title: "Continuous Improvement",
              text: "Optimizing speed and scalability.",
            },
          ],
        },
      ],
    },

    transformYourBussiness: {
      title: "Streamline Service Operations And Enhance Customer Trust",
      image: require("../assets/images/ser_oval.webp"),
    },

    developmentProcessSteps: {
      cta: "Let’s Build Your Home Service Platform",
      title: "Our Home Service App Development Process",
      description:
        "A structured workflow designed to deliver scalable, secure, and high-performing home service solutions.",
      setps: [
        {
          stepNumberImage: "",
          title: "Discovery",
          description: "Understanding service workflows and user needs.",
        },
        {
          stepNumberImage: "",
          title: "Planning",
          description: "Designing system architecture and role management.",
        },
        {
          stepNumberImage: "",
          title: "Design",
          description: "Creating intuitive customer and provider interfaces.",
        },
        {
          stepNumberImage: "",
          title: "Development",
          description: "Building booking, tracking, and payment features.",
        },
        {
          stepNumberImage: "",
          title: "Testing",
          description: "Ensuring reliability, performance, and security.",
        },
        {
          stepNumberImage: "",
          title: "Launch & Support",
          description: "Deploying and continuously improving the platform.",
        },
      ],
    },

    customIndustries: {
      title: "Home Service Solutions Across Categories",
      description:
        "We develop home service applications tailored to diverse service sectors and operational models.",
      industries: [
        {
          title: "Education",
          image: require("../assets/images/eduction_ic.webp"),
        },
        {
          title: "Transportation",
          image: require("../assets/images/transportation_ic.webp"),
        },
        {
          title: "Real Estate",
          image: require("../assets/images/real_estate_ic.webp"),
        },
        {
          title: "Healthcare",
          image: require("../assets/images/healthcare_ic.webp"),
        },
        {
          title: "E-Commerce",
          image: require("../assets/images/e-commerce_ic.webp"),
        },
        {
          title: "Ads & Marketing",
          image: require("../assets/images/ads_marketing.webp"),
        },
        { title: "Dating", image: require("../assets/images/dating_ic.webp") },
        {
          title: "Media & Entertainment",
          image: require("../assets/images/media_entertainment_ic.webp"),
        },
      ],
    },

    serviceImpacts: {
      title: "Business Impact",
      description:
        "Home service applications designed to improve operational efficiency and customer engagement.",
      slides: [
        {
          title: "Improved Service Efficiency",
          subTitle: "Automated Scheduling",
          description:
            "Streamlined booking reduces manual coordination and delays.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [{ title: "Scheduling APIs", image: "" }],
        },
        {
          title: "Higher Customer Retention",
          subTitle: "Reliable Experience",
          description:
            "Real-time updates and smooth communication enhance trust.",
          image: require("../assets/images/ser_mobile.webp"),
          technologiesUsed: [
            { title: "Push Notification Services", image: "" },
          ],
        },
      ],
    },

    whyChooseUs: {
      title: "Why Choose Us",
      description:
        "We combine operational understanding with scalable engineering to deliver reliable home service platforms.",
      image: require("../assets/images/ser_why.webp"),
      steps: [
        {
          title: "Service Workflow Expertise",
          text: "Designing structured and efficient service management systems.",
        },
        {
          title: "Security Focused",
          text: "Ensuring safe data handling and transactions.",
        },
        {
          title: "Performance Optimized",
          text: "Maintaining fast and reliable application behavior.",
        },
        {
          title: "Long-Term Support",
          text: "Providing continuous updates and enhancements.",
        },
      ],
    },

    serviceTestimonials: {
      title: "Client Feedback",
      description:
        "Businesses trust us to build scalable and reliable home service platforms.",
      clientTestimonails: [
        {
          description:
            "The home service app improved coordination between customers and professionals, significantly boosting our efficiency.",
          name: "Rohit V.",
          position: "Operations Manager",
        },
      ],
    },

    techStacks: {
      title: "Technologies We Use",
      description:
        "Modern frameworks and tools used to build secure and scalable home service applications.",
      techList: [
        {
          name: "Mobile Frameworks",
          icon: "",
          lenguages: [
            { name: "React Native", icon: "" },
            { name: "Flutter", icon: "" },
          ],
        },
        {
          name: "Backend",
          icon: "",
          lenguages: [
            { name: "Node.js", icon: "" },
            { name: "Firebase", icon: "" },
          ],
        },
        {
          name: "Integrations",
          icon: "",
          lenguages: [
            { name: "Stripe", icon: "" },
            { name: "Google Maps API", icon: "" },
          ],
        },
      ],
    },

    faqs: {
      title: "FAQs",
      description: "Common questions about home service app development.",
      questions: [
        {
          title: "Can the app support multiple service categories?",
          description:
            "Yes, we build flexible systems supporting various services.",
        },
        {
          title: "Do you provide provider management dashboards?",
          description: "Yes, we develop admin and provider panels.",
        },
        {
          title: "Is secure payment integration available?",
          description: "Yes, we integrate trusted and secure payment gateways.",
        },
        {
          title: "Can customers track service status in real time?",
          description: "Yes, we implement live tracking and notifications.",
        },
        {
          title: "Do you offer post-launch support?",
          description:
            "Yes, we provide continuous maintenance and optimization services.",
        },
      ],
    },
  },
};

export const headerServiceDetailsLinks = {
  mobile_app_development: {
    title: "Mobile App Development",
    links: [
      {
        link: "iOS App Development",
        slug: "ios-app-development",
      },
      {
        link: "Android App Development",
        slug: "android-app-development",
      },
      {
        link: "Cross-Platform App Development",
        slug: "cross-platform-app-development",
      },
      {
        link: "React Native App Development",
        slug: "react-native-app-development",
      },
      {
        link: "Flutter App Development",
        slug: "flutter-app-development",
      },
      {
        link: "Ionic App Development",
        slug: "ionic-app-development",
      },
      {
        link: "Progressive Web App (PWA) Development",
        slug: "progressive-web-app-development",
      },
      {
        link: "Wearable App Development",
        slug: "wearable-app-development",
      },
    ],
  },
  eCommerce_development: {
    title: "eCommerce Development",
    links: [
      {
        link: "eCommerce Website Development",
        slug: "ecommerce-website-development",
      },
      {
        link: "eCommerce App Development",
        slug: "ecommerce-app-development",
      },
      {
        link: "Magento eCommerce Development",
        slug: "magento-ecommerce-development",
      },
      {
        link: "Shopify Development Services",
        slug: "shopify-development-services",
      },
    ],
  },
  on_demand_app_development: {
    title: "On-Demand App Development",
    links: [
      {
        link: "Appointment App Development",
        slug: "appointment-app-development",
      },
      {
        link: "Booking System Development",
        slug: "booking-system-development",
      },
      {
        link: "On-Demand Delivery App Development",
        slug: "on-demand-delivery-app-development",
      },
      {
        link: "Home Service Development",
        slug: "home-service-app-development",
      },
    ],
  },
  digital_marketing: {
    title: "Digital Marketing",
    links: [
      {
        link: "Search Engine Optimization (SEO)",
        slug: "search-engine-optimization-seo",
      },
      {
        link: "Pay Per Click (PPC)",
        slug: "digital-marketing-ppc",
      },
      {
        link: "Online Reputation Management (ORM)",
        slug: "digital-marketing-orm",
      },
      {
        link: "Social Media Optimization (SMO)",
        slug: "digital-marketing-smo",
      },
      {
        link: "Social Media Marketing (SMM)",
        slug: "digital-marketing-smm",
      },
    ],
  },
  cloud_engineering: {
    title: "Cloud Engineering",
    links: [
      {
        link: "DevOps Consulting",
        slug: "devops-consulting",
      },
      {
        link: "CI/CD Pipeline Development",
        slug: "ci-cd-pipeline-development",
      },
      {
        link: "Infrastructure as Code (IaC)",
        slug: "infrastructure-as-code-iac",
      },
      {
        link: "Cloud Migration & Management",
        slug: "cloud-migration-management",
      },
      {
        link: "Containerization & Orchestration",
        slug: "containerization-orchestration",
      },
      {
        link: "Microservices Architecture Setup",
        slug: "microservices-architecture-setup",
      },
      {
        link: "Site Reliability Engineering (SRE)",
        slug: "site-reliability-engineering-sre",
      },
    ],
  },
  product_engineering: {
    title: "Product Engineering",
    links: [
      {
        link: "MVP Development",
        slug: "mvp-development",
      },
      {
        link: "Product Design & Prototyping",
        slug: "product-design-prototyping",
      },
      {
        link: "Full-Scale Product Development",
        slug: "full-scale-product-development",
      },
      {
        link: "Product Modernization & Optimization",
        slug: "product-modernization-optimization",
      },
      {
        link: "Product Testing & QA",
        slug: "product-testing-qa",
      },
    ],
  },
  staff_augmentation: {
    title: "Staff Augmentation",
    links: [
      {
        link: "IT Staffing Solutions",
        slug: "it-staffing-solutions",
      },
      {
        link: "On-Demand Expertise",
        slug: "on-demand-expertise",
      },
      {
        link: "Skills Gap Analysis",
        slug: "skills-gap-analysis",
      },
      {
        link: "Project-Based Augmentation",
        slug: "project-based-augmentation",
      },
      {
        link: "Team Expansion",
        slug: "team-expansion",
      },
    ],
  },
};

export const EngineeringData = [
  {
    id: 1,
    icon: Finance,
    title: "Finance/Banking",
    image: imagePath.Engimg,
    subtitle: "Banking-Financial Services and Insurance",
    description:
      "We deliver secure, intelligent, and scalable solutions for banks, financial institutions, and insurance companies. Our platforms combine cutting-edge technology, robust security, and seamless user experiences to streamline operations, enhance customer engagement, and enable data-driven decision-making.",
    highlights: [
      "Financial Software Development Services",
      "Account and Cashflow Management",
      "Investment and Portfolio Management",
      "Budgeting and Forecasting",
      "Tax Management",
      "Insurance Management",
    ],
  },
  {
    id: 2,
    icon: HealthcareIcon,
    title: "Healthcare",
    image: imagePath.health_care,
    subtitle: "",
    description:
      "We create innovative and secure healthcare solutions that empower users to manage wellness, track health goals, and access essential medical services with ease. From fitness and lifestyle applications to advanced digital health platforms, we combine smart technology, seamless user experiences, and reliable data handling to build scalable systems that support better health outcomes, stronger engagement, and long-term well-being.",
    highlights: [
      "Custom Healthcare Software Development",
      "Healthcare App Development",
      "Doctor Appointment App Development",
      "Fitness App Development Company",
    ],
  },
  {
    id: 3,
    icon: Education,
    title: "Education",
    image: imagePath.education,
    subtitle: "",
    description:
      "We develop innovative and engaging education solutions that make learning accessible, interactive, and effective. From feature-rich education apps to comprehensive eLearning software, we combine modern technology, intuitive design, and scalable architecture to create platforms that enhance student engagement, streamline administration, and support lifelong learning.",
    highlights: ["Education App Development", "eLearning Software Development"],
  },
  {
    id: 4,
    icon: Logistics,
    title: "Logistics",
    image: imagePath.logistics,
    subtitle: "",
    description:
      "We deliver logistics technology solutions that help businesses optimize operations, enhance delivery accuracy, and achieve end-to-end supply chain visibility. We combine smart automation, real-time tracking, and robust data intelligence to build scalable systems that improve efficiency, reduce operational costs, and ensure seamless movement of goods from source to destination.",
    highlights: [
      "Logistics App Development",
      "Logistics Software Development",
      "Supply Chain Software Development",
      "Inventory Management",
      "Fleet Management",
    ],
  },
  {
    id: 5,
    icon: OnDemand,
    title: "On-demand",
    image: imagePath.on_demand,
    subtitle: "",
    description:
      "We develop high-performance on-demand solutions that connect users with services in real time. From booking and delivery to live streaming and appointments, we combine intuitive design, secure technology, and scalable architecture to create platforms that enhance user convenience, improve operational efficiency, and drive long-term business growth.",
    highlights: [
      "Taxi App Development",
      "Food and Grocery Delivery App Development",
      "Live Streaming App Development",
      "Car Wash App Development",
      "Beauty Salon App Development",
      "Restaurant App Development",
      "Hotel Booking App Development",
    ],
  },
  {
    id: 6,
    icon: TravelHospitality,
    title: "Travel",
    image: imagePath.travel,
    subtitle: "",
    description:
      "We build innovative travel and hospitality solutions that deliver seamless booking experiences, real-time updates, and personalized journeys for users. From travel apps to hotel management platforms, we combine modern technology, intuitive design, and scalable systems to enhance customer engagement, streamline operations, and drive long-term growth in the travel and hospitality sector.",
    highlights: ["Travel App Development", "Hotel App Development"],
  },
  {
    id: 7,
    icon: RealEstate,
    title: "Real Estate",
    image: imagePath.real_estate,
    subtitle: "",
    description:
      "We develop innovative real estate solutions that simplify property management, streamline transactions, and enhance user engagement. From property search and listing platforms to agent and management apps, we combine modern design, secure technology, and seamless functionality to deliver scalable solutions that empower buyers, sellers, and agents alike.",
    highlights: [
      "Real Estate Agent Apps",
      "Property Listing and Search Apps",
      "Property Management Apps",
    ],
  },
  {
    id: 8,
    icon: EcommerceSlider,
    title: "eCommerce",
    image: imagePath.ecommerce,
    subtitle: "",
    description:
      "We build robust, scalable, and user-friendly eCommerce solutions that drive sales and enhance customer engagement. By combining modern design, secure technology, and optimized performance, we create web and mobile stores that deliver seamless shopping experiences, streamline operations, and support long-term business growth.",
    highlights: [
      "eCommerce Website Development",
      "eCommerce App Development",
      "Magento eCommerce Development",
      "Shopify Development Services",
    ],
  },

  {
    id: 9,
    icon: MediaEntertainment2,
    title: "Media & Entertainment",
    image: imagePath.media_entertainment,
    subtitle: "",
    description:
      "We deliver innovative media and entertainment solutions that engage audiences, drive user interaction, and enhance content delivery across platforms. From social media apps and music streaming to video-on-demand and OTT platforms, we combine modern design, scalable technology, and seamless performance to build apps that entertain, inspire, and keep users coming back.",
    highlights: [
      "Social Media App Development",
      "Video Streaming App Development",
      "Roku TV App Development",
      "Smart TV App Development",
      "Music Streaming App Development",
      "Entertainment App Development",
      "OTT App Development",
    ],
  },

  {
    id: 10,
    icon: Government,
    title: "Government",
    image: imagePath.government,
    subtitle: "",
    description:
      "We develop intelligent, secure, and scalable solutions for government organizations to enhance efficiency, transparency, and decision-making. From ERP systems to predictive planning tools, our platforms leverage modern technology, data-driven insights, and seamless workflows to optimize operations, improve citizen services, and drive sustainable growth in the public sector.",
    highlights: [
      "ERP Software Development",
      "Intelligent Asset Management",
      "Smart Procurement & Contracts Management",
      "Supplier Management Software Development",
      "Predictive Budgeting & Planning",
      "Capital Planning Software Development",
    ],
  },
  {
    id: 11,
    icon: Automotive,
    title: "Automotive (Auto-Mobile)",
    image: imagePath.automotive,
    subtitle: "",
    description:
      "We deliver innovative and scalable automotive solutions that drive efficiency, connectivity, and enhanced user experiences. From vehicle management systems to connected car applications, we combine cutting-edge technology, real-time data, and intuitive design to create platforms that optimize operations, improve customer engagement, and support growth in the automotive industry.",
    highlights: [
      "Vehicle Tracking & Telematics Systems",
      "EV & Charging Station Management Apps",
      "Automotive IoT Integrations",
      "Automobile Sales & Dealership Platforms",
      "Fleet Management Solutions",
      "Connected Vehicle App Development",
    ],
  },

  {
    id: 12,
    icon: Fintech,
    title: "Fintech",
    image: imagePath.fintech,
    subtitle: "",
    description:
      "We craft secure, intelligent, and high-performance financial technology solutions that empower businesses and users to manage money, investments, and payments with ease. From digital wallets to investment platforms and payment gateways, our solutions combine cutting-edge technology, seamless experiences, and robust analytics to drive efficiency, compliance, and growth in the fast-evolving financial sector.",
    highlights: [
      "Digital Banking & Wallet Solutions",
      "Payment Gateway Integration",
      "Investment & Portfolio Management Platforms",
      "Loan & Credit Management Systems",
      "Risk & Compliance Solutions",
      "Trading & Wealth Management Applications",
    ],
  },

  {
    id: 13,
    icon: Sports,
    title: "Sports",
    image: imagePath.sports,
    subtitle: "",
    description:
      "We develop dynamic, engaging, and high-performance sports solutions that connect athletes, fans, and organizations. From fitness tracking apps to event management platforms and fan engagement tools, our solutions combine real-time data, intuitive design, and seamless performance to enhance participation, improve performance tracking, and deliver immersive experiences across the sports ecosystem.",
    highlights: [
      "Fitness & Training App Development",
      "Sports Event Management Platforms",
      "Fan Engagement & Ticketing Apps",
      "Fleet Management Solutions",
      "Fantasy Sports & Gaming Platforms",
      "Wearable Sports Device Integrations",
    ],
  },
];

export type HeaderServiceKey = keyof typeof headerServiceDetailsLinks;
